/*!
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /* globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
            return factory( window, jQuery );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('jquery')
        );
    } else {
        // browser global
        window.jQueryBridget = factory(
            window,
            window.jQuery
        );
    }

}( window, function factory( window, jQuery ) {
    'use strict';

// ----- utils ----- //

    var arraySlice = Array.prototype.slice;

// helper function for logging errors
// $.error breaks jQuery chaining
    var console = window.console;
    var logError = typeof console == 'undefined' ? function() {} :
        function( message ) {
            console.error( message );
        };

// ----- jQueryBridget ----- //

    function jQueryBridget( namespace, PluginClass, $ ) {
        $ = $ || jQuery || window.jQuery;
        if ( !$ ) {
            return;
        }

        // add option method -> $().plugin('option', {...})
        if ( !PluginClass.prototype.option ) {
            // option setter
            PluginClass.prototype.option = function( opts ) {
                // bail out if not an object
                if ( !$.isPlainObject( opts ) ){
                    return;
                }
                this.options = $.extend( true, this.options, opts );
            };
        }

        // make jQuery plugin
        $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
            if ( typeof arg0 == 'string' ) {
                // method call $().plugin( 'methodName', { options } )
                // shift arguments by 1
                var args = arraySlice.call( arguments, 1 );
                return methodCall( this, arg0, args );
            }
            // just $().plugin({ options })
            plainCall( this, arg0 );
            return this;
        };

        // $().plugin('methodName')
        function methodCall( $elems, methodName, args ) {
            var returnValue;
            var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

            $elems.each( function( i, elem ) {
                // get instance
                var instance = $.data( elem, namespace );
                if ( !instance ) {
                    logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
                        pluginMethodStr );
                    return;
                }

                var method = instance[ methodName ];
                if ( !method || methodName.charAt(0) == '_' ) {
                    logError( pluginMethodStr + ' is not a valid method' );
                    return;
                }

                // apply method, get return value
                var value = method.apply( instance, args );
                // set return value if value is returned, use only first value
                returnValue = returnValue === undefined ? value : returnValue;
            });

            return returnValue !== undefined ? returnValue : $elems;
        }

        function plainCall( $elems, options ) {
            $elems.each( function( i, elem ) {
                var instance = $.data( elem, namespace );
                if ( instance ) {
                    // set options & init
                    instance.option( options );
                    instance._init();
                } else {
                    // initialize new instance
                    instance = new PluginClass( elem, options );
                    $.data( elem, namespace, instance );
                }
            });
        }

        updateJQuery( $ );

    }

// ----- updateJQuery ----- //

// set $.bridget for v1 backwards compatibility
    function updateJQuery( $ ) {
        if ( !$ || ( $ && $.bridget ) ) {
            return;
        }
        $.bridget = jQueryBridget;
    }

    updateJQuery( jQuery || window.jQuery );

// -----  ----- //

    return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */
    if ( typeof define == 'function' && define.amd ) {
        // AMD - RequireJS
        define( 'ev-emitter/ev-emitter',factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS - Browserify, Webpack
        module.exports = factory();
    } else {
        // Browser globals
        global.EvEmitter = factory();
    }

}( typeof window != 'undefined' ? window : this, function() {



    function EvEmitter() {}

    var proto = EvEmitter.prototype;

    proto.on = function( eventName, listener ) {
        if ( !eventName || !listener ) {
            return;
        }
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[ eventName ] = events[ eventName ] || [];
        // only add once
        if ( listeners.indexOf( listener ) == -1 ) {
            listeners.push( listener );
        }

        return this;
    };

    proto.once = function( eventName, listener ) {
        if ( !eventName || !listener ) {
            return;
        }
        // add event
        this.on( eventName, listener );
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
        // set flag
        onceListeners[ listener ] = true;

        return this;
    };

    proto.off = function( eventName, listener ) {
        var listeners = this._events && this._events[ eventName ];
        if ( !listeners || !listeners.length ) {
            return;
        }
        var index = listeners.indexOf( listener );
        if ( index != -1 ) {
            listeners.splice( index, 1 );
        }

        return this;
    };

    proto.emitEvent = function( eventName, args ) {
        var listeners = this._events && this._events[ eventName ];
        if ( !listeners || !listeners.length ) {
            return;
        }
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

        for ( var i=0; i < listeners.length; i++ ) {
            var listener = listeners[i]
            var isOnce = onceListeners && onceListeners[ listener ];
            if ( isOnce ) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off( eventName, listener );
                // unset once flag
                delete onceListeners[ listener ];
            }
            // trigger listener
            listener.apply( this, args );
        }

        return this;
    };

    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };

    return EvEmitter;

}));

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
    /* jshint strict: false */ /* globals define, module */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'get-size/get-size',factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.getSize = factory();
    }

})( window, function factory() {
    'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
    function getStyleSize( value ) {
        var num = parseFloat( value );
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN( num );
        return isValid && num;
    }

    function noop() {}

    var logError = typeof console == 'undefined' ? noop :
        function( message ) {
            console.error( message );
        };

// -------------------------- measurements -------------------------- //

    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];

    var measurementsLength = measurements.length;

    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for ( var i=0; i < measurementsLength; i++ ) {
            var measurement = measurements[i];
            size[ measurement ] = 0;
        }
        return size;
    }

// -------------------------- getStyle -------------------------- //

    /**
     * getStyle, get style of element, check for Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
     */
    function getStyle( elem ) {
        var style = getComputedStyle( elem );
        if ( !style ) {
            logError( 'Style returned ' + style +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1' );
        }
        return style;
    }

// -------------------------- setup -------------------------- //

    var isSetup = false;

    var isBoxSizeOuter;

    /**
     * setup
     * check isBoxSizerOuter
     * do on first getSize() rather than on page load for Firefox bug
     */
    function setup() {
        // setup once
        if ( isSetup ) {
            return;
        }
        isSetup = true;

        // -------------------------- box sizing -------------------------- //

        /**
         * Chrome & Safari measure the outer-width on style.width on border-box elems
         * IE11 & Firefox<29 measures the inner-width
         */
        var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';

        var body = document.body || document.documentElement;
        body.appendChild( div );
        var style = getStyle( div );
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;

        body.removeChild( div );
    }

// -------------------------- getSize -------------------------- //

    function getSize( elem ) {
        setup();

        // use querySeletor if elem is string
        if ( typeof elem == 'string' ) {
            elem = document.querySelector( elem );
        }

        // do not proceed on non-objects
        if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
            return;
        }

        var style = getStyle( elem );

        // if hidden, everything is 0
        if ( style.display == 'none' ) {
            return getZeroSize();
        }

        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;

        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

        // get all measurements
        for ( var i=0; i < measurementsLength; i++ ) {
            var measurement = measurements[i];
            var value = style[ measurement ];
            var num = parseFloat( value );
            // any 'auto', 'medium' value will be 0
            size[ measurement ] = !isNaN( num ) ? num : 0;
        }

        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;

        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize( style.width );
        if ( styleWidth !== false ) {
            size.width = styleWidth +
                // add padding and border unless it's already including it
                ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
        }

        var styleHeight = getStyleSize( style.height );
        if ( styleHeight !== false ) {
            size.height = styleHeight +
                // add padding and border unless it's already including it
                ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
        }

        size.innerWidth = size.width - ( paddingWidth + borderWidth );
        size.innerHeight = size.height - ( paddingHeight + borderHeight );

        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;

        return size;
    }

    return getSize;

});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
    /*global define: false, module: false */
    'use strict';
    // universal module definition
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'desandro-matches-selector/matches-selector',factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.matchesSelector = factory();
    }

}( window, function factory() {
    'use strict';

    var matchesMethod = ( function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if ( ElemProto.matches ) {
            return 'matches';
        }
        // check un-prefixed
        if ( ElemProto.matchesSelector ) {
            return 'matchesSelector';
        }
        // check vendor prefixes
        var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

        for ( var i=0; i < prefixes.length; i++ ) {
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if ( ElemProto[ method ] ) {
                return method;
            }
        }
    })();

    return function matchesSelector( elem, selector ) {
        return elem[ matchesMethod ]( selector );
    };

}));

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */

    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'fizzy-ui-utils/utils',[
            'desandro-matches-selector/matches-selector'
        ], function( matchesSelector ) {
            return factory( window, matchesSelector );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('desandro-matches-selector')
        );
    } else {
        // browser global
        window.fizzyUIUtils = factory(
            window,
            window.matchesSelector
        );
    }

}( window, function factory( window, matchesSelector ) {



    var utils = {};

// ----- extend ----- //

// extends objects
    utils.extend = function( a, b ) {
        for ( var prop in b ) {
            a[ prop ] = b[ prop ];
        }
        return a;
    };

// ----- modulo ----- //

    utils.modulo = function( num, div ) {
        return ( ( num % div ) + div ) % div;
    };

// ----- makeArray ----- //

    var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
    utils.makeArray = function( obj ) {
        if ( Array.isArray( obj ) ) {
            // use object if already an array
            return obj;
        }
        // return empty array if undefined or null. #6
        if ( obj === null || obj === undefined ) {
            return [];
        }

        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if ( isArrayLike ) {
            // convert nodeList to array
            return arraySlice.call( obj );
        }

        // array of single index
        return [ obj ];
    };

// ----- removeFrom ----- //

    utils.removeFrom = function( ary, obj ) {
        var index = ary.indexOf( obj );
        if ( index != -1 ) {
            ary.splice( index, 1 );
        }
    };

// ----- getParent ----- //

    utils.getParent = function( elem, selector ) {
        while ( elem.parentNode && elem != document.body ) {
            elem = elem.parentNode;
            if ( matchesSelector( elem, selector ) ) {
                return elem;
            }
        }
    };

// ----- getQueryElement ----- //

// use element as selector string
    utils.getQueryElement = function( elem ) {
        if ( typeof elem == 'string' ) {
            return document.querySelector( elem );
        }
        return elem;
    };

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function( event ) {
        var method = 'on' + event.type;
        if ( this[ method ] ) {
            this[ method ]( event );
        }
    };

// ----- filterFindElements ----- //

    utils.filterFindElements = function( elems, selector ) {
        // make array of elems
        elems = utils.makeArray( elems );
        var ffElems = [];

        elems.forEach( function( elem ) {
            // check that elem is an actual element
            if ( !( elem instanceof HTMLElement ) ) {
                return;
            }
            // add elem if no selector
            if ( !selector ) {
                ffElems.push( elem );
                return;
            }
            // filter & find items if we have a selector
            // filter
            if ( matchesSelector( elem, selector ) ) {
                ffElems.push( elem );
            }
            // find children
            var childElems = elem.querySelectorAll( selector );
            // concat childElems to filterFound array
            for ( var i=0; i < childElems.length; i++ ) {
                ffElems.push( childElems[i] );
            }
        });

        return ffElems;
    };

// ----- debounceMethod ----- //

    utils.debounceMethod = function( _class, methodName, threshold ) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[ methodName ];
        var timeoutName = methodName + 'Timeout';

        _class.prototype[ methodName ] = function() {
            var timeout = this[ timeoutName ];
            clearTimeout( timeout );

            var args = arguments;
            var _this = this;
            this[ timeoutName ] = setTimeout( function() {
                method.apply( _this, args );
                delete _this[ timeoutName ];
            }, threshold );
        };
    };

// ----- docReady ----- //

    utils.docReady = function( callback ) {
        var readyState = document.readyState;
        if ( readyState == 'complete' || readyState == 'interactive' ) {
            // do async to allow for other scripts to run. metafizzy/flickity#441
            setTimeout( callback );
        } else {
            document.addEventListener( 'DOMContentLoaded', callback );
        }
    };

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function( str ) {
        return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };

    var console = window.console;
    /**
     * allow user to initialize classes via [data-namespace] or .js-namespace class
     * htmlInit( Widget, 'widgetName' )
     * options are parsed from data-namespace-options
     */
    utils.htmlInit = function( WidgetClass, namespace ) {
        utils.docReady( function() {
            var dashedNamespace = utils.toDashed( namespace );
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
            var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
            var elems = utils.makeArray( dataAttrElems )
                .concat( utils.makeArray( jsDashElems ) );
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window.jQuery;

            elems.forEach( function( elem ) {
                var attr = elem.getAttribute( dataAttr ) ||
                    elem.getAttribute( dataOptionsAttr );
                var options;
                try {
                    options = attr && JSON.parse( attr );
                } catch ( error ) {
                    // log error, do not initialize
                    if ( console ) {
                        console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
                            ': ' + error );
                    }
                    return;
                }
                // initialize
                var instance = new WidgetClass( elem, options );
                // make available via $().data('namespace')
                if ( jQuery ) {
                    jQuery.data( elem, namespace, instance );
                }
            });

        });
    };

// -----  ----- //

    return utils;

}));

// Flickity.Cell
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/cell',[
            'get-size/get-size'
        ], function( getSize ) {
            return factory( window, getSize );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('get-size')
        );
    } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.Cell = factory(
            window,
            window.getSize
        );
    }

}( window, function factory( window, getSize ) {



    function Cell( elem, parent ) {
        this.element = elem;
        this.parent = parent;

        this.create();
    }

    var proto = Cell.prototype;

    proto.create = function() {
        this.element.style.position = 'absolute';
        this.element.setAttribute( 'aria-hidden', 'true' );
        this.x = 0;
        this.shift = 0;
    };

    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.style.position = '';
        var side = this.parent.originSide;
        this.element.style[ side ] = '';
    };

    proto.getSize = function() {
        this.size = getSize( this.element );
    };

    proto.setPosition = function( x ) {
        this.x = x;
        this.updateTarget();
        this.renderPosition( x );
    };

// setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
        this.target = this.x + this.size[ marginProperty ] +
            this.size.width * this.parent.cellAlign;
    };

    proto.renderPosition = function( x ) {
        // render position of cell with in slider
        var side = this.parent.originSide;
        this.element.style[ side ] = this.parent.getPositionValue( x );
    };

    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };

    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute( 'aria-hidden', 'true' );
    };

    /**
     * @param {Integer} factor - 0, 1, or -1
     **/
    proto.wrapShift = function( shift ) {
        this.shift = shift;
        this.renderPosition( this.x + this.parent.slideableWidth * shift );
    };

    proto.remove = function() {
        this.element.parentNode.removeChild( this.element );
    };

    return Cell;

}));

// slide
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/slide',factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.Slide = factory();
    }

}( window, function factory() {
    'use strict';

    function Slide( parent ) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == 'left';
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }

    var proto = Slide.prototype;

    proto.addCell = function( cell ) {
        this.cells.push( cell );
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max( cell.size.outerHeight, this.height );
        // first cell stuff
        if ( this.cells.length == 1 ) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = cell.size[ beginMargin ];
        }
    };

    proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
        var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };

    proto.getLastCell = function() {
        return this.cells[ this.cells.length - 1 ];
    };

    proto.select = function() {
        this.cells.forEach( function( cell ) {
            cell.select();
        });
    };

    proto.unselect = function() {
        this.cells.forEach( function( cell ) {
            cell.unselect();
        });
    };

    proto.getCellElements = function() {
        return this.cells.map( function( cell ) {
            return cell.element;
        });
    };

    return Slide;

}));

// animate
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/animate',[
            'fizzy-ui-utils/utils'
        ], function( utils ) {
            return factory( window, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.Flickity = window.Flickity || {};
        window.Flickity.animatePrototype = factory(
            window,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, utils ) {



// -------------------------- animate -------------------------- //

    var proto = {};

    proto.startAnimation = function() {
        if ( this.isAnimating ) {
            return;
        }

        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };

    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();

        var previousX = this.x;

        this.integratePhysics();
        this.positionSlider();
        this.settle( previousX );
        // animate next frame
        if ( this.isAnimating ) {
            var _this = this;
            requestAnimationFrame( function animateFrame() {
                _this.animate();
            });
        }
    };

    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if ( this.options.wrapAround && this.cells.length > 1 ) {
            x = utils.modulo( x, this.slideableWidth );
            x = x - this.slideableWidth;
            this.shiftWrapCells( x );
        }

        this.setTranslateX( x, this.isAnimating );
        this.dispatchScrollEvent();
    };

    proto.setTranslateX = function( x, is3d ) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue( x );
        // use 3D tranforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ?
            'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
    };

    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if ( !firstSlide ) {
            return;
        }
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
    };

    proto.positionSliderAtSelected = function() {
        if ( !this.cells.length ) {
            return;
        }
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };

    proto.getPositionValue = function( position ) {
        if ( this.options.percentPosition ) {
            // percent position, round to 2 digits, like 12.34%
            return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
        } else {
            // pixel positioning
            return Math.round( position ) + 'px';
        }
    };

    proto.settle = function( previousX ) {
        // keep track of frames where x hasn't moved
        if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
            this.restingFrames++;
        }
        // stop animating if resting for 3 or more frames
        if ( this.restingFrames > 2 ) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
        }
    };

    proto.shiftWrapCells = function( x ) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
        // shift after cells
        var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
        this._shiftCells( this.afterShiftCells, afterGap, 1 );
    };

    proto._shiftCells = function( cells, gap, shift ) {
        for ( var i=0; i < cells.length; i++ ) {
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift( cellShift );
            gap -= cell.size.outerWidth;
        }
    };

    proto._unshiftCells = function( cells ) {
        if ( !cells || !cells.length ) {
            return;
        }
        for ( var i=0; i < cells.length; i++ ) {
            cells[i].wrapShift( 0 );
        }
    };

// -------------------------- physics -------------------------- //

    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };

    proto.applyForce = function( force ) {
        this.velocity += force;
    };

    proto.getFrictionFactor = function() {
        return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
    };

    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
    };

    proto.applyDragForce = function() {
        if ( !this.isDraggable || !this.isPointerDown ) {
            return;
        }
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce( dragForce );
    };

    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
            return;
        }
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce( force );
    };

    return proto;

}));

// Flickity main
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/flickity',[
            'ev-emitter/ev-emitter',
            'get-size/get-size',
            'fizzy-ui-utils/utils',
            './cell',
            './slide',
            './animate'
        ], function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
            return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter'),
            require('get-size'),
            require('fizzy-ui-utils'),
            require('./cell'),
            require('./slide'),
            require('./animate')
        );
    } else {
        // browser global
        var _Flickity = window.Flickity;

        window.Flickity = factory(
            window,
            window.EvEmitter,
            window.getSize,
            window.fizzyUIUtils,
            _Flickity.Cell,
            _Flickity.Slide,
            _Flickity.animatePrototype
        );
    }

}( window, function factory( window, EvEmitter, getSize,
                             utils, Cell, Slide, animatePrototype ) {



// vars
    var jQuery = window.jQuery;
    var getComputedStyle = window.getComputedStyle;
    var console = window.console;

    function moveElements( elems, toElem ) {
        elems = utils.makeArray( elems );
        while ( elems.length ) {
            toElem.appendChild( elems.shift() );
        }
    }

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
    var GUID = 0;
// internal store of all Flickity intances
    var instances = {};

    function Flickity( element, options ) {
        var queryElement = utils.getQueryElement( element );
        if ( !queryElement ) {
            if ( console ) {
                console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
            }
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if ( this.element.flickityGUID ) {
            var instance = instances[ this.element.flickityGUID ];
            instance.option( options );
            return instance;
        }

        // add jQuery
        if ( jQuery ) {
            this.$element = jQuery( this.element );
        }
        // options
        this.options = utils.extend( {}, this.constructor.defaults );
        this.option( options );

        // kick things off
        this._create();
    }

    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075, // friction when free-scrolling
        friction: 0.28, // friction when selecting
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
        // watchCSS: false,
        // wrapAround: false
    };

// hash of methods triggered on _create()
    Flickity.createMethods = [];

    var proto = Flickity.prototype;
// inherit EventEmitter
    utils.extend( proto, EvEmitter.prototype );

    proto._create = function() {
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[ id ] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? 'right' : 'left';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();

        if ( this.options.resize || this.options.watchCSS ) {
            window.addEventListener( 'resize', this );
        }

        // add listeners from on option
        for ( var eventName in this.options.on ) {
            var listener = this.options.on[ eventName ];
            this.on( eventName, listener );
        }

        Flickity.createMethods.forEach( function( method ) {
            this[ method ]();
        }, this );

        if ( this.options.watchCSS ) {
            this.watchCSS();
        } else {
            this.activate();
        }

    };

    /**
     * set options
     * @param {Object} opts
     */
    proto.option = function( opts ) {
        utils.extend( this.options, opts );
    };

    proto.activate = function() {
        if ( this.isActive ) {
            return;
        }
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if ( this.options.rightToLeft ) {
            this.element.classList.add('flickity-rtl');
        }

        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements( this.element.children );
        moveElements( cellElems, this.slider );
        this.viewport.appendChild( this.slider );
        this.element.appendChild( this.viewport );
        // get cells from children
        this.reloadCells();

        if ( this.options.accessibility ) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener( 'keydown', this );
        }

        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };

// slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement('div');
        slider.className = 'flickity-slider';
        slider.style[ this.originSide ] = 0;
        this.slider = slider;
    };

    proto._filterFindCellElements = function( elems ) {
        return utils.filterFindElements( elems, this.options.cellSelector );
    };

// goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells( this.slider.children );
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };

    /**
     * turn elements into Flickity.Cells
     * @param {Array or NodeList or HTMLElement} elems
     * @returns {Array} items - collection of new Flickity Cells
     */
    proto._makeCells = function( elems ) {
        var cellElems = this._filterFindCellElements( elems );

        // create new Flickity for collection
        var cells = cellElems.map( function( cellElem ) {
            return new Cell( cellElem, this );
        }, this );

        return cells;
    };

    proto.getLastCell = function() {
        return this.cells[ this.cells.length - 1 ];
    };

    proto.getLastSlide = function() {
        return this.slides[ this.slides.length - 1 ];
    };

// positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells( this.cells );
        // position all cells
        this._positionCells( 0 );
    };

    /**
     * position certain cells
     * @param {Integer} index - which cell to start with
     */
    proto._positionCells = function( index ) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if ( index > 0 ) {
            var startCell = this.cells[ index - 1 ];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for ( var i=index; i < len; i++ ) {
            var cell = this.cells[i];
            cell.setPosition( cellX );
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };

    /**
     * cell.getSize() on multiple cells
     * @param {Array} cells
     */
    proto._sizeCells = function( cells ) {
        cells.forEach( function( cell ) {
            cell.getSize();
        });
    };

// --------------------------  -------------------------- //

    proto.updateSlides = function() {
        this.slides = [];
        if ( !this.cells.length ) {
            return;
        }

        var slide = new Slide( this );
        this.slides.push( slide );
        var isOriginLeft = this.originSide == 'left';
        var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

        var canCellFit = this._getCanCellFit();

        this.cells.forEach( function( cell, i ) {
            // just add cell if first cell in slide
            if ( !slide.cells.length ) {
                slide.addCell( cell );
                return;
            }

            var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
                ( cell.size.outerWidth - cell.size[ nextMargin ] );

            if ( canCellFit.call( this, i, slideWidth ) ) {
                slide.addCell( cell );
            } else {
                // doesn't fit, new slide
                slide.updateTarget();

                slide = new Slide( this );
                this.slides.push( slide );
                slide.addCell( cell );
            }
        }, this );
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };

    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if ( !groupCells ) {
            return function() {
                return false;
            };
        } else if ( typeof groupCells == 'number' ) {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt( groupCells, 10 );
            return function( i ) {
                return ( i % number ) !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == 'string' &&
            groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
        return function( i, slideWidth ) {
            return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
        };
    };

// alias _init for jQuery plugin .flickity()
    proto._init =
        proto.reposition = function() {
            this.positionCells();
            this.positionSliderAtSelected();
        };

    proto.getSize = function() {
        this.size = getSize( this.element );
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };

    var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };

    proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[ this.options.cellAlign ];
        this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
    };

    proto.setGallerySize = function() {
        if ( this.options.setGallerySize ) {
            var height = this.options.adaptiveHeight && this.selectedSlide ?
                this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + 'px';
        }
    };

    proto._getWrapShiftCells = function() {
        // only for wrap-around
        if ( !this.options.wrapAround ) {
            return;
        }
        // unshift previous cells
        this._unshiftCells( this.beforeShiftCells );
        this._unshiftCells( this.afterShiftCells );
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
    };

    proto._getGapCells = function( gapX, cellIndex, increment ) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while ( gapX > 0 ) {
            var cell = this.cells[ cellIndex ];
            if ( !cell ) {
                break;
            }
            cells.push( cell );
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };

// ----- contain ----- //

// contain cell targets so no excess sliding
    proto._containSlides = function() {
        if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
            return;
        }
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
        var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
        var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
        var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
        // contain each cell target
        this.slides.forEach( function( slide ) {
            if ( isContentSmaller ) {
                // all cells fit inside gallery
                slide.target = contentWidth * this.cellAlign;
            } else {
                // contain to bounds
                slide.target = Math.max( slide.target, beginBound );
                slide.target = Math.min( slide.target, endBound );
            }
        }, this );
    };

// -----  ----- //

    /**
     * emits events via eventEmitter and jQuery events
     * @param {String} type - name of event
     * @param {Event} event - original event
     * @param {Array} args - extra arguments
     */
    proto.dispatchEvent = function( type, event, args ) {
        var emitArgs = event ? [ event ].concat( args ) : args;
        this.emitEvent( type, emitArgs );

        if ( jQuery && this.$element ) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            var $event = type;
            if ( event ) {
                // create jQuery event
                var jQEvent = jQuery.Event( event );
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger( $event, args );
        }
    };

// -------------------------- select -------------------------- //

    /**
     * @param {Integer} index - index of the slide
     * @param {Boolean} isWrap - will wrap-around to last/first if at the end
     * @param {Boolean} isInstant - will immediately set position at selected cell
     */
    proto.select = function( index, isWrap, isInstant ) {
        if ( !this.isActive ) {
            return;
        }
        index = parseInt( index, 10 );
        this._wrapSelect( index );

        if ( this.options.wrapAround || isWrap ) {
            index = utils.modulo( index, this.slides.length );
        }
        // bail if invalid index
        if ( !this.slides[ index ] ) {
            return;
        }
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if ( isInstant ) {
            this.positionSliderAtSelected();
        } else {
            this.startAnimation();
        }
        if ( this.options.adaptiveHeight ) {
            this.setGallerySize();
        }
        // events
        this.dispatchEvent( 'select', null, [ index ] );
        // change event if new index
        if ( index != prevIndex ) {
            this.dispatchEvent( 'change', null, [ index ] );
        }
        // old v1 event name, remove in v3
        this.dispatchEvent('cellSelect');
    };

// wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function( index ) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if ( !isWrapping ) {
            return index;
        }
        var wrapIndex = utils.modulo( index, len );
        // go to shortest
        var delta = Math.abs( wrapIndex - this.selectedIndex );
        var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
        var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
        if ( !this.isDragSelect && backWrapDelta < delta ) {
            index += len;
        } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
            index -= len;
        }
        // wrap position so slider is within normal area
        if ( index < 0 ) {
            this.x -= this.slideableWidth;
        } else if ( index >= len ) {
            this.x += this.slideableWidth;
        }
    };

    proto.previous = function( isWrap, isInstant ) {
        this.select( this.selectedIndex - 1, isWrap, isInstant );
    };

    proto.next = function( isWrap, isInstant ) {
        this.select( this.selectedIndex + 1, isWrap, isInstant );
    };

    proto.updateSelectedSlide = function() {
        var slide = this.slides[ this.selectedIndex ];
        // selectedIndex could be outside of slides, if triggered before resize()
        if ( !slide ) {
            return;
        }
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };

    proto.unselectSelectedSlide = function() {
        if ( this.selectedSlide ) {
            this.selectedSlide.unselect();
        }
    };

    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if ( this.isInitActivated ) {
            this.select( this.selectedIndex, false, true );
            return;
        }
        // select with selector string
        if ( initialIndex && typeof initialIndex == 'string' ) {
            var cell = this.queryCell( initialIndex );
            if ( cell ) {
                this.selectCell( initialIndex, false, true );
                return;
            }
        }

        var index = 0;
        // select with number
        if ( initialIndex && this.slides[ initialIndex ] ) {
            index = initialIndex;
        }
        // select instantly
        this.select( index, false, true );
    };

    /**
     * select slide from number or cell element
     * @param {Element or Number} elem
     */
    proto.selectCell = function( value, isWrap, isInstant ) {
        // get cell
        var cell = this.queryCell( value );
        if ( !cell ) {
            return;
        }

        var index = this.getCellSlideIndex( cell );
        this.select( index, isWrap, isInstant );
    };

    proto.getCellSlideIndex = function( cell ) {
        // get index of slides that has cell
        for ( var i=0; i < this.slides.length; i++ ) {
            var slide = this.slides[i];
            var index = slide.cells.indexOf( cell );
            if ( index != -1 ) {
                return i;
            }
        }
    };

// -------------------------- get cells -------------------------- //

    /**
     * get Flickity.Cell, given an Element
     * @param {Element} elem
     * @returns {Flickity.Cell} item
     */
    proto.getCell = function( elem ) {
        // loop through cells to get the one that matches
        for ( var i=0; i < this.cells.length; i++ ) {
            var cell = this.cells[i];
            if ( cell.element == elem ) {
                return cell;
            }
        }
    };

    /**
     * get collection of Flickity.Cells, given Elements
     * @param {Element, Array, NodeList} elems
     * @returns {Array} cells - Flickity.Cells
     */
    proto.getCells = function( elems ) {
        elems = utils.makeArray( elems );
        var cells = [];
        elems.forEach( function( elem ) {
            var cell = this.getCell( elem );
            if ( cell ) {
                cells.push( cell );
            }
        }, this );
        return cells;
    };

    /**
     * get cell elements
     * @returns {Array} cellElems
     */
    proto.getCellElements = function() {
        return this.cells.map( function( cell ) {
            return cell.element;
        });
    };

    /**
     * get parent cell from an element
     * @param {Element} elem
     * @returns {Flickit.Cell} cell
     */
    proto.getParentCell = function( elem ) {
        // first check if elem is cell
        var cell = this.getCell( elem );
        if ( cell ) {
            return cell;
        }
        // try to get parent cell elem
        elem = utils.getParent( elem, '.flickity-slider > *' );
        return this.getCell( elem );
    };

    /**
     * get cells adjacent to a slide
     * @param {Integer} adjCount - number of adjacent slides
     * @param {Integer} index - index of slide to start
     * @returns {Array} cells - array of Flickity.Cells
     */
    proto.getAdjacentCellElements = function( adjCount, index ) {
        if ( !adjCount ) {
            return this.selectedSlide.getCellElements();
        }
        index = index === undefined ? this.selectedIndex : index;

        var len = this.slides.length;
        if ( 1 + ( adjCount * 2 ) >= len ) {
            return this.getCellElements();
        }

        var cellElems = [];
        for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
            var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
            var slide = this.slides[ slideIndex ];
            if ( slide ) {
                cellElems = cellElems.concat( slide.getCellElements() );
            }
        }
        return cellElems;
    };

    /**
     * select slide from number or cell element
     * @param {Element, Selector String, or Number} selector
     */
    proto.queryCell = function( selector ) {
        if ( typeof selector == 'number' ) {
            // use number as index
            return this.cells[ selector ];
        }
        if ( typeof selector == 'string' ) {
            // do not select invalid selectors from hash: #123, #/. #791
            if ( selector.match(/^[#\.]?[\d\/]/) ) {
                return;
            }
            // use string as selector, get element
            selector = this.element.querySelector( selector );
        }
        // get cell from element
        return this.getCell( selector );
    };

// -------------------------- events -------------------------- //

    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };

// keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function( event ) {
        // HACK iOS does not allow touch events to bubble up?!
        if ( event.type != 'touchstart' ) {
            event.preventDefault();
        }
        this.focus();
    };

// ----- resize ----- //

    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };

    utils.debounceMethod( Flickity, 'onresize', 150 );

    proto.resize = function() {
        if ( !this.isActive ) {
            return;
        }
        this.getSize();
        // wrap values
        if ( this.options.wrapAround ) {
            this.x = utils.modulo( this.x, this.slideableWidth );
        }
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell( selectedElement, false, true );
    };

// watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if ( !watchOption ) {
            return;
        }

        var afterContent = getComputedStyle( this.element, ':after' ).content;
        // activate if :after { content: 'flickity' }
        if ( afterContent.indexOf('flickity') != -1 ) {
            this.activate();
        } else {
            this.deactivate();
        }
    };

// ----- keydown ----- //

// go previous/next if left/right keys pressed
    proto.onkeydown = function( event ) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if ( !this.options.accessibility ||isNotFocused ) {
            return;
        }

        var handler = Flickity.keyboardHandlers[ event.keyCode ];
        if ( handler ) {
            handler.call( this );
        }
    };

    Flickity.keyboardHandlers = {
        // left arrow
        37: function() {
            var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[ leftMethod ]();
        },
        // right arrow
        39: function() {
            var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[ rightMethod ]();
        },
    };

// ----- focus ----- //

    proto.focus = function() {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
        var prevScrollY = window.pageYOffset;
        this.element.focus({ preventScroll: true });
        // hack to fix scroll jump after focus, #76
        if ( window.pageYOffset != prevScrollY ) {
            window.scrollTo( window.pageXOffset, prevScrollY );
        }
    };

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if ( !this.isActive ) {
            return;
        }
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach( function( cell ) {
            cell.destroy();
        });
        this.element.removeChild( this.viewport );
        // move child elements back into element
        moveElements( this.slider.children, this.element );
        if ( this.options.accessibility ) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener( 'keydown', this );
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };

    proto.destroy = function() {
        this.deactivate();
        window.removeEventListener( 'resize', this );
        this.allOff();
        this.emitEvent('destroy');
        if ( jQuery && this.$element ) {
            jQuery.removeData( this.element, 'flickity' );
        }
        delete this.element.flickityGUID;
        delete instances[ this.guid ];
    };

// -------------------------- prototype -------------------------- //

    utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

    /**
     * get Flickity instance from element
     * @param {Element} elem
     * @returns {Flickity}
     */
    Flickity.data = function( elem ) {
        elem = utils.getQueryElement( elem );
        var id = elem && elem.flickityGUID;
        return id && instances[ id ];
    };

    utils.htmlInit( Flickity, 'flickity' );

    if ( jQuery && jQuery.bridget ) {
        jQuery.bridget( 'flickity', Flickity );
    }

// set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function( jq ) {
        jQuery = jq;
    };

    Flickity.Cell = Cell;
    Flickity.Slide = Slide;

    return Flickity;

}));

/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'unipointer/unipointer',[
            'ev-emitter/ev-emitter'
        ], function( EvEmitter ) {
            return factory( window, EvEmitter );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter')
        );
    } else {
        // browser global
        window.Unipointer = factory(
            window,
            window.EvEmitter
        );
    }

}( window, function factory( window, EvEmitter ) {



    function noop() {}

    function Unipointer() {}

// inherit EvEmitter
    var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

    proto.bindStartEvent = function( elem ) {
        this._bindStartEvent( elem, true );
    };

    proto.unbindStartEvent = function( elem ) {
        this._bindStartEvent( elem, false );
    };

    /**
     * Add or remove start event
     * @param {Boolean} isAdd - remove if falsey
     */
    proto._bindStartEvent = function( elem, isAdd ) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

        // default to mouse events
        var startEvent = 'mousedown';
        if ( window.PointerEvent ) {
            // Pointer Events
            startEvent = 'pointerdown';
        } else if ( 'ontouchstart' in window ) {
            // Touch Events. iOS Safari
            startEvent = 'touchstart';
        }
        elem[ bindMethod ]( startEvent, this );
    };

// trigger handler methods for events
    proto.handleEvent = function( event ) {
        var method = 'on' + event.type;
        if ( this[ method ] ) {
            this[ method ]( event );
        }
    };

// returns the touch that we're keeping track of
    proto.getTouch = function( touches ) {
        for ( var i=0; i < touches.length; i++ ) {
            var touch = touches[i];
            if ( touch.identifier == this.pointerIdentifier ) {
                return touch;
            }
        }
    };

// ----- start event ----- //

    proto.onmousedown = function( event ) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if ( button && ( button !== 0 && button !== 1 ) ) {
            return;
        }
        this._pointerDown( event, event );
    };

    proto.ontouchstart = function( event ) {
        this._pointerDown( event, event.changedTouches[0] );
    };

    proto.onpointerdown = function( event ) {
        this._pointerDown( event, event );
    };

    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto._pointerDown = function( event, pointer ) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if ( event.button || this.isPointerDown ) {
            return;
        }

        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ?
            // pointerId for pointer events, touch.indentifier for touch events
            pointer.pointerId : pointer.identifier;

        this.pointerDown( event, pointer );
    };

    proto.pointerDown = function( event, pointer ) {
        this._bindPostStartEvents( event );
        this.emitEvent( 'pointerDown', [ event, pointer ] );
    };

// hash of events to be bound after start event
    var postStartEvents = {
        mousedown: [ 'mousemove', 'mouseup' ],
        touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
        pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
    };

    proto._bindPostStartEvents = function( event ) {
        if ( !event ) {
            return;
        }
        // get proper events to match start event
        var events = postStartEvents[ event.type ];
        // bind events to node
        events.forEach( function( eventName ) {
            window.addEventListener( eventName, this );
        }, this );
        // save these arguments
        this._boundPointerEvents = events;
    };

    proto._unbindPostStartEvents = function() {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if ( !this._boundPointerEvents ) {
            return;
        }
        this._boundPointerEvents.forEach( function( eventName ) {
            window.removeEventListener( eventName, this );
        }, this );

        delete this._boundPointerEvents;
    };

// ----- move event ----- //

    proto.onmousemove = function( event ) {
        this._pointerMove( event, event );
    };

    proto.onpointermove = function( event ) {
        if ( event.pointerId == this.pointerIdentifier ) {
            this._pointerMove( event, event );
        }
    };

    proto.ontouchmove = function( event ) {
        var touch = this.getTouch( event.changedTouches );
        if ( touch ) {
            this._pointerMove( event, touch );
        }
    };

    /**
     * pointer move
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerMove = function( event, pointer ) {
        this.pointerMove( event, pointer );
    };

// public
    proto.pointerMove = function( event, pointer ) {
        this.emitEvent( 'pointerMove', [ event, pointer ] );
    };

// ----- end event ----- //


    proto.onmouseup = function( event ) {
        this._pointerUp( event, event );
    };

    proto.onpointerup = function( event ) {
        if ( event.pointerId == this.pointerIdentifier ) {
            this._pointerUp( event, event );
        }
    };

    proto.ontouchend = function( event ) {
        var touch = this.getTouch( event.changedTouches );
        if ( touch ) {
            this._pointerUp( event, touch );
        }
    };

    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerUp = function( event, pointer ) {
        this._pointerDone();
        this.pointerUp( event, pointer );
    };

// public
    proto.pointerUp = function( event, pointer ) {
        this.emitEvent( 'pointerUp', [ event, pointer ] );
    };

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };

    proto._pointerReset = function() {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };

    proto.pointerDone = noop;

// ----- pointer cancel ----- //

    proto.onpointercancel = function( event ) {
        if ( event.pointerId == this.pointerIdentifier ) {
            this._pointerCancel( event, event );
        }
    };

    proto.ontouchcancel = function( event ) {
        var touch = this.getTouch( event.changedTouches );
        if ( touch ) {
            this._pointerCancel( event, touch );
        }
    };

    /**
     * pointer cancel
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerCancel = function( event, pointer ) {
        this._pointerDone();
        this.pointerCancel( event, pointer );
    };

// public
    proto.pointerCancel = function( event, pointer ) {
        this.emitEvent( 'pointerCancel', [ event, pointer ] );
    };

// -----  ----- //

// utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function( pointer ) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };

// -----  ----- //

    return Unipointer;

}));

/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */

    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'unidragger/unidragger',[
            'unipointer/unipointer'
        ], function( Unipointer ) {
            return factory( window, Unipointer );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('unipointer')
        );
    } else {
        // browser global
        window.Unidragger = factory(
            window,
            window.Unipointer
        );
    }

}( window, function factory( window, Unipointer ) {



// -------------------------- Unidragger -------------------------- //

    function Unidragger() {}

// inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

    proto.bindHandles = function() {
        this._bindHandles( true );
    };

    proto.unbindHandles = function() {
        this._bindHandles( false );
    };

    /**
     * Add or remove start event
     * @param {Boolean} isAdd
     */
    proto._bindHandles = function( isAdd ) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        var touchAction = isAdd ? this._touchActionValue : '';
        for ( var i=0; i < this.handles.length; i++ ) {
            var handle = this.handles[i];
            this._bindStartEvent( handle, isAdd );
            handle[ bindMethod ]( 'click', this );
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if ( window.PointerEvent ) {
                handle.style.touchAction = touchAction;
            }
        }
    };

// prototype so it can be overwriteable by Flickity
    proto._touchActionValue = 'none';

// ----- start event ----- //

    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerDown = function( event, pointer ) {
        var isOkay = this.okayPointerDown( event );
        if ( !isOkay ) {
            return;
        }
        // track start event position
        this.pointerDownPointer = pointer;

        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents( event );
        this.emitEvent( 'pointerDown', [ event, pointer ] );
    };

// nodes that have text fields
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true,
    };

// input types that do not have text fields
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true,
    };

// dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function( event ) {
        var isCursorNode = cursorNodes[ event.target.nodeName ];
        var isClickType = clickTypes[ event.target.type ];
        var isOkay = !isCursorNode || isClickType;
        if ( !isOkay ) {
            this._pointerReset();
        }
        return isOkay;
    };

// kludge to blur previously focused input
    proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if ( canBlur ) {
            focused.blur();
        }
    };

// ----- move event ----- //

    /**
     * drag move
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerMove = function( event, pointer ) {
        var moveVector = this._dragPointerMove( event, pointer );
        this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
        this._dragMove( event, pointer, moveVector );
    };

// base pointer move logic
    proto._dragPointerMove = function( event, pointer ) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
            this._dragStart( event, pointer );
        }
        return moveVector;
    };

// condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function( moveVector ) {
        return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
    };

// ----- end event ----- //

    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerUp = function( event, pointer ) {
        this.emitEvent( 'pointerUp', [ event, pointer ] );
        this._dragPointerUp( event, pointer );
    };

    proto._dragPointerUp = function( event, pointer ) {
        if ( this.isDragging ) {
            this._dragEnd( event, pointer );
        } else {
            // pointer didn't move enough for drag to start
            this._staticClick( event, pointer );
        }
    };

// -------------------------- drag -------------------------- //

// dragStart
    proto._dragStart = function( event, pointer ) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart( event, pointer );
    };

    proto.dragStart = function( event, pointer ) {
        this.emitEvent( 'dragStart', [ event, pointer ] );
    };

// dragMove
    proto._dragMove = function( event, pointer, moveVector ) {
        // do not drag if not dragging yet
        if ( !this.isDragging ) {
            return;
        }

        this.dragMove( event, pointer, moveVector );
    };

    proto.dragMove = function( event, pointer, moveVector ) {
        event.preventDefault();
        this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
    };

// dragEnd
    proto._dragEnd = function( event, pointer ) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout( function() {
            delete this.isPreventingClicks;
        }.bind( this ) );

        this.dragEnd( event, pointer );
    };

    proto.dragEnd = function( event, pointer ) {
        this.emitEvent( 'dragEnd', [ event, pointer ] );
    };

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
    proto.onclick = function( event ) {
        if ( this.isPreventingClicks ) {
            event.preventDefault();
        }
    };

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
    proto._staticClick = function( event, pointer ) {
        // ignore emulated mouse up clicks
        if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
            return;
        }

        this.staticClick( event, pointer );

        // set flag for emulated clicks 300ms after touchend
        if ( event.type != 'mouseup' ) {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout( function() {
                delete this.isIgnoringMouseUp;
            }.bind( this ), 400 );
        }
    };

    proto.staticClick = function( event, pointer ) {
        this.emitEvent( 'staticClick', [ event, pointer ] );
    };

// ----- utils ----- //

    Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

    return Unidragger;

}));

// drag
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/drag',[
            './flickity',
            'unidragger/unidragger',
            'fizzy-ui-utils/utils'
        ], function( Flickity, Unidragger, utils ) {
            return factory( window, Flickity, Unidragger, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('./flickity'),
            require('unidragger'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.Flickity = factory(
            window,
            window.Flickity,
            window.Unidragger,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, Flickity, Unidragger, utils ) {



// ----- defaults ----- //

    utils.extend( Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3,
    });

// ----- create ----- //

    Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

    var proto = Flickity.prototype;
    utils.extend( proto, Unidragger.prototype );
    proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

    var isTouch = 'createTouch' in document;
    var isTouchmoveScrollCanceled = false;

    proto._createDrag = function() {
        this.on( 'activate', this.onActivateDrag );
        this.on( 'uiChange', this._uiChangeDrag );
        this.on( 'deactivate', this.onDeactivateDrag );
        this.on( 'cellChange', this.updateDraggable );
        // TODO updateDraggable on resize? if groupCells & slides change
        // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
        // #457, RubaXa/Sortable#973
        if ( isTouch && !isTouchmoveScrollCanceled ) {
            window.addEventListener( 'touchmove', function() {});
            isTouchmoveScrollCanceled = true;
        }
    };

    proto.onActivateDrag = function() {
        this.handles = [ this.viewport ];
        this.bindHandles();
        this.updateDraggable();
    };

    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };

    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if ( this.options.draggable == '>1' ) {
            this.isDraggable = this.slides.length > 1;
        } else {
            this.isDraggable = this.options.draggable;
        }
        if ( this.isDraggable ) {
            this.element.classList.add('is-draggable');
        } else {
            this.element.classList.remove('is-draggable');
        }
    };

// backwards compatibility
    proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
    };

    proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
    };

    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };

// -------------------------- pointer events -------------------------- //

    proto.pointerDown = function( event, pointer ) {
        if ( !this.isDraggable ) {
            this._pointerDownDefault( event, pointer );
            return;
        }
        var isOkay = this.okayPointerDown( event );
        if ( !isOkay ) {
            return;
        }

        this._pointerDownPreventDefault( event );
        this.pointerDownFocus( event );
        // blur
        if ( document.activeElement != this.element ) {
            // do not blur if already focused
            this.pointerDownBlur();
        }

        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window.addEventListener( 'scroll', this );

        this._pointerDownDefault( event, pointer );
    };

// default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function( event, pointer ) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY,
        };
        // bind move and end events
        this._bindPostStartEvents( event );
        this.dispatchEvent( 'pointerDown', event, [ pointer ] );
    };

    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true,
    };

    proto.pointerDownFocus = function( event ) {
        var isFocusNode = focusNodes[ event.target.nodeName ];
        if ( !isFocusNode ) {
            this.focus();
        }
    };

    proto._pointerDownPreventDefault = function( event ) {
        var isTouchStart = event.type == 'touchstart';
        var isTouchPointer = event.pointerType == 'touch';
        var isFocusNode = focusNodes[ event.target.nodeName ];
        if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
            event.preventDefault();
        }
    };

// ----- move ----- //

    proto.hasDragStarted = function( moveVector ) {
        return Math.abs( moveVector.x ) > this.options.dragThreshold;
    };

// ----- up ----- //

    proto.pointerUp = function( event, pointer ) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
        this.dispatchEvent( 'pointerUp', event, [ pointer ] );
        this._dragPointerUp( event, pointer );
    };

    proto.pointerDone = function() {
        window.removeEventListener( 'scroll', this );
        delete this.pointerDownScroll;
    };

// -------------------------- dragging -------------------------- //

    proto.dragStart = function( event, pointer ) {
        if ( !this.isDraggable ) {
            return;
        }
        this.dragStartPosition = this.x;
        this.startAnimation();
        window.removeEventListener( 'scroll', this );
        this.dispatchEvent( 'dragStart', event, [ pointer ] );
    };

    proto.pointerMove = function( event, pointer ) {
        var moveVector = this._dragPointerMove( event, pointer );
        this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
        this._dragMove( event, pointer, moveVector );
    };

    proto.dragMove = function( event, pointer, moveVector ) {
        if ( !this.isDraggable ) {
            return;
        }
        event.preventDefault();

        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if ( this.options.wrapAround ) {
            // wrap around move. #589
            moveVector.x = moveVector.x % this.slideableWidth;
        }
        var dragX = this.dragStartPosition + moveVector.x * direction;

        if ( !this.options.wrapAround && this.slides.length ) {
            // slow drag
            var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
            dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
            var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
            dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
        }

        this.dragX = dragX;

        this.dragMoveTime = new Date();
        this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
    };

    proto.dragEnd = function( event, pointer ) {
        if ( !this.isDraggable ) {
            return;
        }
        if ( this.options.freeScroll ) {
            this.isFreeScrolling = true;
        }
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();

        if ( this.options.freeScroll && !this.options.wrapAround ) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target &&
                -restingX < this.getLastSlide().target;
        } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
            // boost selection if selected index has not changed
            index += this.dragEndBoostSelect();
        }
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select( index );
        delete this.isDragSelect;
        this.dispatchEvent( 'dragEnd', event, [ pointer ] );
    };

    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting( restingX, distance, 1 );
        var negativeResting = this._getClosestResting( restingX, distance, -1 );
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ?
            positiveResting.index : negativeResting.index;
        return index;
    };

    /**
     * given resting X and distance to selected cell
     * get the distance and index of the closest cell
     * @param {Number} restingX - estimated post-flick resting position
     * @param {Number} distance - distance to selected cell
     * @param {Integer} increment - +1 or -1, going up or down
     * @returns {Object} - { distance: {Number}, index: {Integer} }
     */
    proto._getClosestResting = function( restingX, distance, increment ) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ?
            // if contain, keep going if distance is equal to minDistance
            function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
        while ( condition( distance, minDistance ) ) {
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance( -restingX, index );
            if ( distance === null ) {
                break;
            }
            distance = Math.abs( distance );
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };

    /**
     * measure distance between x and a slide target
     * @param {Number} x
     * @param {Integer} index - slide index
     */
    proto.getSlideDistance = function( x, index ) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
        var slide = this.slides[ slideIndex ];
        if ( !slide ) {
            return null;
        }
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
        return x - ( slide.target + wrap );
    };

    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if ( this.previousDragX === undefined || !this.dragMoveTime ||
            // or if drag was held for 100 ms
            new Date() - this.dragMoveTime > 100 ) {
            return 0;
        }

        var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
        var delta = this.previousDragX - this.dragX;
        if ( distance > 0 && delta > 0 ) {
            // boost to next if moving towards the right, and positive velocity
            return 1;
        } else if ( distance < 0 && delta < 0 ) {
            // boost to previous if moving towards the left, and negative velocity
            return -1;
        }
        return 0;
    };

// ----- staticClick ----- //

    proto.staticClick = function( event, pointer ) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell( event.target );
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
        this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
    };

// ----- scroll ----- //

    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
            this._pointerDone();
        }
    };

// ----- utils ----- //

    function getScrollPosition() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    }

// -----  ----- //

    return Flickity;

}));

// prev/next buttons
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/prev-next-button',[
            './flickity',
            'unipointer/unipointer',
            'fizzy-ui-utils/utils'
        ], function( Flickity, Unipointer, utils ) {
            return factory( window, Flickity, Unipointer, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('./flickity'),
            require('unipointer'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.Flickity,
            window.Unipointer,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, Flickity, Unipointer, utils ) {
    'use strict';

    var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

    function PrevNextButton( direction, parent ) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }

    PrevNextButton.prototype = Object.create( Unipointer.prototype );

    PrevNextButton.prototype._create = function() {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;

        var element = this.element = document.createElement('button');
        element.className = 'flickity-button flickity-prev-next-button';
        element.className += this.isPrevious ? ' previous' : ' next';
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute( 'type', 'button' );
        // init as disabled
        this.disable();

        element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

        // create arrow
        var svg = this.createSVG();
        element.appendChild( svg );
        // events
        this.parent.on( 'select', this.update.bind( this ) );
        this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
    };

    PrevNextButton.prototype.activate = function() {
        this.bindStartEvent( this.element );
        this.element.addEventListener( 'click', this );
        // add to DOM
        this.parent.element.appendChild( this.element );
    };

    PrevNextButton.prototype.deactivate = function() {
        // remove from DOM
        this.parent.element.removeChild( this.element );
        // click events
        this.unbindStartEvent( this.element );
        this.element.removeEventListener( 'click', this );
    };

    PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS( svgURI, 'svg');
        svg.setAttribute( 'class', 'flickity-button-icon' );
        svg.setAttribute( 'viewBox', '0 0 100 100' );
        var path = document.createElementNS( svgURI, 'path');
        var pathMovements = getArrowMovements( this.parent.options.arrowShape );
        path.setAttribute( 'd', pathMovements );
        path.setAttribute( 'class', 'arrow' );
        // rotate arrow
        if ( !this.isLeft ) {
            path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
        }
        svg.appendChild( path );
        return svg;
    };

// get SVG path movmement
    function getArrowMovements( shape ) {
        // use shape as movement if string
        if ( typeof shape == 'string' ) {
            return shape;
        }
        // create movement string
        return 'M ' + shape.x0 + ',50' +
            ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
            ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
            ' L ' + shape.x3 + ',50 ' +
            ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
            ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
            ' Z';
    }

    PrevNextButton.prototype.handleEvent = utils.handleEvent;

    PrevNextButton.prototype.onclick = function() {
        if ( !this.isEnabled ) {
            return;
        }
        this.parent.uiChange();
        var method = this.isPrevious ? 'previous' : 'next';
        this.parent[ method ]();
    };

// -----  ----- //

    PrevNextButton.prototype.enable = function() {
        if ( this.isEnabled ) {
            return;
        }
        this.element.disabled = false;
        this.isEnabled = true;
    };

    PrevNextButton.prototype.disable = function() {
        if ( !this.isEnabled ) {
            return;
        }
        this.element.disabled = true;
        this.isEnabled = false;
    };

    PrevNextButton.prototype.update = function() {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if ( this.parent.options.wrapAround && slides.length > 1 ) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
        this[ method ]();
    };

    PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };

// -------------------------- Flickity prototype -------------------------- //

    utils.extend( Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 70, y2: 40,
            x3: 30
        }
    });

    Flickity.createMethods.push('_createPrevNextButtons');
    var proto = Flickity.prototype;

    proto._createPrevNextButtons = function() {
        if ( !this.options.prevNextButtons ) {
            return;
        }

        this.prevButton = new PrevNextButton( -1, this );
        this.nextButton = new PrevNextButton( 1, this );

        this.on( 'activate', this.activatePrevNextButtons );
    };

    proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on( 'deactivate', this.deactivatePrevNextButtons );
    };

    proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off( 'deactivate', this.deactivatePrevNextButtons );
    };

// --------------------------  -------------------------- //

    Flickity.PrevNextButton = PrevNextButton;

    return Flickity;

}));

// page dots
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/page-dots',[
            './flickity',
            'unipointer/unipointer',
            'fizzy-ui-utils/utils'
        ], function( Flickity, Unipointer, utils ) {
            return factory( window, Flickity, Unipointer, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('./flickity'),
            require('unipointer'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.Flickity,
            window.Unipointer,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //



    function PageDots( parent ) {
        this.parent = parent;
        this._create();
    }

    PageDots.prototype = Object.create( Unipointer.prototype );

    PageDots.prototype._create = function() {
        // create holder element
        this.holder = document.createElement('ol');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind( this );
        this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
    };

    PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener( 'click', this.handleClick );
        this.bindStartEvent( this.holder );
        // add to DOM
        this.parent.element.appendChild( this.holder );
    };

    PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener( 'click', this.handleClick );
        this.unbindStartEvent( this.holder );
        // remove from DOM
        this.parent.element.removeChild( this.holder );
    };

    PageDots.prototype.setDots = function() {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if ( delta > 0 ) {
            this.addDots( delta );
        } else if ( delta < 0 ) {
            this.removeDots( -delta );
        }
    };

    PageDots.prototype.addDots = function( count ) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;

        for ( var i = length; i < max; i++ ) {
            var dot = document.createElement('li');
            dot.className = 'dot';
            dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
            fragment.appendChild( dot );
            newDots.push( dot );
        }

        this.holder.appendChild( fragment );
        this.dots = this.dots.concat( newDots );
    };

    PageDots.prototype.removeDots = function( count ) {
        // remove from this.dots collection
        var removeDots = this.dots.splice( this.dots.length - count, count );
        // remove from DOM
        removeDots.forEach( function( dot ) {
            this.holder.removeChild( dot );
        }, this );
    };

    PageDots.prototype.updateSelected = function() {
        // remove selected class on previous
        if ( this.selectedDot ) {
            this.selectedDot.className = 'dot';
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if ( !this.dots.length ) {
            return;
        }
        this.selectedDot = this.dots[ this.parent.selectedIndex ];
        this.selectedDot.className = 'dot is-selected';
        this.selectedDot.setAttribute( 'aria-current', 'step' );
    };

    PageDots.prototype.onTap = // old method name, backwards-compatible
        PageDots.prototype.onClick = function( event ) {
            var target = event.target;
            // only care about dot clicks
            if ( target.nodeName != 'LI' ) {
                return;
            }

            this.parent.uiChange();
            var index = this.dots.indexOf( target );
            this.parent.select( index );
        };

    PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };

    Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

    utils.extend( Flickity.defaults, {
        pageDots: true
    });

    Flickity.createMethods.push('_createPageDots');

    var proto = Flickity.prototype;

    proto._createPageDots = function() {
        if ( !this.options.pageDots ) {
            return;
        }
        this.pageDots = new PageDots( this );
        // events
        this.on( 'activate', this.activatePageDots );
        this.on( 'select', this.updateSelectedPageDots );
        this.on( 'cellChange', this.updatePageDots );
        this.on( 'resize', this.updatePageDots );
        this.on( 'deactivate', this.deactivatePageDots );
    };

    proto.activatePageDots = function() {
        this.pageDots.activate();
    };

    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    };

    proto.updatePageDots = function() {
        this.pageDots.setDots();
    };

    proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
    };

// -----  ----- //

    Flickity.PageDots = PageDots;

    return Flickity;

}));

// player & autoPlay
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/player',[
            'ev-emitter/ev-emitter',
            'fizzy-ui-utils/utils',
            './flickity'
        ], function( EvEmitter, utils, Flickity ) {
            return factory( EvEmitter, utils, Flickity );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            require('ev-emitter'),
            require('fizzy-ui-utils'),
            require('./flickity')
        );
    } else {
        // browser global
        factory(
            window.EvEmitter,
            window.fizzyUIUtils,
            window.Flickity
        );
    }

}( window, function factory( EvEmitter, utils, Flickity ) {



// -------------------------- Player -------------------------- //

    function Player( parent ) {
        this.parent = parent;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind( this );
        this.onVisibilityPlay = this.visibilityPlay.bind( this );
    }

    Player.prototype = Object.create( EvEmitter.prototype );

// start play
    Player.prototype.play = function() {
        if ( this.state == 'playing' ) {
            return;
        }
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if ( isPageHidden ) {
            document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
            return;
        }

        this.state = 'playing';
        // listen to visibility change
        document.addEventListener( 'visibilitychange', this.onVisibilityChange );
        // start ticking
        this.tick();
    };

    Player.prototype.tick = function() {
        // do not tick if not playing
        if ( this.state != 'playing' ) {
            return;
        }

        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == 'number' ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout( function() {
            _this.parent.next( true );
            _this.tick();
        }, time );
    };

    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
    };

    Player.prototype.clear = function() {
        clearTimeout( this.timeout );
    };

    Player.prototype.pause = function() {
        if ( this.state == 'playing' ) {
            this.state = 'paused';
            this.clear();
        }
    };

    Player.prototype.unpause = function() {
        // re-start play if paused
        if ( this.state == 'paused' ) {
            this.play();
        }
    };

// pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[ isPageHidden ? 'pause' : 'unpause' ]();
    };

    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
    };

// -------------------------- Flickity -------------------------- //

    utils.extend( Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });

    Flickity.createMethods.push('_createPlayer');
    var proto = Flickity.prototype;

    proto._createPlayer = function() {
        this.player = new Player( this );

        this.on( 'activate', this.activatePlayer );
        this.on( 'uiChange', this.stopPlayer );
        this.on( 'pointerDown', this.stopPlayer );
        this.on( 'deactivate', this.deactivatePlayer );
    };

    proto.activatePlayer = function() {
        if ( !this.options.autoPlay ) {
            return;
        }
        this.player.play();
        this.element.addEventListener( 'mouseenter', this );
    };

// Player API, don't hate the ... thanks I know where the door is

    proto.playPlayer = function() {
        this.player.play();
    };

    proto.stopPlayer = function() {
        this.player.stop();
    };

    proto.pausePlayer = function() {
        this.player.pause();
    };

    proto.unpausePlayer = function() {
        this.player.unpause();
    };

    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener( 'mouseenter', this );
    };

// ----- mouseenter/leave ----- //

// pause auto-play on hover
    proto.onmouseenter = function() {
        if ( !this.options.pauseAutoPlayOnHover ) {
            return;
        }
        this.player.pause();
        this.element.addEventListener( 'mouseleave', this );
    };

// resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener( 'mouseleave', this );
    };

// -----  ----- //

    Flickity.Player = Player;

    return Flickity;

}));

// add, remove cell
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/add-remove-cell',[
            './flickity',
            'fizzy-ui-utils/utils'
        ], function( Flickity, utils ) {
            return factory( window, Flickity, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('./flickity'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.Flickity,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, Flickity, utils ) {



// append cells to a document fragment
    function getCellsFragment( cells ) {
        var fragment = document.createDocumentFragment();
        cells.forEach( function( cell ) {
            fragment.appendChild( cell.element );
        });
        return fragment;
    }

// -------------------------- add/remove cell prototype -------------------------- //

    var proto = Flickity.prototype;

    /**
     * Insert, prepend, or append cells
     * @param {Element, Array, NodeList} elems
     * @param {Integer} index
     */
    proto.insert = function( elems, index ) {
        var cells = this._makeCells( elems );
        if ( !cells || !cells.length ) {
            return;
        }
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment( cells );
        // append to slider
        var isAppend = index == len;
        if ( isAppend ) {
            this.slider.appendChild( fragment );
        } else {
            var insertCellElement = this.cells[ index ].element;
            this.slider.insertBefore( fragment, insertCellElement );
        }
        // add to this.cells
        if ( index === 0 ) {
            // prepend, add to start
            this.cells = cells.concat( this.cells );
        } else if ( isAppend ) {
            // append, add to end
            this.cells = this.cells.concat( cells );
        } else {
            // insert in this.cells
            var endCells = this.cells.splice( index, len - index );
            this.cells = this.cells.concat( cells ).concat( endCells );
        }

        this._sizeCells( cells );
        this.cellChange( index, true );
    };

    proto.append = function( elems ) {
        this.insert( elems, this.cells.length );
    };

    proto.prepend = function( elems ) {
        this.insert( elems, 0 );
    };

    /**
     * Remove cells
     * @param {Element, Array, NodeList} elems
     */
    proto.remove = function( elems ) {
        var cells = this.getCells( elems );
        if ( !cells || !cells.length ) {
            return;
        }

        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach( function( cell ) {
            cell.remove();
            var index = this.cells.indexOf( cell );
            minCellIndex = Math.min( index, minCellIndex );
            utils.removeFrom( this.cells, cell );
        }, this );

        this.cellChange( minCellIndex, true );
    };

    /**
     * logic to be run after a cell's size changes
     * @param {Element} elem - cell's element
     */
    proto.cellSizeChange = function( elem ) {
        var cell = this.getCell( elem );
        if ( !cell ) {
            return;
        }
        cell.getSize();

        var index = this.cells.indexOf( cell );
        this.cellChange( index );
    };

    /**
     * logic any time a cell is changed: added, removed, or size changed
     * @param {Integer} changedCellIndex - index of the changed cell, optional
     */
    proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells( changedCellIndex );
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell( prevSelectedElem );
        if ( cell ) {
            this.selectedIndex = this.getCellSlideIndex( cell );
        }
        this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

        this.emitEvent( 'cellChange', [ changedCellIndex ] );
        // position slider
        this.select( this.selectedIndex );
        // do not position slider after lazy load
        if ( isPositioningSlider ) {
            this.positionSliderAtSelected();
        }
    };

// -----  ----- //

    return Flickity;

}));

// lazyload
( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/lazyload',[
            './flickity',
            'fizzy-ui-utils/utils'
        ], function( Flickity, utils ) {
            return factory( window, Flickity, utils );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('./flickity'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.Flickity,
            window.fizzyUIUtils
        );
    }

}( window, function factory( window, Flickity, utils ) {
    'use strict';

    Flickity.createMethods.push('_createLazyload');
    var proto = Flickity.prototype;

    proto._createLazyload = function() {
        this.on( 'select', this.lazyLoad );
    };

    proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if ( !lazyLoad ) {
            return;
        }
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements( adjCount );
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach( function( cellElem ) {
            var lazyCellImages = getCellLazyImages( cellElem );
            lazyImages = lazyImages.concat( lazyCellImages );
        });
        // load lazy images
        lazyImages.forEach( function( img ) {
            new LazyLoader( img, this );
        }, this );
    };

    function getCellLazyImages( cellElem ) {
        // check if cell element is lazy image
        if ( cellElem.nodeName == 'IMG' ) {
            var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
            var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
            var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
            if ( lazyloadAttr || srcAttr || srcsetAttr ) {
                return [ cellElem ];
            }
        }
        // select lazy images in cell
        var lazySelector = 'img[data-flickity-lazyload], ' +
            'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
        var imgs = cellElem.querySelectorAll( lazySelector );
        return utils.makeArray( imgs );
    }

// -------------------------- LazyLoader -------------------------- //

    /**
     * class to handle loading images
     */
    function LazyLoader( img, flickity ) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }

    LazyLoader.prototype.handleEvent = utils.handleEvent;

    LazyLoader.prototype.load = function() {
        this.img.addEventListener( 'load', this );
        this.img.addEventListener( 'error', this );
        // get src & srcset
        var src = this.img.getAttribute('data-flickity-lazyload') ||
            this.img.getAttribute('data-flickity-lazyload-src');
        var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
        // set src & serset
        this.img.src = src;
        if ( srcset ) {
            this.img.setAttribute( 'srcset', srcset );
        }
        // remove attr
        this.img.removeAttribute('data-flickity-lazyload');
        this.img.removeAttribute('data-flickity-lazyload-src');
        this.img.removeAttribute('data-flickity-lazyload-srcset');
    };

    LazyLoader.prototype.onload = function( event ) {
        this.complete( event, 'flickity-lazyloaded' );
    };

    LazyLoader.prototype.onerror = function( event ) {
        this.complete( event, 'flickity-lazyerror' );
    };

    LazyLoader.prototype.complete = function( event, className ) {
        // unbind events
        this.img.removeEventListener( 'load', this );
        this.img.removeEventListener( 'error', this );

        var cell = this.flickity.getParentCell( this.img );
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange( cellElem );

        this.img.classList.add( className );
        this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
    };

// -----  ----- //

    Flickity.LazyLoader = LazyLoader;

    return Flickity;

}));

/*!
 * Flickity v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

( function( window, factory ) {
    // universal module definition
    /* jshint strict: false */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity/js/index',[
            './flickity',
            './drag',
            './prev-next-button',
            './page-dots',
            './player',
            './add-remove-cell',
            './lazyload'
        ], factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            require('./flickity'),
            require('./drag'),
            require('./prev-next-button'),
            require('./page-dots'),
            require('./player'),
            require('./add-remove-cell'),
            require('./lazyload')
        );
    }

})( window, function factory( Flickity ) {
    /*jshint strict: false*/
    return Flickity;
});

/*!
 * Flickity asNavFor v2.0.2
 * enable asNavFor for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'flickity-as-nav-for/as-nav-for',[
            'flickity/js/index',
            'fizzy-ui-utils/utils'
        ], factory );
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            require('flickity'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.Flickity = factory(
            window.Flickity,
            window.fizzyUIUtils
        );
    }

}( window, function factory( Flickity, utils ) {



// -------------------------- asNavFor prototype -------------------------- //

// Flickity.defaults.asNavFor = null;

    Flickity.createMethods.push('_createAsNavFor');

    var proto = Flickity.prototype;

    proto._createAsNavFor = function() {
        this.on( 'activate', this.activateAsNavFor );
        this.on( 'deactivate', this.deactivateAsNavFor );
        this.on( 'destroy', this.destroyAsNavFor );

        var asNavForOption = this.options.asNavFor;
        if ( !asNavForOption ) {
            return;
        }
        // HACK do async, give time for other flickity to be initalized
        var _this = this;
        setTimeout( function initNavCompanion() {
            _this.setNavCompanion( asNavForOption );
        });
    };

    proto.setNavCompanion = function( elem ) {
        elem = utils.getQueryElement( elem );
        var companion = Flickity.data( elem );
        // stop if no companion or companion is self
        if ( !companion || companion == this ) {
            return;
        }

        this.navCompanion = companion;
        // companion select
        var _this = this;
        this.onNavCompanionSelect = function() {
            _this.navCompanionSelect();
        };
        companion.on( 'select', this.onNavCompanionSelect );
        // click
        this.on( 'staticClick', this.onNavStaticClick );

        this.navCompanionSelect( true );
    };

    proto.navCompanionSelect = function( isInstant ) {
        // wait for companion & selectedCells first. #8
        var companionCells = this.navCompanion && this.navCompanion.selectedCells;
        if ( !companionCells ) {
            return;
        }
        // select slide that matches first cell of slide
        var selectedCell = companionCells[0];
        var firstIndex = this.navCompanion.cells.indexOf( selectedCell );
        var lastIndex = firstIndex + companionCells.length - 1;
        var selectIndex = Math.floor( lerp( firstIndex, lastIndex,
            this.navCompanion.cellAlign ) );
        this.selectCell( selectIndex, false, isInstant );
        // set nav selected class
        this.removeNavSelectedElements();
        // stop if companion has more cells than this one
        if ( selectIndex >= this.cells.length ) {
            return;
        }

        var selectedCells = this.cells.slice( firstIndex, lastIndex + 1 );
        this.navSelectedElements = selectedCells.map( function( cell ) {
            return cell.element;
        });
        this.changeNavSelectedClass('add');
    };

    function lerp( a, b, t ) {
        return ( b - a ) * t + a;
    }

    proto.changeNavSelectedClass = function( method ) {
        this.navSelectedElements.forEach( function( navElem ) {
            navElem.classList[ method ]('is-nav-selected');
        });
    };

    proto.activateAsNavFor = function() {
        this.navCompanionSelect( true );
    };

    proto.removeNavSelectedElements = function() {
        if ( !this.navSelectedElements ) {
            return;
        }
        this.changeNavSelectedClass('remove');
        delete this.navSelectedElements;
    };

    proto.onNavStaticClick = function( event, pointer, cellElement, cellIndex ) {
        if ( typeof cellIndex == 'number' ) {
            this.navCompanion.selectCell( cellIndex );
        }
    };

    proto.deactivateAsNavFor = function() {
        this.removeNavSelectedElements();
    };

    proto.destroyAsNavFor = function() {
        if ( !this.navCompanion ) {
            return;
        }
        this.navCompanion.off( 'select', this.onNavCompanionSelect );
        this.off( 'staticClick', this.onNavStaticClick );
        delete this.navCompanion;
    };

// -----  ----- //

    return Flickity;

}));

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
    // universal module definition

    /*global define: false, module: false, require: false */

    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( 'imagesloaded/imagesloaded',[
            'ev-emitter/ev-emitter'
        ], function( EvEmitter ) {
            return factory( window, EvEmitter );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter')
        );
    } else {
        // browser global
        window.imagesLoaded = factory(
            window,
            window.EvEmitter
        );
    }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

    function factory( window, EvEmitter ) {



        var $ = window.jQuery;
        var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
        function extend( a, b ) {
            for ( var prop in b ) {
                a[ prop ] = b[ prop ];
            }
            return a;
        }

        var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
        function makeArray( obj ) {
            if ( Array.isArray( obj ) ) {
                // use object if already an array
                return obj;
            }

            var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
            if ( isArrayLike ) {
                // convert nodeList to array
                return arraySlice.call( obj );
            }

            // array of single index
            return [ obj ];
        }

// -------------------------- imagesLoaded -------------------------- //

        /**
         * @param {Array, Element, NodeList, String} elem
         * @param {Object or Function} options - if function, use as callback
         * @param {Function} onAlways - callback function
         */
        function ImagesLoaded( elem, options, onAlways ) {
            // coerce ImagesLoaded() without new, to be new ImagesLoaded()
            if ( !( this instanceof ImagesLoaded ) ) {
                return new ImagesLoaded( elem, options, onAlways );
            }
            // use elem as selector string
            var queryElem = elem;
            if ( typeof elem == 'string' ) {
                queryElem = document.querySelectorAll( elem );
            }
            // bail if bad element
            if ( !queryElem ) {
                console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
                return;
            }

            this.elements = makeArray( queryElem );
            this.options = extend( {}, this.options );
            // shift arguments if no options set
            if ( typeof options == 'function' ) {
                onAlways = options;
            } else {
                extend( this.options, options );
            }

            if ( onAlways ) {
                this.on( 'always', onAlways );
            }

            this.getImages();

            if ( $ ) {
                // add jQuery Deferred object
                this.jqDeferred = new $.Deferred();
            }

            // HACK check async to allow time to bind listeners
            setTimeout( this.check.bind( this ) );
        }

        ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

        ImagesLoaded.prototype.options = {};

        ImagesLoaded.prototype.getImages = function() {
            this.images = [];

            // filter & find items if we have an item selector
            this.elements.forEach( this.addElementImages, this );
        };

        /**
         * @param {Node} element
         */
        ImagesLoaded.prototype.addElementImages = function( elem ) {
            // filter siblings
            if ( elem.nodeName == 'IMG' ) {
                this.addImage( elem );
            }
            // get background image on element
            if ( this.options.background === true ) {
                this.addElementBackgroundImages( elem );
            }

            // find children
            // no non-element nodes, #143
            var nodeType = elem.nodeType;
            if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
                return;
            }
            var childImgs = elem.querySelectorAll('img');
            // concat childElems to filterFound array
            for ( var i=0; i < childImgs.length; i++ ) {
                var img = childImgs[i];
                this.addImage( img );
            }

            // get child background images
            if ( typeof this.options.background == 'string' ) {
                var children = elem.querySelectorAll( this.options.background );
                for ( i=0; i < children.length; i++ ) {
                    var child = children[i];
                    this.addElementBackgroundImages( child );
                }
            }
        };

        var elementNodeTypes = {
            1: true,
            9: true,
            11: true
        };

        ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
            var style = getComputedStyle( elem );
            if ( !style ) {
                // Firefox returns null if in a hidden iframe https://bugzil.la/548397
                return;
            }
            // get url inside url("...")
            var reURL = /url\((['"])?(.*?)\1\)/gi;
            var matches = reURL.exec( style.backgroundImage );
            while ( matches !== null ) {
                var url = matches && matches[2];
                if ( url ) {
                    this.addBackground( url, elem );
                }
                matches = reURL.exec( style.backgroundImage );
            }
        };

        /**
         * @param {Image} img
         */
        ImagesLoaded.prototype.addImage = function( img ) {
            var loadingImage = new LoadingImage( img );
            this.images.push( loadingImage );
        };

        ImagesLoaded.prototype.addBackground = function( url, elem ) {
            var background = new Background( url, elem );
            this.images.push( background );
        };

        ImagesLoaded.prototype.check = function() {
            var _this = this;
            this.progressedCount = 0;
            this.hasAnyBroken = false;
            // complete if no images
            if ( !this.images.length ) {
                this.complete();
                return;
            }

            function onProgress( image, elem, message ) {
                // HACK - Chrome triggers event before object properties have changed. #83
                setTimeout( function() {
                    _this.progress( image, elem, message );
                });
            }

            this.images.forEach( function( loadingImage ) {
                loadingImage.once( 'progress', onProgress );
                loadingImage.check();
            });
        };

        ImagesLoaded.prototype.progress = function( image, elem, message ) {
            this.progressedCount++;
            this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
            // progress event
            this.emitEvent( 'progress', [ this, image, elem ] );
            if ( this.jqDeferred && this.jqDeferred.notify ) {
                this.jqDeferred.notify( this, image );
            }
            // check if completed
            if ( this.progressedCount == this.images.length ) {
                this.complete();
            }

            if ( this.options.debug && console ) {
                console.log( 'progress: ' + message, image, elem );
            }
        };

        ImagesLoaded.prototype.complete = function() {
            var eventName = this.hasAnyBroken ? 'fail' : 'done';
            this.isComplete = true;
            this.emitEvent( eventName, [ this ] );
            this.emitEvent( 'always', [ this ] );
            if ( this.jqDeferred ) {
                var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
                this.jqDeferred[ jqMethod ]( this );
            }
        };

// --------------------------  -------------------------- //

        function LoadingImage( img ) {
            this.img = img;
        }

        LoadingImage.prototype = Object.create( EvEmitter.prototype );

        LoadingImage.prototype.check = function() {
            // If complete is true and browser supports natural sizes,
            // try to check for image status manually.
            var isComplete = this.getIsImageComplete();
            if ( isComplete ) {
                // report based on naturalWidth
                this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
                return;
            }

            // If none of the checks above matched, simulate loading on detached element.
            this.proxyImage = new Image();
            this.proxyImage.addEventListener( 'load', this );
            this.proxyImage.addEventListener( 'error', this );
            // bind to image as well for Firefox. #191
            this.img.addEventListener( 'load', this );
            this.img.addEventListener( 'error', this );
            this.proxyImage.src = this.img.src;
        };

        LoadingImage.prototype.getIsImageComplete = function() {
            // check for non-zero, non-undefined naturalWidth
            // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
            return this.img.complete && this.img.naturalWidth;
        };

        LoadingImage.prototype.confirm = function( isLoaded, message ) {
            this.isLoaded = isLoaded;
            this.emitEvent( 'progress', [ this, this.img, message ] );
        };

// ----- events ----- //

// trigger specified handler for event type
        LoadingImage.prototype.handleEvent = function( event ) {
            var method = 'on' + event.type;
            if ( this[ method ] ) {
                this[ method ]( event );
            }
        };

        LoadingImage.prototype.onload = function() {
            this.confirm( true, 'onload' );
            this.unbindEvents();
        };

        LoadingImage.prototype.onerror = function() {
            this.confirm( false, 'onerror' );
            this.unbindEvents();
        };

        LoadingImage.prototype.unbindEvents = function() {
            this.proxyImage.removeEventListener( 'load', this );
            this.proxyImage.removeEventListener( 'error', this );
            this.img.removeEventListener( 'load', this );
            this.img.removeEventListener( 'error', this );
        };

// -------------------------- Background -------------------------- //

        function Background( url, element ) {
            this.url = url;
            this.element = element;
            this.img = new Image();
        }

// inherit LoadingImage prototype
        Background.prototype = Object.create( LoadingImage.prototype );

        Background.prototype.check = function() {
            this.img.addEventListener( 'load', this );
            this.img.addEventListener( 'error', this );
            this.img.src = this.url;
            // check if image is already complete
            var isComplete = this.getIsImageComplete();
            if ( isComplete ) {
                this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
                this.unbindEvents();
            }
        };

        Background.prototype.unbindEvents = function() {
            this.img.removeEventListener( 'load', this );
            this.img.removeEventListener( 'error', this );
        };

        Background.prototype.confirm = function( isLoaded, message ) {
            this.isLoaded = isLoaded;
            this.emitEvent( 'progress', [ this, this.element, message ] );
        };

// -------------------------- jQuery -------------------------- //

        ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
            jQuery = jQuery || window.jQuery;
            if ( !jQuery ) {
                return;
            }
            // set local variable
            $ = jQuery;
            // $().imagesLoaded()
            $.fn.imagesLoaded = function( options, callback ) {
                var instance = new ImagesLoaded( this, options, callback );
                return instance.jqDeferred.promise( $(this) );
            };
        };
// try making plugin
        ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

        return ImagesLoaded;

    });

/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
        // AMD
        define( [
            'flickity/js/index',
            'imagesloaded/imagesloaded'
        ], function( Flickity, imagesLoaded ) {
            return factory( window, Flickity, imagesLoaded );
        });
    } else if ( typeof module == 'object' && module.exports ) {
        // CommonJS
        module.exports = factory(
            window,
            require('flickity'),
            require('imagesloaded')
        );
    } else {
        // browser global
        window.Flickity = factory(
            window,
            window.Flickity,
            window.imagesLoaded
        );
    }

}( window, function factory( window, Flickity, imagesLoaded ) {
    'use strict';

    Flickity.createMethods.push('_createImagesLoaded');

    var proto = Flickity.prototype;

    proto._createImagesLoaded = function() {
        this.on( 'activate', this.imagesLoaded );
    };

    proto.imagesLoaded = function() {
        if ( !this.options.imagesLoaded ) {
            return;
        }
        var _this = this;
        function onImagesLoadedProgress( instance, image ) {
            var cell = _this.getParentCell( image.img );
            _this.cellSizeChange( cell && cell.element );
            if ( !_this.options.freeScroll ) {
                _this.positionSliderAtSelected();
            }
        }
        imagesLoaded( this.slider ).on( 'progress', onImagesLoadedProgress );
    };

    return Flickity;

}));

/*!
	Colorbox 1.6.4
	license: MIT
	http://www.jacklmoore.com/colorbox
*/
(function ($, document, window) {
	var
	// Default settings object.
	// See http://jacklmoore.com/colorbox for details.
	defaults = {
		// data sources
		html: false,
		photo: false,
		iframe: false,
		inline: false,

		// behavior and appearance
		transition: "elastic",
		speed: 300,
		fadeOut: 300,
		width: false,
		initialWidth: "600",
		innerWidth: false,
		maxWidth: false,
		height: false,
		initialHeight: "450",
		innerHeight: false,
		maxHeight: false,
		scalePhotos: true,
		scrolling: true,
		opacity: 0.9,
		preloading: true,
		className: false,
		overlayClose: true,
		escKey: true,
		arrowKey: true,
		top: false,
		bottom: false,
		left: false,
		right: false,
		fixed: false,
		data: undefined,
		closeButton: true,
		fastIframe: true,
		open: false,
		reposition: true,
		loop: true,
		slideshow: false,
		slideshowAuto: true,
		slideshowSpeed: 2500,
		slideshowStart: "start slideshow",
		slideshowStop: "stop slideshow",
		photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,

		// alternate image paths for high-res displays
		retinaImage: false,
		retinaUrl: false,
		retinaSuffix: '@2x.$1',

		// internationalization
		current: "image {current} of {total}",
		previous: "previous",
		next: "next",
		close: "close",
		xhrError: "This content failed to load.",
		imgError: "This image failed to load.",

		// accessbility
		returnFocus: true,
		trapFocus: true,

		// callbacks
		onOpen: false,
		onLoad: false,
		onComplete: false,
		onCleanup: false,
		onClosed: false,

		rel: function() {
			return this.rel;
		},
		href: function() {
			// using this.href would give the absolute url, when the href may have been inteded as a selector (e.g. '#container')
			return $(this).attr('href');
		},
		title: function() {
			return this.title;
		},
		createImg: function() {
			var img = new Image();
			var attrs = $(this).data('cbox-img-attrs');

			if (typeof attrs === 'object') {
				$.each(attrs, function(key, val){
					img[key] = val;
				});
			}

			return img;
		},
		createIframe: function() {
			var iframe = document.createElement('iframe');
			var attrs = $(this).data('cbox-iframe-attrs');

			if (typeof attrs === 'object') {
				$.each(attrs, function(key, val){
					iframe[key] = val;
				});
			}

			if ('frameBorder' in iframe) {
				iframe.frameBorder = 0;
			}
			if ('allowTransparency' in iframe) {
				iframe.allowTransparency = "true";
			}
			iframe.name = (new Date()).getTime(); // give the iframe a unique name to prevent caching
			iframe.allowFullscreen = true;

			return iframe;
		}
	},

	// Abstracting the HTML and event identifiers for easy rebranding
	colorbox = 'colorbox',
	prefix = 'cbox',
	boxElement = prefix + 'Element',

	// Events
	event_open = prefix + '_open',
	event_load = prefix + '_load',
	event_complete = prefix + '_complete',
	event_cleanup = prefix + '_cleanup',
	event_closed = prefix + '_closed',
	event_purge = prefix + '_purge',

	// Cached jQuery Object Variables
	$overlay,
	$box,
	$wrap,
	$content,
	$topBorder,
	$leftBorder,
	$rightBorder,
	$bottomBorder,
	$related,
	$window,
	$loaded,
	$loadingBay,
	$loadingOverlay,
	$title,
	$current,
	$slideshow,
	$next,
	$prev,
	$close,
	$groupControls,
	$events = $('<a/>'), // $({}) would be preferred, but there is an issue with jQuery 1.4.2

	// Variables for cached values or use across multiple functions
	settings,
	interfaceHeight,
	interfaceWidth,
	loadedHeight,
	loadedWidth,
	index,
	photo,
	open,
	active,
	closing,
	loadingTimer,
	publicMethod,
	div = "div",
	requests = 0,
	previousCSS = {},
	init;

	// ****************
	// HELPER FUNCTIONS
	// ****************

	// Convenience function for creating new jQuery objects
	function $tag(tag, id, css) {
		var element = document.createElement(tag);

		if (id) {
			element.id = prefix + id;
		}

		if (css) {
			element.style.cssText = css;
		}

		return $(element);
	}

	// Get the window height using innerHeight when available to avoid an issue with iOS
	// http://bugs.jquery.com/ticket/6724
	function winheight() {
		return window.innerHeight ? window.innerHeight : $(window).height();
	}

	function Settings(element, options) {
		if (options !== Object(options)) {
			options = {};
		}

		this.cache = {};
		this.el = element;

		this.value = function(key) {
			var dataAttr;

			if (this.cache[key] === undefined) {
				dataAttr = $(this.el).attr('data-cbox-'+key);

				if (dataAttr !== undefined) {
					this.cache[key] = dataAttr;
				} else if (options[key] !== undefined) {
					this.cache[key] = options[key];
				} else if (defaults[key] !== undefined) {
					this.cache[key] = defaults[key];
				}
			}

			return this.cache[key];
		};

		this.get = function(key) {
			var value = this.value(key);
			return $.isFunction(value) ? value.call(this.el, this) : value;
		};
	}

	// Determine the next and previous members in a group.
	function getIndex(increment) {
		var
		max = $related.length,
		newIndex = (index + increment) % max;

		return (newIndex < 0) ? max + newIndex : newIndex;
	}

	// Convert '%' and 'px' values to integers
	function setSize(size, dimension) {
		return Math.round((/%/.test(size) ? ((dimension === 'x' ? $window.width() : winheight()) / 100) : 1) * parseInt(size, 10));
	}

	// Checks an href to see if it is a photo.
	// There is a force photo option (photo: true) for hrefs that cannot be matched by the regex.
	function isImage(settings, url) {
		return settings.get('photo') || settings.get('photoRegex').test(url);
	}

	function retinaUrl(settings, url) {
		return settings.get('retinaUrl') && window.devicePixelRatio > 1 ? url.replace(settings.get('photoRegex'), settings.get('retinaSuffix')) : url;
	}

	function trapFocus(e) {
		if ('contains' in $box[0] && !$box[0].contains(e.target) && e.target !== $overlay[0]) {
			e.stopPropagation();
			$box.focus();
		}
	}

	function setClass(str) {
		if (setClass.str !== str) {
			$box.add($overlay).removeClass(setClass.str).addClass(str);
			setClass.str = str;
		}
	}

	function getRelated(rel) {
		index = 0;

		if (rel && rel !== false && rel !== 'nofollow') {
			$related = $('.' + boxElement).filter(function () {
				var options = $.data(this, colorbox);
				var settings = new Settings(this, options);
				return (settings.get('rel') === rel);
			});
			index = $related.index(settings.el);

			// Check direct calls to Colorbox.
			if (index === -1) {
				$related = $related.add(settings.el);
				index = $related.length - 1;
			}
		} else {
			$related = $(settings.el);
		}
	}

	function trigger(event) {
		// for external use
		$(document).trigger(event);
		// for internal use
		$events.triggerHandler(event);
	}

	var slideshow = (function(){
		var active,
			className = prefix + "Slideshow_",
			click = "click." + prefix,
			timeOut;

		function clear () {
			clearTimeout(timeOut);
		}

		function set() {
			if (settings.get('loop') || $related[index + 1]) {
				clear();
				timeOut = setTimeout(publicMethod.next, settings.get('slideshowSpeed'));
			}
		}

		function start() {
			$slideshow
				.html(settings.get('slideshowStop'))
				.unbind(click)
				.one(click, stop);

			$events
				.bind(event_complete, set)
				.bind(event_load, clear);

			$box.removeClass(className + "off").addClass(className + "on");
		}

		function stop() {
			clear();

			$events
				.unbind(event_complete, set)
				.unbind(event_load, clear);

			$slideshow
				.html(settings.get('slideshowStart'))
				.unbind(click)
				.one(click, function () {
					publicMethod.next();
					start();
				});

			$box.removeClass(className + "on").addClass(className + "off");
		}

		function reset() {
			active = false;
			$slideshow.hide();
			clear();
			$events
				.unbind(event_complete, set)
				.unbind(event_load, clear);
			$box.removeClass(className + "off " + className + "on");
		}

		return function(){
			if (active) {
				if (!settings.get('slideshow')) {
					$events.unbind(event_cleanup, reset);
					reset();
				}
			} else {
				if (settings.get('slideshow') && $related[1]) {
					active = true;
					$events.one(event_cleanup, reset);
					if (settings.get('slideshowAuto')) {
						start();
					} else {
						stop();
					}
					$slideshow.show();
				}
			}
		};

	}());


	function launch(element) {
		var options;

		if (!closing) {

			options = $(element).data(colorbox);

			settings = new Settings(element, options);

			getRelated(settings.get('rel'));

			if (!open) {
				open = active = true; // Prevents the page-change action from queuing up if the visitor holds down the left or right keys.

				setClass(settings.get('className'));

				// Show colorbox so the sizes can be calculated in older versions of jQuery
				$box.css({visibility:'hidden', display:'block', opacity:''});

				$loaded = $tag(div, 'LoadedContent', 'width:0; height:0; overflow:hidden; visibility:hidden');
				$content.css({width:'', height:''}).append($loaded);

				// Cache values needed for size calculations
				interfaceHeight = $topBorder.height() + $bottomBorder.height() + $content.outerHeight(true) - $content.height();
				interfaceWidth = $leftBorder.width() + $rightBorder.width() + $content.outerWidth(true) - $content.width();
				loadedHeight = $loaded.outerHeight(true);
				loadedWidth = $loaded.outerWidth(true);

				// Opens inital empty Colorbox prior to content being loaded.
				var initialWidth = setSize(settings.get('initialWidth'), 'x');
				var initialHeight = setSize(settings.get('initialHeight'), 'y');
				var maxWidth = settings.get('maxWidth');
				var maxHeight = settings.get('maxHeight');

				settings.w = Math.max((maxWidth !== false ? Math.min(initialWidth, setSize(maxWidth, 'x')) : initialWidth) - loadedWidth - interfaceWidth, 0);
				settings.h = Math.max((maxHeight !== false ? Math.min(initialHeight, setSize(maxHeight, 'y')) : initialHeight) - loadedHeight - interfaceHeight, 0);

				$loaded.css({width:'', height:settings.h});
				publicMethod.position();

				trigger(event_open);
				settings.get('onOpen');

				$groupControls.add($title).hide();

				$box.focus();

				if (settings.get('trapFocus')) {
					// Confine focus to the modal
					// Uses event capturing that is not supported in IE8-
					if (document.addEventListener) {

						document.addEventListener('focus', trapFocus, true);

						$events.one(event_closed, function () {
							document.removeEventListener('focus', trapFocus, true);
						});
					}
				}

				// Return focus on closing
				if (settings.get('returnFocus')) {
					$events.one(event_closed, function () {
						$(settings.el).focus();
					});
				}
			}

			var opacity = parseFloat(settings.get('opacity'));
			$overlay.css({
				opacity: opacity === opacity ? opacity : '',
				cursor: settings.get('overlayClose') ? 'pointer' : '',
				visibility: 'visible'
			}).show();

			if (settings.get('closeButton')) {
				$close.html(settings.get('close')).appendTo($content);
			} else {
				$close.appendTo('<div/>'); // replace with .detach() when dropping jQuery < 1.4
			}

			load();
		}
	}

	// Colorbox's markup needs to be added to the DOM prior to being called
	// so that the browser will go ahead and load the CSS background images.
	function appendHTML() {
		if (!$box) {
			init = false;
			$window = $(window);
			$box = $tag(div).attr({
				id: colorbox,
				'class': $.support.opacity === false ? prefix + 'IE' : '', // class for optional IE8 & lower targeted CSS.
				role: 'dialog',
				tabindex: '-1'
			}).hide();
			$overlay = $tag(div, "Overlay").hide();
			$loadingOverlay = $([$tag(div, "LoadingOverlay")[0],$tag(div, "LoadingGraphic")[0]]);
			$wrap = $tag(div, "Wrapper");
			$content = $tag(div, "Content").append(
				$title = $tag(div, "Title"),
				$current = $tag(div, "Current"),
				$prev = $('<button type="button"/>').attr({id:prefix+'Previous'}),
				$next = $('<button type="button"/>').attr({id:prefix+'Next'}),
				$slideshow = $('<button type="button"/>').attr({id:prefix+'Slideshow'}),
				$loadingOverlay
			);

			$close = $('<button type="button"/>').attr({id:prefix+'Close'});

			$wrap.append( // The 3x3 Grid that makes up Colorbox
				$tag(div).append(
					$tag(div, "TopLeft"),
					$topBorder = $tag(div, "TopCenter"),
					$tag(div, "TopRight")
				),
				$tag(div, false, 'clear:left').append(
					$leftBorder = $tag(div, "MiddleLeft"),
					$content,
					$rightBorder = $tag(div, "MiddleRight")
				),
				$tag(div, false, 'clear:left').append(
					$tag(div, "BottomLeft"),
					$bottomBorder = $tag(div, "BottomCenter"),
					$tag(div, "BottomRight")
				)
			).find('div div').css({'float': 'left'});

			$loadingBay = $tag(div, false, 'position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;');

			$groupControls = $next.add($prev).add($current).add($slideshow);
		}
		if (document.body && !$box.parent().length) {
			$(document.body).append($overlay, $box.append($wrap, $loadingBay));
		}
	}

	// Add Colorbox's event bindings
	function addBindings() {
		function clickHandler(e) {
			// ignore non-left-mouse-clicks and clicks modified with ctrl / command, shift, or alt.
			// See: http://jacklmoore.com/notes/click-events/
			if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				launch(this);
			}
		}

		if ($box) {
			if (!init) {
				init = true;

				// Anonymous functions here keep the public method from being cached, thereby allowing them to be redefined on the fly.
				$next.click(function () {
					publicMethod.next();
				});
				$prev.click(function () {
					publicMethod.prev();
				});
				$close.click(function () {
					publicMethod.close();
				});
				$overlay.click(function () {
					if (settings.get('overlayClose')) {
						publicMethod.close();
					}
				});

				// Key Bindings
				$(document).bind('keydown.' + prefix, function (e) {
					var key = e.keyCode;
					if (open && settings.get('escKey') && key === 27) {
						e.preventDefault();
						publicMethod.close();
					}
					if (open && settings.get('arrowKey') && $related[1] && !e.altKey) {
						if (key === 37) {
							e.preventDefault();
							$prev.click();
						} else if (key === 39) {
							e.preventDefault();
							$next.click();
						}
					}
				});

				if ($.isFunction($.fn.on)) {
					// For jQuery 1.7+
					$(document).on('click.'+prefix, '.'+boxElement, clickHandler);
				} else {
					// For jQuery 1.3.x -> 1.6.x
					// This code is never reached in jQuery 1.9, so do not contact me about 'live' being removed.
					// This is not here for jQuery 1.9, it's here for legacy users.
					$('.'+boxElement).live('click.'+prefix, clickHandler);
				}
			}
			return true;
		}
		return false;
	}

	// Don't do anything if Colorbox already exists.
	if ($[colorbox]) {
		return;
	}

	// Append the HTML when the DOM loads
	$(appendHTML);


	// ****************
	// PUBLIC FUNCTIONS
	// Usage format: $.colorbox.close();
	// Usage from within an iframe: parent.jQuery.colorbox.close();
	// ****************

	publicMethod = $.fn[colorbox] = $[colorbox] = function (options, callback) {
		var settings;
		var $obj = this;

		options = options || {};

		if ($.isFunction($obj)) { // assume a call to $.colorbox
			$obj = $('<a/>');
			options.open = true;
		}

		if (!$obj[0]) { // colorbox being applied to empty collection
			return $obj;
		}

		appendHTML();

		if (addBindings()) {

			if (callback) {
				options.onComplete = callback;
			}

			$obj.each(function () {
				var old = $.data(this, colorbox) || {};
				$.data(this, colorbox, $.extend(old, options));
			}).addClass(boxElement);

			settings = new Settings($obj[0], options);

			if (settings.get('open')) {
				launch($obj[0]);
			}
		}

		return $obj;
	};

	publicMethod.position = function (speed, loadedCallback) {
		var
		css,
		top = 0,
		left = 0,
		offset = $box.offset(),
		scrollTop,
		scrollLeft;

		$window.unbind('resize.' + prefix);

		// remove the modal so that it doesn't influence the document width/height
		$box.css({top: -9e4, left: -9e4});

		scrollTop = $window.scrollTop();
		scrollLeft = $window.scrollLeft();

		if (settings.get('fixed')) {
			offset.top -= scrollTop;
			offset.left -= scrollLeft;
			$box.css({position: 'fixed'});
		} else {
			top = scrollTop;
			left = scrollLeft;
			$box.css({position: 'absolute'});
		}

		// keeps the top and left positions within the browser's viewport.
		if (settings.get('right') !== false) {
			left += Math.max($window.width() - settings.w - loadedWidth - interfaceWidth - setSize(settings.get('right'), 'x'), 0);
		} else if (settings.get('left') !== false) {
			left += setSize(settings.get('left'), 'x');
		} else {
			left += Math.round(Math.max($window.width() - settings.w - loadedWidth - interfaceWidth, 0) / 2);
		}

		if (settings.get('bottom') !== false) {
			top += Math.max(winheight() - settings.h - loadedHeight - interfaceHeight - setSize(settings.get('bottom'), 'y'), 0);
		} else if (settings.get('top') !== false) {
			top += setSize(settings.get('top'), 'y');
		} else {
			top += Math.round(Math.max(winheight() - settings.h - loadedHeight - interfaceHeight, 0) / 2);
		}

		$box.css({top: offset.top, left: offset.left, visibility:'visible'});

		// this gives the wrapper plenty of breathing room so it's floated contents can move around smoothly,
		// but it has to be shrank down around the size of div#colorbox when it's done.  If not,
		// it can invoke an obscure IE bug when using iframes.
		$wrap[0].style.width = $wrap[0].style.height = "9999px";

		function modalDimensions() {
			$topBorder[0].style.width = $bottomBorder[0].style.width = $content[0].style.width = (parseInt($box[0].style.width,10) - interfaceWidth)+'px';
			$content[0].style.height = $leftBorder[0].style.height = $rightBorder[0].style.height = (parseInt($box[0].style.height,10) - interfaceHeight)+'px';
		}

		css = {width: settings.w + loadedWidth + interfaceWidth, height: settings.h + loadedHeight + interfaceHeight, top: top, left: left};

		// setting the speed to 0 if the content hasn't changed size or position
		if (speed) {
			var tempSpeed = 0;
			$.each(css, function(i){
				if (css[i] !== previousCSS[i]) {
					tempSpeed = speed;
					return;
				}
			});
			speed = tempSpeed;
		}

		previousCSS = css;

		if (!speed) {
			$box.css(css);
		}

		$box.dequeue().animate(css, {
			duration: speed || 0,
			complete: function () {
				modalDimensions();

				active = false;

				// shrink the wrapper down to exactly the size of colorbox to avoid a bug in IE's iframe implementation.
				$wrap[0].style.width = (settings.w + loadedWidth + interfaceWidth) + "px";
				$wrap[0].style.height = (settings.h + loadedHeight + interfaceHeight) + "px";

				if (settings.get('reposition')) {
					setTimeout(function () {  // small delay before binding onresize due to an IE8 bug.
						$window.bind('resize.' + prefix, publicMethod.position);
					}, 1);
				}

				if ($.isFunction(loadedCallback)) {
					loadedCallback();
				}
			},
			step: modalDimensions
		});
	};

	publicMethod.resize = function (options) {
		var scrolltop;

		if (open) {
			options = options || {};

			if (options.width) {
				settings.w = setSize(options.width, 'x') - loadedWidth - interfaceWidth;
			}

			if (options.innerWidth) {
				settings.w = setSize(options.innerWidth, 'x');
			}

			$loaded.css({width: settings.w});

			if (options.height) {
				settings.h = setSize(options.height, 'y') - loadedHeight - interfaceHeight;
			}

			if (options.innerHeight) {
				settings.h = setSize(options.innerHeight, 'y');
			}

			if (!options.innerHeight && !options.height) {
				scrolltop = $loaded.scrollTop();
				$loaded.css({height: "auto"});
				settings.h = $loaded.height();
			}

			$loaded.css({height: settings.h});

			if(scrolltop) {
				$loaded.scrollTop(scrolltop);
			}

			publicMethod.position(settings.get('transition') === "none" ? 0 : settings.get('speed'));
		}
	};

	publicMethod.prep = function (object) {
		if (!open) {
			return;
		}

		var callback, speed = settings.get('transition') === "none" ? 0 : settings.get('speed');

		$loaded.remove();

		$loaded = $tag(div, 'LoadedContent').append(object);

		function getWidth() {
			settings.w = settings.w || $loaded.width();
			settings.w = settings.mw && settings.mw < settings.w ? settings.mw : settings.w;
			return settings.w;
		}
		function getHeight() {
			settings.h = settings.h || $loaded.height();
			settings.h = settings.mh && settings.mh < settings.h ? settings.mh : settings.h;
			return settings.h;
		}

		$loaded.hide()
		.appendTo($loadingBay.show())// content has to be appended to the DOM for accurate size calculations.
		.css({width: getWidth(), overflow: settings.get('scrolling') ? 'auto' : 'hidden'})
		.css({height: getHeight()})// sets the height independently from the width in case the new width influences the value of height.
		.prependTo($content);

		$loadingBay.hide();

		// floating the IMG removes the bottom line-height and fixed a problem where IE miscalculates the width of the parent element as 100% of the document width.

		$(photo).css({'float': 'none'});

		setClass(settings.get('className'));

		callback = function () {
			var total = $related.length,
				iframe,
				complete;

			if (!open) {
				return;
			}

			function removeFilter() { // Needed for IE8 in versions of jQuery prior to 1.7.2
				if ($.support.opacity === false) {
					$box[0].style.removeAttribute('filter');
				}
			}

			complete = function () {
				clearTimeout(loadingTimer);
				$loadingOverlay.hide();
				trigger(event_complete);
				settings.get('onComplete');
			};


			$title.html(settings.get('title')).show();
			$loaded.show();

			if (total > 1) { // handle grouping
				if (typeof settings.get('current') === "string") {
					$current.html(settings.get('current').replace('{current}', index + 1).replace('{total}', total)).show();
				}

				$next[(settings.get('loop') || index < total - 1) ? "show" : "hide"]().html(settings.get('next'));
				$prev[(settings.get('loop') || index) ? "show" : "hide"]().html(settings.get('previous'));

				slideshow();

				// Preloads images within a rel group
				if (settings.get('preloading')) {
					$.each([getIndex(-1), getIndex(1)], function(){
						var img,
							i = $related[this],
							settings = new Settings(i, $.data(i, colorbox)),
							src = settings.get('href');

						if (src && isImage(settings, src)) {
							src = retinaUrl(settings, src);
							img = document.createElement('img');
							img.src = src;
						}
					});
				}
			} else {
				$groupControls.hide();
			}

			if (settings.get('iframe')) {

				iframe = settings.get('createIframe');

				if (!settings.get('scrolling')) {
					iframe.scrolling = "no";
				}

				$(iframe)
					.attr({
						src: settings.get('href'),
						'class': prefix + 'Iframe'
					})
					.one('load', complete)
					.appendTo($loaded);

				$events.one(event_purge, function () {
					iframe.src = "//about:blank";
				});

				if (settings.get('fastIframe')) {
					$(iframe).trigger('load');
				}
			} else {
				complete();
			}

			if (settings.get('transition') === 'fade') {
				$box.fadeTo(speed, 1, removeFilter);
			} else {
				removeFilter();
			}
		};

		if (settings.get('transition') === 'fade') {
			$box.fadeTo(speed, 0, function () {
				publicMethod.position(0, callback);
			});
		} else {
			publicMethod.position(speed, callback);
		}
	};

	function load () {
		var href, setResize, prep = publicMethod.prep, $inline, request = ++requests;

		active = true;

		photo = false;

		trigger(event_purge);
		trigger(event_load);
		settings.get('onLoad');

		settings.h = settings.get('height') ?
				setSize(settings.get('height'), 'y') - loadedHeight - interfaceHeight :
				settings.get('innerHeight') && setSize(settings.get('innerHeight'), 'y');

		settings.w = settings.get('width') ?
				setSize(settings.get('width'), 'x') - loadedWidth - interfaceWidth :
				settings.get('innerWidth') && setSize(settings.get('innerWidth'), 'x');

		// Sets the minimum dimensions for use in image scaling
		settings.mw = settings.w;
		settings.mh = settings.h;

		// Re-evaluate the minimum width and height based on maxWidth and maxHeight values.
		// If the width or height exceed the maxWidth or maxHeight, use the maximum values instead.
		if (settings.get('maxWidth')) {
			settings.mw = setSize(settings.get('maxWidth'), 'x') - loadedWidth - interfaceWidth;
			settings.mw = settings.w && settings.w < settings.mw ? settings.w : settings.mw;
		}
		if (settings.get('maxHeight')) {
			settings.mh = setSize(settings.get('maxHeight'), 'y') - loadedHeight - interfaceHeight;
			settings.mh = settings.h && settings.h < settings.mh ? settings.h : settings.mh;
		}

		href = settings.get('href');

		loadingTimer = setTimeout(function () {
			$loadingOverlay.show();
		}, 100);

		if (settings.get('inline')) {
			var $target = $(href).eq(0);
			// Inserts an empty placeholder where inline content is being pulled from.
			// An event is bound to put inline content back when Colorbox closes or loads new content.
			$inline = $('<div>').hide().insertBefore($target);

			$events.one(event_purge, function () {
				$inline.replaceWith($target);
			});

			prep($target);
		} else if (settings.get('iframe')) {
			// IFrame element won't be added to the DOM until it is ready to be displayed,
			// to avoid problems with DOM-ready JS that might be trying to run in that iframe.
			prep(" ");
		} else if (settings.get('html')) {
			prep(settings.get('html'));
		} else if (isImage(settings, href)) {

			href = retinaUrl(settings, href);

			photo = settings.get('createImg');

			$(photo)
			.addClass(prefix + 'Photo')
			.bind('error.'+prefix,function () {
				prep($tag(div, 'Error').html(settings.get('imgError')));
			})
			.one('load', function () {
				if (request !== requests) {
					return;
				}

				// A small pause because some browsers will occasionally report a
				// img.width and img.height of zero immediately after the img.onload fires
				setTimeout(function(){
					var percent;

					if (settings.get('retinaImage') && window.devicePixelRatio > 1) {
						photo.height = photo.height / window.devicePixelRatio;
						photo.width = photo.width / window.devicePixelRatio;
					}

					if (settings.get('scalePhotos')) {
						setResize = function () {
							photo.height -= photo.height * percent;
							photo.width -= photo.width * percent;
						};
						if (settings.mw && photo.width > settings.mw) {
							percent = (photo.width - settings.mw) / photo.width;
							setResize();
						}
						if (settings.mh && photo.height > settings.mh) {
							percent = (photo.height - settings.mh) / photo.height;
							setResize();
						}
					}

					if (settings.h) {
						photo.style.marginTop = Math.max(settings.mh - photo.height, 0) / 2 + 'px';
					}

					if ($related[1] && (settings.get('loop') || $related[index + 1])) {
						photo.style.cursor = 'pointer';

						$(photo).bind('click.'+prefix, function () {
							publicMethod.next();
						});
					}

					photo.style.width = photo.width + 'px';
					photo.style.height = photo.height + 'px';
					prep(photo);
				}, 1);
			});

			photo.src = href;

		} else if (href) {
			$loadingBay.load(href, settings.get('data'), function (data, status) {
				if (request === requests) {
					prep(status === 'error' ? $tag(div, 'Error').html(settings.get('xhrError')) : $(this).contents());
				}
			});
		}
	}

	// Navigates to the next page/image in a set.
	publicMethod.next = function () {
		if (!active && $related[1] && (settings.get('loop') || $related[index + 1])) {
			index = getIndex(1);
			launch($related[index]);
		}
	};

	publicMethod.prev = function () {
		if (!active && $related[1] && (settings.get('loop') || index)) {
			index = getIndex(-1);
			launch($related[index]);
		}
	};

	// Note: to use this within an iframe use the following format: parent.jQuery.colorbox.close();
	publicMethod.close = function () {
		if (open && !closing) {

			closing = true;
			open = false;
			trigger(event_cleanup);
			settings.get('onCleanup');
			$window.unbind('.' + prefix);
			$overlay.fadeTo(settings.get('fadeOut') || 0, 0);

			$box.stop().fadeTo(settings.get('fadeOut') || 0, 0, function () {
				$box.hide();
				$overlay.hide();
				trigger(event_purge);
				$loaded.remove();

				setTimeout(function () {
					closing = false;
					trigger(event_closed);
					settings.get('onClosed');
				}, 1);
			});
		}
	};

	// Removes changes Colorbox made to the document, but does not remove the plugin.
	publicMethod.remove = function () {
		if (!$box) { return; }

		$box.stop();
		$[colorbox].close();
		$box.stop(false, true).remove();
		$overlay.remove();
		closing = false;
		$box = null;
		$('.' + boxElement)
			.removeData(colorbox)
			.removeClass(boxElement);

		$(document).unbind('click.'+prefix).unbind('keydown.'+prefix);
	};

	// A method for fetching the current element Colorbox is referencing.
	// returns a jQuery object.
	publicMethod.element = function () {
		return $(settings.el);
	};

	publicMethod.settings = defaults;

}(jQuery, document, window));

/*! lazysizes - v5.1.2 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}("undefined"!=typeof window?window:{},function(a,b){"use strict";var c,d;if(function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b])}(),!b||!b.getElementsByClassName)return{init:function(){},cfg:d,noSupport:!0};var e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("Event");return e||(e={}),e.instance=c,h.initEvent(d,!f,!g),h.detail=e,a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?(c&&c.src&&!b[i]("srcset")&&b.setAttribute("srcset",c.src),e({reevaluate:!0,elements:[b]})):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=d.throttleDelay,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&g>49?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=!0===a)&&(g=33),b||(b=!0,d=e-(f.now()-c),d<0&&(d=0),a||d<9?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;a<d?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}},D=function(){var g,m,o,p,y,D,F,G,H,I,J,K,L=/^img$/i,M=/^iframe$/i,N="onscroll"in a&&!/(gle|ing)bot/.test(navigator.userAgent),O=0,P=0,Q=0,R=-1,S=function(a){Q--,(!a||Q<0||!a.target)&&(Q=0)},T=function(a){return null==K&&(K="hidden"==x(b.body,"visibility")),K||!("hidden"==x(a.parentNode,"visibility")&&"hidden"==x(a,"visibility"))},U=function(a,c){var d,f=a,g=T(a);for(G-=c,J+=c,H-=c,I+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)(g=(x(f,"opacity")||1)>0)&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=I>d.left&&H<d.right&&J>d.top-1&&G<d.bottom+1);return g},V=function(){var a,f,h,j,k,l,n,o,q,r,s,t,u=c.elements;if((p=d.loadMode)&&Q<8&&(a=u.length)){for(f=0,R++;f<a;f++)if(u[f]&&!u[f]._lazyRace)if(!N||c.prematureUnveil&&c.prematureUnveil(u[f]))ba(u[f]);else if((o=u[f][i]("data-expand"))&&(l=1*o)||(l=P),r||(r=!d.expand||d.expand<1?e.clientHeight>500&&e.clientWidth>500?500:370:d.expand,c._defEx=r,s=r*d.expFactor,t=d.hFac,K=null,P<s&&Q<1&&R>2&&p>2&&!b.hidden?(P=s,R=0):P=p>1&&R>1&&Q<6?r:O),q!==l&&(D=innerWidth+l*t,F=innerHeight+l,n=-1*l,q=l),h=u[f].getBoundingClientRect(),(J=h.bottom)>=n&&(G=h.top)<=F&&(I=h.right)>=n*t&&(H=h.left)<=D&&(J||I||H||G)&&(d.loadHidden||T(u[f]))&&(m&&Q<3&&!o&&(p<3||R<4)||U(u[f],l))){if(ba(u[f]),k=!0,Q>9)break}else!k&&m&&!j&&Q<4&&R<4&&p>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!o&&(J||I||H||G||"auto"!=u[f][i](d.sizesAttr)))&&(j=g[0]||u[f]);j&&!k&&ba(j)}},W=B(V),X=function(a){var b=a.target;if(b._lazyCache)return void delete b._lazyCache;S(a),s(b,d.loadedClass),t(b,d.loadingClass),u(b,Z),v(b,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,e,f){var g,h,j,l,m,p;(m=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),m={target:a},s(a,d.loadingClass),p&&(clearTimeout(o),o=k(S,2500),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(M.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){var b=a.complete&&a.naturalWidth>1;p&&!b||(b&&s(a,"ls-is-cached"),X(m),a._lazyCache=!0,k(function(){"_lazyCache"in a&&delete a._lazyCache},9)),"lazy"==a.loading&&Q--},!0)}),ba=function(a){if(!a._lazyRace){var b,c=L.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&m||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,Q++,aa(a,b,f,e,c))}},ca=C(function(){d.loadMode=3,W()}),da=function(){3==d.loadMode&&(d.loadMode=2),ca()},ea=function(){if(!m){if(f.now()-y<999)return void k(ea,999);m=!0,d.loadMode=3,W(),j("scroll",da,!0)}};return{_:function(){y=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),j("scroll",W,!0),j("resize",W,!0),j("pageshow",function(a){if(a.persisted){var c=b.querySelectorAll("."+d.loadingClass);c.length&&c.forEach&&l(function(){c.forEach(function(a){a.complete&&ba(a)})})}}),a.MutationObserver?new MutationObserver(W).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",W,!0),e[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ea():(j("load",ea),b[h]("DOMContentLoaded",W),k(ea,2e4)),c.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba,_aLSL:da}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;f<g;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width)&&d!==a._lazysizesWidth&&c(a,f,e,d))},f=function(){var b,c=a.length;if(c)for(b=0;b<c;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){!F.i&&b.getElementsByClassName&&(F.i=!0,E._(),D._())};return k(function(){d.init&&F()}),c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}});
jQuery.fn.putCursorAtEnd = function() {
    return this.each(function() {
        $(this).focus()
        // If this function exists...
        if (this.setSelectionRange) {
            // ... then use it (Doesn't work in IE)
            // Double the length because Opera is inconsistent about whether a carriage return is one character or two. Sigh.
            var len = $(this).text().length * 2;
            this.setSelectionRange(len, len);
        } else {
            // ... otherwise replace the contents with itself
            // (Doesn't work in Google Chrome)
            $(this).text($(this).text());
        }
    });
};

var ScrollOut=function(){"use strict"
function O(e,t,n){return e<t?t:n<e?n:e}function T(e){return+(0<e)-+(e<0)}var t={}
function u(e){return t[e]||(t[e]=e.replace(/([A-Z])/g,n))}function n(e){return"-"+e[0].toLowerCase()}var q=window,r=document.documentElement
function v(e,t){return e&&0!==e.length?e.nodeName?[e]:[].slice.call(e[0].nodeName?e:(t||r).querySelectorAll(e)):[]}var F,d=function(e,t){for(var n in t)e.setAttribute("data-"+u(n),t[n])},N=[]
function z(){N.slice().forEach(function(e){return e()}),F=N.length?requestAnimationFrame(z):0}function h(){}var g="scroll",m="resize",p="addEventListener",X="removeEventListener"
return function(P){var i,H,L,W,A,o=(P=P||{}).onChange||h,l=P.onHidden||h,c=P.onShown||h,s=P.onScroll||h,f=P.cssProps?(i=P.cssProps,function(e,t){for(var n in t)(!0===i||i[n])&&e.style.setProperty("--"+u(n),(r=t[n],Math.round(1e4*r)/1e4))
var r}):h,e=P.scrollingElement,E=e?v(e)[0]:q,C=e?v(e)[0]:r,S=!1,x={}
function t(){H=v(P.targets||"[data-scroll]",v(P.scope||C)[0]).map(function(e){return{element:e}})}function n(){var e,t,n=C.clientWidth,r=C.clientHeight,i=T(-W+(W=C.scrollLeft||q.pageXOffset)),o=T(-A+(A=C.scrollTop||q.pageYOffset)),l=C.scrollLeft/(C.scrollWidth-n||1),c=C.scrollTop/(C.scrollHeight-r||1)
S=S||x.scrollDirX!==i||x.scrollDirY!==o||x.scrollPercentX!==l||x.scrollPercentY!==c,x.scrollDirX=i,x.scrollDirY=o,x.scrollPercentX=l,x.scrollPercentY=c
for(var s=0;s<H.length;s++){for(var f=H[s],a=f.element,u=a,v=0,d=0;v+=u.offsetLeft,d+=u.offsetTop,(u=u.offsetParent)&&u!==E;);var h=a.clientHeight||a.offsetHeight||0,g=a.clientWidth||a.offsetWidth||0,m=(O(v+g,W,W+n)-O(v,W,W+n))/g,p=(O(d+h,A,A+r)-O(d,A,A+r))/h,X=1===m?0:T(v-W),Y=1===p?0:T(d-A),b=O((W-(g/2+v-n/2))/(n/2),-1,1),_=O((A-(h/2+d-r/2))/(r/2),-1,1),w=+(P.offset?P.offset<=A:(P.threshold||0)<m*p),D=f.visible!==w;(D||f._changed||f.visible!==w||f.visibleX!==m||f.visibleY!==p||f.index!==s||f.elementHeight!==h||f.elementWidth!==g||f.offsetX!==v||f.offsetY!==d||f.intersectX!=f.intersectX||f.intersectY!=f.intersectY||f.viewportX!==b||f.viewportY!==_)&&(e=!0,f._changed=!0,f._visibleChanged=D,f.visible=w,f.elementHeight=h,f.elementWidth=g,f.index=s,f.offsetX=v,f.visibleX=m,f.visibleY=p,f.intersectX=X,f.intersectY=Y,f.viewportX=b,f.viewportY=_,f.visible=w)}(!L&&e||x.__changed__)&&(t=y,N.push(t),F||z(),L=function(){!(N=N.filter(function(e){return e!==t})).length&&F&&(F=0,cancelAnimationFrame(F))})}function y(){if(H){S&&(S=!1,d(C,{scrollDirX:x.scrollDirX,scrollDirY:x.scrollDirY}),f(C,x),s(C,x,H))
for(var e=H.length-1;-1<e;e--){var t=H[e],n=t.element,r=t.visible
t._changed&&(t._changed=!1,f(n,t)),t._visibleChanged&&(d(n,{scroll:r?"in":"out"}),o(n,t,C),(r?c:l)(n,t,C)),r&&P.once&&H.splice(e,1)}a()}}function a(){L&&(L(),L=void 0)}return t(),n(),q[p](m,n),E[p](g,n),{index:t,update:n,teardown:function(){a(),q[X](m,n),E[X](g,n)}}}}()

jQuery(document).ready(function ($) {


    $('#masker').click(function (e) {
        hideCart();
    });

    window.setCartCount = function (count) {
        if (count == 0) {
            $('.cartcount').hide();
        } else {
            $('.cartcount').text(count);
            $('.cartcount').show();
        }
    }



    window.adjustQty = function (url) {
        $('.waitaminute').addClass('active');
        console.log("Adjusting", url);
        $.ajax(url, {
            cache: false,
            dataType: 'html',
            success: function (data, a, e) {
                //console.log("success", data);
            },
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
                $('.waitaminute').removeClass('active');
            },
            complete: function (data, status) {
                console.log('Got the cart.');
                refreshCart();
            }
        });
    }

    window.deletecartitem = function (item) {
        var url = '/cart/change?line=' + item + '&amp;quantity=0';
        console.log(url);
        adjustQty(url);
        // They just removed this item, so the number should now
        // be the same, but the next time in the cart.
        removeSubsequentIfTemplate(item);
    };

    window.removeSubsequentIfTemplate = function ( item ) {
        console.log(item, "in ", 'removeSubsequentIfTemplate');
        var url = '/cart.js';
        console.log(url);
        $.ajax(url, {
            cache: false,
            dataType: 'json',
            success: function (data, a, e) {
                console.log('data', data);
                //console.log("success in validateDecals", data);
                $(data.items).each(function (index, value) {
                    console.log(index, item, value.handle);
                    // cart numbers start at 1 not at zero
                    if (
                        (value.handle === 'extra-template')
                        &&
                        (parseInt(item) === parseInt(index))
                    ) {
                        console.log("MATCHES");
                        let url2 = '/cart/change?line=' + (index) + '&amp;quantity=0';
                        console.log(url2);
                        adjustQty(url2);
                    }
                })
            },
            error: function (xhqr, status, error) {
                console.log('error in removeSubsequentIfTemplate');
                console.log(status);
            },
            complete: function (data, status) {
                console.log(data, 'data');
            }
        });

    }

    window.decrementCartItem = function (item, currentQty) {
        currentQty = parseInt(currentQty) - 1;
        var url = '/cart/change?line=' + item + '&amp;quantity=' + currentQty;
        adjustQty(url);
    };

    window.incrementCartItem = function (item, currentQty) {
        currentQty = parseInt(currentQty) + 1;
        var url = '/cart/change?line=' + item + '&amp;quantity=' + currentQty;
        adjustQty(url);
    };

    window.decrementCartItemByNumber = function (item, currentQty, howMany) {
        currentQty = parseInt(currentQty) - parseInt(howMany);
        var url = '/cart/change?line=' + item + '&amp;quantity=' + currentQty;
        adjustQty(url);
    };

    window.incrementCartItemByNumber = function (item, currentQty, howMany) {
        currentQty = parseInt(currentQty) + parseInt(howMany);
        var url = '/cart/change?line=' + item + '&amp;quantity=' + currentQty;
        adjustQty(url);
    };

    /**
     * it is possible for users to add the exact same decal set to the cart twice, resulting in
     * "1 set of 6 chars" for a 3-letter number (i.e. qty gets doubled). This will fix.
     */
    window.validateDecals = function () {
        var url = '/cart.js';
        $.ajax(url, {
            cache: false,
            dataType: 'json',
            success: function (data, a, e) {
                //console.log("success in validateDecals", data);
                $(data.items).each(function (index, value) {
                    if (value.handle == 'mailbox-numbers-letters') {
                        // return getTextLengthForSpecificString(this.text); // consider migrating the following to the global function.
                        var string = value.properties['House-numbers'].trim().split('').filter(function (currentValue, index, arr) {
                            var code = arr[index].charCodeAt(0);
                            return ((code != 32) && (code != 160));
                        });
                        var length = parseInt(string.length);
                        var quantity = parseInt(value.quantity);
                        if (length != quantity) {
                            console.log('will set new qty to ' + length);
                            var request = {
                                quantity: length,
                                id: value.key
                            };
                            console.log(request);
                            jQuery.post('/cart/change.js',
                                request,
                                function (response) {
                                    console.log(response);
                                    refreshCart();
                                }, 'json');
                        }
                    }
                })
            },
            error: function (xhqr, status, error) {
                console.log('error in validateDecals');
                console.log(status);
            },
            complete: function (data, status) {

            }
        });
    }

    window.incrementDecal = function (item, size, num_sets, numbers, color, font) {
        window.size = size;
        window.num_sets = parseInt(num_sets.replace(' sets', '').replace(' set', ''));
        window.numbers = numbers;
        window.color = color;
        window.font = font;
        $('.waitaminute').addClass('active');
        var url = '/cart/change?line=' + item + '&amp;quantity=0';
        $.ajax(url, {
            cache: false,
            dataType: 'html',
            success: function (data, a, e) {
                // console.log("success", data);
            },
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
                $('.waitaminute').removeClass('active');
            },
            complete: function (data, status) {
                // console.log('Got the cart.');
                // now, add it!
                $.ajax('/products/mailbox-numbers-letters.js', {
                    cache: false,
                    dataType: 'json',
                    success: function (data, a, e) {
                        $(data.variants).each(function (index, value) {
                            // console.log('variation', value);
                            var thisQty = parseInt(value.option2.replace(' sets', '').replace(' set', ''));
                            var thisSize = parseInt(value.option1.replace('" vinyl number', '').replace('"', ''));
                            var thisVariationId = value.id;
                            // console.log('comparing', (window.num_sets + 1), thisQty, 'and', window.size, thisSize );
                            if (((window.num_sets + 1) == thisQty) && (window.size == thisSize)) {
                                var item = {
                                    quantity: window.numbers.trim().replace(' ', '').length,
                                    id: thisVariationId,
                                    properties: {
                                        'Typeface': window.font,
                                        'House-numbers': window.numbers,
                                        'Mailbox-color': window.color
                                    }
                                };
                                //console.log('adding', item);
                                jQuery.post('/cart/add.js', {
                                    items: [
                                        item
                                    ]
                                }, function (response) {
                                    refreshCart();
                                }, 'json');

                            }
                        });
                    },
                    error: function (xhqr, status, error) {
                        console.log('error');
                        console.log(status);
                    },
                    complete: function (data, status) {
                        // console.log('complete');
                        //console.log(status);
                    }
                });
            }
        });
    }

    window.decrementDecal = function (item, size, num_sets, numbers, color, font) {
        window.size = size;
        window.num_sets = parseInt(num_sets.replace(' sets', '').replace(' set', ''));
        window.numbers = numbers;
        window.color = color;
        window.font = font;
        $('.waitaminute').addClass('active');
        var url = '/cart/change?line=' + item + '&amp;quantity=0';
        $.ajax(url, {
            cache: false,
            dataType: 'html',
            success: function (data, a, e) {
                // console.log("success", data);
            },
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
                $('.waitaminute').removeClass('active');
            },
            complete: function (data, status) {
                //console.log('Got the cart.');
                // now, add it!
                $.ajax('/products/mailbox-numbers-letters.js', {
                    cache: false,
                    dataType: 'json',
                    success: function (data, a, e) {
                        $(data.variants).each(function (index, value) {
                            // console.log('variation', value);
                            var thisQty = parseInt(value.option2.replace(' sets', '').replace(' set', ''));
                            var thisSize = parseInt(value.option1.replace('" vinyl number', '').replace('"', ''));
                            var thisVariationId = value.id;
                            //console.log('comparing', (window.num_sets + 1), thisQty, 'and', window.size, thisSize );
                            if (((window.num_sets - 1) == thisQty) && (window.size == thisSize)) {
                                var item = {
                                    quantity: window.numbers.length,
                                    id: thisVariationId,
                                    properties: {
                                        'Typeface': window.font,
                                        'House-numbers': window.numbers,
                                        'Mailbox-color': window.color
                                    }
                                };
                                //console.log('adding', item);
                                jQuery.post('/cart/add.js', {
                                    items: [
                                        item
                                    ]
                                }, function (response) {
                                    refreshCart();
                                }, 'json');

                            }
                        });
                    },
                    error: function (xhqr, status, error) {
                        console.log('error');
                        console.log(status);
                    },
                    complete: function (data, status) {
                        //console.log('complete');
                        //console.log(status);
                    }
                });
            }
        });
    }


    var showCart = function () {
        $('.waitaminute').addClass('active');
        $('#modalcart').addClass('active');
        $('body').addClass('h-full overflow-hidden');
        $('#masker').fadeIn(200);
        $.ajax('/pages/minimal-cart', {
            cache: false,
            dataType: 'html',
            success: function (data, a, e) {
                $('#modalcart .payload').html(data);

            },
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                $('#modalcart').removeClass('fixed');

                window.setTimeout(function () {
                    var payloadheight = $('#modalcart .payload').height();
                    var actionbuttons = $('#modalcart .actionbuttons').height();
                    var cartheader = $('#modalcart .cartheader').outerHeight();
                    var windowheight = $(window).height();

                    if (((cartheader + payloadheight) > windowheight) && (!navigator.userAgent.match(/iPhone|iPad|iPod/i))) {
                        $('#modalcart').addClass('fixed');
                    } else {
                        $('#modalcart').removeClass('fixed');
                    }
                    $('.waitaminute').removeClass('active');
                }, 220);

                if ($('#modalcart .payload').find('.cartlineitem').length) {
                    showDefaultShipping();
                }
            }
        });
    }

    window.refreshCart = function () {
        if (window.location.href.indexOf('cart') < 0) {
            showCart();
        } else {
            window.location = "/cart";
        }
    };

    var showDefaultShipping = function () {
        // US
        var e = {
            zip: '85701',
            country: "US",
            province: "AZ"
        };
        _getCartShippingRatesForDestination(e, $('.shipping_cost'));
    }

    var _getCartShippingRatesForDestination = function (e, target) {

        var t = {
            type: "POST",
            url: "/cart/prepare_shipping_rates",
            data: jQuery.param(
                {shipping_address: e}),
            success: _pollForCartShippingRatesForDestination(e, target),
            error: _onError
        };
        jQuery.ajax(t)
    }
    var _pollForCartShippingRatesForDestination = function (e, target) {

        var t = function () {
            jQuery.ajax("/cart/async_shipping_rates", {
                dataType: "json",
                success: function (r, n, a) {
                    if (r == null) {
                        target.html('tbd');
                    } else {
                        if (r.shipping_rates[0].price == '0.00') {
                            target.html('tbd');
                        } else {
                            target.html('$' + r.shipping_rates[0].price);
                        }
                    }
                },
                error: _onError
            })
        };
        return t
    };

    window.adjustShippingPreview = function (options) {
        var country = options.find('option:selected').val();
        var e = {
            zip: '85701',
            country: "US",
            province: "AZ"
        };
        if (country == 'CA') {
            e = {
                zip: 'M5S 1G5',
                country: "CA",
                province: "Ontario"
            };
        } else if (country == 'AU') {
            e = {
                zip: '2580',
                country: "NZ",
                province: "Auckland"
            };
        } else if (country == 'OTHER') {
            e = {
                zip: 'N13 4XS',
                country: "FR",
                province: "Paris"
            };
        }
        _getCartShippingRatesForDestination(e, $('.shipping_cost'));
    };

    var _onError = function (XMLHttpRequest, textStatus) {
        console.log("err" + textStatus);
    };

    $('.cartheader .closebox').click(function (e) {
        e.preventDefault();
        hideCart();
    });

    $('.showcart').click(function (e) {
        e.preventDefault();
        hideMobileMenu();
        var windowwidth = $(window).width();
        //console.log(windowwidth);
        if ((num_lines_in_cart > 5) && (windowwidth > 768)) {
            window.location = '/cart';
        } else {
            showCart();
        }
    });

    var hideCart = function () {
        $('#modalcart').removeClass('active');
        $('#masker').hide();
        $('body').removeClass('h-full overflow-hidden');
    }

    var is_cart = window.location.href.slice(window.location.href.indexOf('?') + 1);
    if (is_cart == 'cart') {
        showCart();
    }

    if (window.location.href.indexOf('cart') > 0) {
        showDefaultShipping();
    }
});

/*

https://github.com/BrOrlandi/big-text.js


Brorlandi/big-text.js v1.0.0, 2017
Adapted from DanielHoffmann/jquery-bigtext, v1.3.0, May 2014

And from Jetroid/bigtext.js v1.0.0, September 2016

Usage:
BigText("#myElement",{
	fontSizeFactor: {Number}, (0.8)
	maximumFontSize: {Number}, (null)
	limitingDimension: {String}, ("both")
	horizontalAlign: {String}, ("center")
	verticalAlign: {String}, ("center")
	textAlign: {String}, ("center")
	whiteSpace: {String}, ("nowrap")
});


Original Projects:
https://github.com/DanielHoffmann/jquery-bigtext
https://github.com/Jetroid/bigtext.js

Options:


fontSizeFactor: This option is used to give some vertical spacing for letters that overflow the line-height (like 'g', 'Á' and most other accentuated uppercase letters). This does not affect the font-size if the limiting factor is the width of the parent div. The default is 0.8

maximumFontSize: maximum font size to use.

limitingDimension: In which dimension the font size should be limited. Possible values: "width", "height" or "both". Defaults to both. Using this option with values different than "both" overwrites the element parent width or height.

horizontalAlign: Where to align the text horizontally. Possible values: "left", "center", "right". Defaults to "center".

verticalAlign: Where to align the text vertically. Possible values: "top", "center", "bottom". Defaults to "center".

textAlign: Sets the text align of the element. Possible values: "left", "center", "right". Defaults to "center". This option is only useful if there are linebreaks (<br> tags) inside the text.

whiteSpace: Sets whitespace handling. Possible values: "nowrap", "pre". Defaults to "nowrap". (Can also be set to enable wrapping but this doesn't work well.)

Bruno Orlandi - 2017

Copyright (C) 2013 Daniel Hoffmann Bernardes, Ícaro Technologies
Copyright (C) 2016 Jet Holt

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

function _calculateInnerDimensions(computedStyle){
    //Calculate the inner width and height
    var innerWidth;
    var innerHeight;

    var width = parseInt(computedStyle.getPropertyValue("width"));
    var height = parseInt(computedStyle.getPropertyValue("height"));
    var paddingLeft = parseInt(computedStyle.getPropertyValue("padding-left"));
    var paddingRight = parseInt(computedStyle.getPropertyValue("padding-right"));
    var paddingTop = parseInt(computedStyle.getPropertyValue("padding-top"));
    var paddingBottom = parseInt(computedStyle.getPropertyValue("padding-bottom"));
    var borderLeft = parseInt(computedStyle.getPropertyValue("border-left-width"));
    var borderRight = parseInt(computedStyle.getPropertyValue("border-right-width"));
    var borderTop = parseInt(computedStyle.getPropertyValue("border-top-width"));
    var borderBottom = parseInt(computedStyle.getPropertyValue("border-bottom-width"));

    //If box-sizing is border-box, we need to subtract padding and border.
    var parentBoxSizing = computedStyle.getPropertyValue("box-sizing");
    if(parentBoxSizing == "border-box"){
        innerWidth = width - (paddingLeft + paddingRight + borderLeft + borderRight);
        innerHeight = height - (paddingTop + paddingBottom + borderTop + borderBottom);
    }else{
        innerWidth = width;
        innerHeight = height;
    }
    var obj = {};
    obj["width"] = innerWidth;
    obj["height"] = innerHeight;

    return obj;
}

var BigText = function(element, options){


    if (typeof element === 'string') {
        element = document.querySelector(element);
    } else if (element.length) {
        // Support for array based queries (such as jQuery)
        element = element[0];
    }

    var defaultOptions = {
        fontSizeFactor: 0.8,
        maximumFontSize: null,
        limitingDimension: "both",
        horizontalAlign: "center",
        verticalAlign: "center",
        textAlign: "center",
        whiteSpace: "nowrap"
    };

    //Merge provided options and default options
    options = options || {};
    for (var opt in defaultOptions)
        if (defaultOptions.hasOwnProperty(opt) && !options.hasOwnProperty(opt))
            options[opt] = defaultOptions[opt];

    //Get variables which we will reference frequently
    var style = element.style;

    var computedStyle = document.defaultView.getComputedStyle(element);
    var parent = element.parentNode;
    var parentStyle = parent.style;
    var parentComputedStyle = document.defaultView.getComputedStyle(parent);

    //hides the element to prevent "flashing"
    style.visibility = "hidden";

    //Set some properties
    style.display = "inline-block";
    style.clear = "both";
    style.float = "left";
    style.fontSize = (1000 * options.fontSizeFactor) + "px";
    style.lineHeight = "1000px";
    style.whiteSpace = options.whiteSpace;
    style.textAlign = options.textAlign;
    style.position = "relative";
    style.padding = 0;
    style.margin = 0;
    style.left = "50%";
    style.top = "50%";

    //Get properties of parent to allow easier referencing later.
    var parentPadding = {
        top: parseInt(parentComputedStyle.getPropertyValue("padding-top")),
        right: parseInt(parentComputedStyle.getPropertyValue("padding-right")),
        bottom: parseInt(parentComputedStyle.getPropertyValue("padding-bottom")),
        left: parseInt(parentComputedStyle.getPropertyValue("padding-left")),
    };
    var parentBorder = {
        top: parseInt(parentComputedStyle.getPropertyValue("border-top")),
        right: parseInt(parentComputedStyle.getPropertyValue("border-right")),
        bottom: parseInt(parentComputedStyle.getPropertyValue("border-bottom")),
        left: parseInt(parentComputedStyle.getPropertyValue("border-left")),
    };

    //Calculate the parent inner width and height
    var parentInnerDimensions = _calculateInnerDimensions(parentComputedStyle);
    var parentInnerWidth = parentInnerDimensions["width"];
    var parentInnerHeight = parentInnerDimensions["height"];

    var box = {
        width: element.offsetWidth, //Note: This is slightly larger than the jQuery version
        height: element.offsetHeight,
    };

    var widthFactor = (parentInnerWidth - parentPadding.left - parentPadding.right) / box.width;
    var heightFactor = (parentInnerHeight - parentPadding.top - parentPadding.bottom) / box.height;
    var lineHeight;

    if (options.limitingDimension.toLowerCase() === "width") {
        lineHeight= Math.floor(widthFactor * 1000);
        parentStyle.height = lineHeight + "px";
    } else if (options.limitingDimension.toLowerCase() === "height") {
        lineHeight= Math.floor(heightFactor * 1000);
    } else if (widthFactor < heightFactor)
        lineHeight= Math.floor(widthFactor * 1000);
    else if (widthFactor >= heightFactor)
        lineHeight= Math.floor(heightFactor * 1000);

    var fontSize = lineHeight * options.fontSizeFactor;
    if (options.maximumFontSize !== null && fontSize > options.maximumFontSize) {
        fontSize = options.maximumFontSize;
        lineHeight = fontSize / options.fontSizeFactor;
    }


    style.fontSize = Math.floor(fontSize) + "px";
    style.lineHeight = Math.ceil(lineHeight)  + "px";
    style.marginBottom = "0px";
    style.marginRight = "0px";

    if (options.limitingDimension.toLowerCase() === "height") {
        //this option needs the font-size to be set already so computedStyle.getPropertyValue("width") returns the right size
        //this +4 is to compensate the rounding erros that can occur due to the calls to Math.floor in the centering code
        parentStyle.width = (parseInt(computedStyle.getPropertyValue("width")) + 4) + "px";
    }

    //Calculate the inner width and height
    var innerDimensions = _calculateInnerDimensions(computedStyle);
    var innerWidth = innerDimensions["width"];
    var innerHeight = innerDimensions["height"];


    switch(options.verticalAlign.toLowerCase()) {
        case "top":
            style.top = "0%";
            break;
        case "bottom":
            style.top = "100%";
            var numChars = jQuery(element).text().length;
            var fontHeight = parseInt(jQuery(element).css('font-size').replace('px',''));
            // console.log(fontHeight);
            // style.marginTop = Math.floor(((innerHeight - fontHeight)/2)) + "px";
            if (numChars == 4 ) {
                style.marginTop = Math.floor(-innerHeight + 20 ) + "px";
            } else if (numChars == 5) {
                style.marginTop = Math.floor(-innerHeight + 44 ) + "px";
            } else if (numChars == 6) {
                style.marginTop = Math.floor(-innerHeight + 60 ) + "px";
            } else {
                style.marginTop = Math.floor(-innerHeight + 20) + "px";
            }
            break;
        default:
            style.marginTop = Math.floor((-innerHeight / 2)) + "px";
            break;
    }

    switch(options.horizontalAlign.toLowerCase()) {
        case "left":
            style.left = "0%";
            break;
        case "right":
            style.left = "100%";
            style.marginLeft = Math.floor(-innerWidth) + "px";
            break;
        default:
            style.marginLeft = Math.floor((-innerWidth / 2)) + "px";
            break;
    }


    // iej
    if (options.verticalAlign.toLowerCase() === "center") {
        lineHeight = innerDimensions["height"];
        style.lineHeight = Math.ceil(lineHeight)  + "px";
    }

    //shows the element after the work is done
    style.visibility = "visible";
    return element;
}


class decalcalculator {

    saveAndCalc(data, a, e) {
        //console.log(data);
        calc.product = data;
        calc.recalc();
    }

    getProductData() {

        $.ajax('/products/mailbox-numbers-letters.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalc,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                //console.log('complete');
                //console.log(status);
            }
        });
    }


    init() {

        this.maxLength = 50;
        this.textDefault = '123Abc';

        window.has_rendered_once = false;

        window.user_has_modified_preview_text = false;

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font != 'palmsprings') this.setFont(this.font);

        this.qty = this.getDefault('qty', '2');
        if (this.qty != '2') this.setQty(this.qty);

        this.size = this.getDefault('size', '3');
        if (this.size != '3') this.setSize(this.size);

        this.color = this.getDefault('color', 'silver');
        if (this.color != 'silver') this.setColor(this.color);

        this.text = this.getDefault('text', this.textDefault);
        this.setText(this.text);

        if (this.text != this.textDefault) {
            window.user_has_modified_preview_text = true;
        }

        this.recalc();

        this.getProductData();

        this.reset_url();
    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin',
            'soho': 'SoHo',
            'backbay': 'Backbay',
            'southbeach': 'South Beach',
            'santabarbara': 'Santa Barbara'
        }
        return names[key];
    };


    getNiceColorName(key) {
        if (key == "bronze") {
            return "Dark Bronze";
        } else {
            return key;
        }
    };


    setFont(font) {
        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);

        // extra fancy stuff.


        //var height = $('#previewsection').height();
        //$('#previewsection').css('height', height);
        // $('#previewsection').css('overflow', 'hidden');
        //$('#previewsection .previewimagewrapper').hide();
        //var slideshowSelector = '#previewsection .previewimagewrapper';
        //$(slideshowSelector).fadeIn(250, function () {
        //   var flkty = new Flickity('#previewsection');
            //flkty.select(0, false, true);
        //   flkty.resize();
        //});

        // guide next
        this.bumpSlideshow('.main-carousel.fonts', font);
        this.setGuidePicker('font', font);

        this.recalc();
    }

    setQty(qty) {
        this.qty = qty;
        this.setCookie('qty', qty, 7);

        // first the picker
        this.setPicker("#qty-picker", 'qty', qty);

        // now the guide
        this.bumpSlideshow('.main-carousel.qty', 'qty' + qty);
        this.setGuidePicker('qty', qty);


        this.recalc();
    }

    setSize(size) {
        var possibleSizes = [1, 2, 3, 4, 6, 8, 12];
        if (possibleSizes.indexOf(parseInt(size)) == -1) {
            size = 3;
        }

        this.size = size;
        this.setCookie('size', size, 7);

        // first the picker
        this.setPicker("#size-picker", 'size', size);

        // now the guide
        this.bumpSlideshow('.main-carousel.size', 'size' + size);
        this.setGuidePicker('size', size);

        this.recalc();
    }

    setColor(color) {
        this.color = color;
        this.setCookie('color', color, 7);

        // first the picker
        this.setPicker("#color-picker", 'color', color);

        // now the guide
        this.bumpSlideshow('.main-carousel.color', color);
        this.setGuidePicker('color', color);

        this.recalc();
    }

    setPrices(singlePrice) {
        if (this.text != this.textDefault) {
            //console.log(singlePrice, 'is the single price');
            if ($('.picker_result.chosen_size').text().indexOf('character') == -1) {
                $('.picker_result.chosen_size').append(' - $' + (singlePrice / this.qty).toFixed(2) + ' / character');
            }
            var total = parseFloat(singlePrice * (this.getTextLength()));
            //console.log(total, 'is the total');
            //console.log(singlePrice, 'is the singlePrice');
            $('.itemQty').html(this.qty);
            $('.price_block .singleUnitPrice').html((total / parseInt(this.qty)).toFixed(2));
            $('.totalPrice').html((total).toFixed(2));
        }
    }

    setText(text, master) {
        window.has_rendered_once = false;
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault) this.setCookie('text', text, 7);
        $('.preview_summary').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.recalc(true);
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }

    /**
     * Set the guide picker indicator
     * @param selector
     * @param attr
     * @param value
     */
    setGuidePicker(attr, value) {
        var selector = "#" + attr + "-guide-picker";
        $(selector + ' li ').removeClass('active');
        $(selector + ' li i').removeClass('fas').addClass('far');
        var chosen = $(selector + ' li[data-' + attr + '="' + value + '"]');
        chosen.addClass('active');
        chosen.find('i').removeClass('far').addClass('fas');
        $(selector + ' .desc').addClass('mhnhidden');
        chosen.find('.desc').removeClass('mhnhidden');

        // now adjust the menus. Note that we're checking current value so we don't trigger a change event when not necessary.
        var mobileDropDown = $('select[name="mobile-' + attr + '-guide-picker"]');
        if (mobileDropDown.val() != value) mobileDropDown.val(value);

        // NEW STYLE:
        var description = chosen.find(" .desc").text();
        $(".mobile-" + attr + "-description").text(description);

    }

    /**
     * Refresh slideshow so it works right
     * @param selector
     * @param attr
     */
    bumpSlideshow(selector, attr) {
        var slideshowSelector = selector + '.' + attr;
        if ($(slideshowSelector).length) {
            $(selector).addClass('hidden');
            $(slideshowSelector).removeClass('hidden');
            var flkty = new Flickity(slideshowSelector);
            flkty.resize();
        }
    }


    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    addToCart() {

        if (!window.user_has_modified_preview_text) {
            window.alert("Please enter your own text by clicking on the \"" + this.textDefault + "\" preview text.");
            return false;
        }

        var textToAdd = (this.font == 'socal') ? this.text.toUpperCase() : this.text;
        var item = {
            quantity: this.getTextLength(),
            id: this.variation_id,
            properties: {
                'Typeface': this.getNiceFontName(this.font),
                'House-numbers': textToAdd,
                'Mailbox-color': this.color
            }
        };
        jQuery.post('/cart/add.js', {
            items: [
                item
            ]
        }, function (response) {
            refreshCart();
            jQuery.post(
                'https://dev.modernhousenumbers.com/api/log_shopify',
                {
                    type: 'decal-add-to-cart',
                    item: item,
                    response: response
                }
            );
        }, 'json');
    }

    redraw() {
        var previews = ['.picker  .bigtext', '.summary .bigtext'];
        var currentfont = this.font;

        if (undefined != currentfont) {
            if (!$(previews[0]).closest('.previewwrapper').hasClass(currentfont) || (window.has_rendered_once == false)) {

                $(previews).each(function (index, selector) {
                    $(selector).css('width', '100%');
                    var height = $(selector).height(),
                        width = $(selector).width();
                    $(selector).css('width', width + 'px').css('height', height + 'px');

                    $(selector).css('opacity', 0);
                    var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
                    $(possibleFonts).each(function (index, value) {
                        $('.previewwrapper').removeClass(value);
                    });
                    $('.previewwrapper').addClass(currentfont);

                    window.setTimeout(function () {
                            BigText(selector + ' div', {
                                fontSizeFactor: 0.8,
                                maximumFontSize: 100,
                                limitingDimension: 'both',
                                horizontalAlign: 'center',
                                verticalAlign: 'center',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            });

                            adjustFontOffset(selector, currentfont);
                            $(selector).css('opacity', 1);
                        },
                        400
                    );
                });
            }
        }
        window.has_rendered_once = true;
    }


    recalc() {
        $('.summary .font').html(this.getNiceFontName(this.font));
        $('.summary .color').html(this.getNiceColorName(this.color));
        $('.summary .size').html(this.size + ' inches');
        $('.summary .qty').html(this.qty + ' sets');
        if (undefined != this.text) {
            $('.summary .quantity').html(this.getTextLength());
        } else {
            $('.summary .quantity').html('');
        }
        this.redraw();

        /*
        $('.bigtext').css('height', '150px').css('width', '550px').textfill({
            innerTag: 'div',
            minFontPixels: 14,
            widthOnly: true,
            maxFontPixels: 60,
            changeLineHeight: true,
            allowOverflow: false,
            debug: true,
            success: function() {
                console.log("yay!")
            },
            fail: function() {

            }
        });
        */
        /*$('.bigtext').bigtext({
            minfontsize: 55 // default is null
        });*/

        if (undefined != calc.product) {
            var currentQty = parseInt(this.qty);
            var currentSize = parseInt(this.size);
            $(calc.product.variants).each(function (index, value) {
                // console.log('variation', value);
                var thisQty = parseInt(value.option2.replace(' sets', '').replace(' set', ''));
                var thisSize = parseInt(value.option1.replace('" vinyl number', '').replace('"', ''));
                var thisVariationId = value.id;
                var thisPrice = value.price / 100;
                if ((currentQty == thisQty) && (currentSize == thisSize)) {
                    window.calc.setVariationId(thisVariationId);
                    window.calc.setPrices(thisPrice);
                }
            });
        }
    }

    getTextLength() {
        return getTextLengthForSpecificString(this.text);
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        // console.log('will set url',baseurl[0]);
        window.history.pushState('', '', baseurl[0]);
    }

}

class homecalculator {

    init() {

        this.maxLength = 50;
        this.textDefault = '123Abc';

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font != 'palmsprings') this.setFont(this.font);

        this.text = this.getDefault('text', this.textDefault);
        this.setText(this.text);

        this.redraw();

    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin',
            'soho': 'SoHo',
            'backbay': 'Backbay',
            'southbeach': 'South Beach',
            'santabarbara': 'Santa Barbara'
        }
        return names[key];
    };


    setFont(font) {
        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);

        this.redraw();
    }

    setText(text, master) {
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault)  this.setCookie('text', text, 7);
        $('.preview_summary').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.redraw();
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }


    redraw() {
        var font = this.font;
        var currentfont = font;
        var selector = '.picker  .bigtext';

        $(selector).css('width', '100%');
        var height = $(selector).height(),
            width = $(selector).width();
        jQuery(selector).css('width', width + 'px').css('height', height + 'px');

        $(selector).css('opacity', 0);
        // extra fancy stuff.
        if (undefined != currentfont) {
            var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
            $(possibleFonts).each(function (index, value) {
                $('.previewwrapper').removeClass(value);
            });
            $('.previewwrapper').addClass(currentfont);
        }
        // console.log('added font');
        window.setTimeout(function () {
                // console.log('starting bigtext');
                BigText(selector + ' div', {
                    fontSizeFactor: 0.8,
                    maximumFontSize: 90,
                    limitingDimension: 'both',
                    horizontalAlign: 'center',
                    verticalAlign: 'center',
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                });
                adjustFontOffset(selector, currentfont);
                $(selector).css('opacity', 1);
            },
            400
        );

    }

    getTextLength() {
        var temp = this.text.replace(/ /g, '');
        return temp.length;
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

}

class nlcalculator {

    saveAndCalc(data, a, e) {
        // console.log(data);
        calc.nl_product = data;
        calc.recalc();
    }

    async getTemplateData() {
        calc.template_data = [];
        const response = await fetch("/products/extra-template.js");
        const templateProducts = await response.json();
        // console.log("HERE", templateProducts);

        $(templateProducts.variants).each(function (index, variant) {
            //console.log(variant);
            var id = variant.id;
            var size = variant.option1.toLowerCase()
                .replaceAll('"', '')
            calc.template_data['size_' + size] = {
                'price': variant.price,
                'id': id
            };
        });
        calc.recalc();
    }

    getProductData() {

        $.ajax('/products/house-numbers-letters.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalc,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });

    }


    init() {

        window.has_rendered_once = false;

        this.maxLength = 50;
        this.textDefault = '123Abc';

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font != 'palmsprings') this.setFont(this.font);

        this.finish = this.getDefault('finish', 'brushed');
        if (this.finish != 'brushed') this.setFinish(this.finish);

        this.size = this.getDefault('size', '6');
        if (this.size != '6') this.setSize(this.size);

        this.orientation = this.getDefault('orientation', 'horizontal');
        if (this.orientation != 'horizontal') this.setOrientation(this.orientation);

        this.text = this.getDefault('text', this.textDefault);

        this.setText(this.text);

        this.getProductData();

        this.getTemplateData();

        this.recalc();

        this.reset_url();
    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin',
            'soho': 'SoHo',
            'backbay': 'Backbay',
            'southbeach': 'South Beach',
            'santabarbara': 'Santa Barbara'
        }
        return names[key];
    };

    getNiceFinishName(key) {
        var names = {
            'brushed': 'Brushed Aluminum',
            'black': 'Matte Black',
            'white': 'White',
            'brass': 'Matte Brass',
            'bronze': 'Dark Bronze'
        }
        return names[key];
    };


    setFont(font) {
        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);


        var height = $('#previewsection').height();
        $('#previewsection').css('height', height);
        // $('#previewsection').css('overflow', 'hidden');
        $('#previewsection .previewimagewrapper').hide();
        var slideshowSelector = '#previewsection .previewimagewrapper[data-font=\'' + font + '\']';
        $(slideshowSelector).fadeIn(250, function () {
            var flkty = new Flickity('#previewsection');
            flkty.select(0, false, true);
            flkty.resize();
        });

        // guide next
        this.bumpSlideshow('.main-carousel.fonts', font);
        this.setGuidePicker('font', font);

        this.recalc();
    }

    setFinish(finish) {
        this.finish = finish;
        this.setCookie('finish', finish, 7);

        // first the picker
        this.setPicker("#finish-picker", 'finish', finish);

        // now the guide
        this.bumpSlideshow('.main-carousel.finish', finish);
        this.setGuidePicker('finish', finish);

        this.recalc();
    }

    setSize(size) {

        var possibleSizes = [4, 6, 8, 12, 15];
        if (possibleSizes.indexOf(parseInt(size)) == -1) {
            size = 4;
        }
        this.size = size;
        this.setCookie('size', size, 7);

        // first the picker
        this.setPicker("#size-picker", 'size', size);

        // this.maybeSetBothPrice();

        // now the guide
        this.bumpSlideshow('.main-carousel.size', 'size' + size);
        this.setGuidePicker('size', size);

        this.recalc();
    }

    maybeSetBothPrice() {

        if (this.orientation === 'both') {
            let price = this.getBothPrice();
            $('.both_note').html('(optional - $'+price+' Add On)');
        } else {
            $('.both_note').html('');
        }
    }

    setOrientation(orientation) {
        this.orientation = orientation;
        this.setCookie('orientation', orientation, 7);

        // first the picker
        this.setPicker("#orientation-picker", 'orientation', orientation);

        this.maybeSetBothPrice();

        // now the guide
        this.bumpSlideshow('.main-carousel.orientation', orientation);
        this.setGuidePicker('orientation', orientation);

        this.recalc();
    }

    getBothPrice() {
        if ((undefined !== calc.template_data) && (this.size !== undefined)) {
            let num_chars = this.getTextLength();
            let size = parseInt(this.size);
            if (undefined !== calc.template_data['size_' + size] ?? undefined) {
                let singlePrice = parseInt(calc.template_data['size_' + size]['price'] ?? 0) / 100;
                return parseFloat(singlePrice * num_chars).toFixed(2);
            }
        }
        return 0;
    }

    setPrices(singlePrice) {

        if (this.orientation === 'both') {
            $('.extraprice').html("Plus $" + this.getBothPrice() + " additional installation template.");
        } else {
            $('.extraprice').html("");
        }
        $('.singleUnitPrice').html(parseFloat(singlePrice).toFixed(2));
        if (this.text != this.textDefault) {
            $('.itemQty').html(this.getTextLength());
            $('.totalPrice').html(parseFloat(singlePrice * (this.getTextLength())).toFixed(2));
        }
    }

    setText(text, master) {
        window.has_rendered_once = false;
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault) this.setCookie('text', text, 7);
        $('.preview_summary').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.recalc();
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }

    /**
     * Set the guide picker indicator
     * @param selector
     * @param attr
     * @param value
     */
    setGuidePicker(attr, value) {
        var selector = "#" + attr + "-guide-picker";
        $(selector + ' li ').removeClass('active');
        $(selector + ' li i').removeClass('fas').addClass('far');
        var chosen = $(selector + ' li[data-' + attr + '="' + value + '"]');
        chosen.addClass('active');
        chosen.find('i').removeClass('far').addClass('fas');
        $(selector + ' .desc').addClass('mhnhidden');
        chosen.find('.desc').removeClass('mhnhidden');

        // OLD STYLE
        // now adjust the menus. Note that we're checking current value so we don't trigger a change event when not necessary.
        var mobileDropDown = $('select[name="mobile-' + attr + '-guide-picker"]');
        if (mobileDropDown.val() != value) mobileDropDown.val(value);

        // NEW STYLE:
        var description = chosen.find(" .desc").text();
        $(".mobile-" + attr + "-description").text(description);


    }


    /**
     * Refresh slideshow so it works right
     * @param selector
     * @param attr
     */
    bumpSlideshow(selector, attr) {
        var slideshowSelector = selector + '.' + attr;
        if ($(slideshowSelector).length) {
            $(selector).addClass('hidden');
            $(slideshowSelector).removeClass('hidden');
            var flkty = new Flickity(slideshowSelector);
            flkty.resize();
        }
    }


    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    addToCart() {
        if (this.text == this.textDefault) {
            window.alert("Please enter your own text by clicking on the \"" + this.textDefault + "\" preview text.");
            return false;
        }
        var textToAdd = (this.font === 'socal') ? this.text.toUpperCase() : this.text;
        var item = {
            quantity: this.getTextLength(),
            id: this.variation_id,
            properties: {
                'Typeface': this.getNiceFontName(this.font),
                'House-numbers': textToAdd,
                'Orientation': this.orientation
            }
        };

        // reverse order so that the template comes after.
        let items = [];
        if (this.orientation === 'both') {
            items.push(
                {
                    quantity: this.getTextLength(),
                    id: this.template_data['size_' + this.size].id,
                    properties: {
                        'Typeface': this.getNiceFontName(this.font),
                        'House-numbers': textToAdd,
                    }
                }
            )
        }
        items.push( item );
        jQuery.post('/cart/add.js', {
            items: items
        }, function (response) {
            // We're having trouble with empty properties. Log remotely to see what's happening.
            refreshCart();
            jQuery.post(
                'https://dev.modernhousenumbers.com/api/log_shopify',
                {
                    type: 'nl-add-to-cart',
                    item: item,
                    response: response
                }
            );
        }, 'json');
    }

    redraw() {
        var previews = ['.picker  .bigtext', '.summary .bigtext'];
        var currentfont = this.font;

        $(previews).each(function (index, selector) {

            $(selector).css('width', '100%');
            var height = $(selector).height(),
                width = $(selector).width();
            $(selector).css('width', width + 'px').css('height', height + 'px');

            if (undefined != currentfont) {
                if (!$(selector).closest('.previewwrapper').hasClass(currentfont) || (window.has_rendered_once == false)) {
                    $(selector).css('opacity', 0);
                    var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
                    $(possibleFonts).each(function (index, value) {
                        $('.previewwrapper').removeClass(value);
                    });
                    $('.previewwrapper').addClass(currentfont);


                    window.setTimeout(function () {
                            BigText(selector + ' div', {
                                fontSizeFactor: 0.8,
                                maximumFontSize: 100,
                                limitingDimension: 'both',
                                horizontalAlign: 'center',
                                verticalAlign: 'center',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            });
                            adjustFontOffset(selector, currentfont);
                            $(selector).css('opacity', 1);
                        },
                        400
                    );
                }
            }
        });
        window.has_rendered_once = true;
    }

    recalc() {

        $('.summary .font').html(this.getNiceFontName(this.font));
        $('.summary .finish').html(this.getNiceFinishName(this.finish));
        $('.summary .size').html(this.size + ' inches');
        $('.summary .orientation').html(this.orientation);
        if (undefined != this.text) {
            $('.summary .quantity').html(this.getTextLength());
        } else {
            $('.summary .quantity').html('');
        }
        this.redraw();
        if (undefined != calc.nl_product) {
            var currentFinish = this.finish;
            var currentSize = this.size;
            $(calc.nl_product.variants).each(function (index, value) {
                // console.log('variation', value);
                var thisFinish = value.option2;
                var thisSize = value.option1.replace('"','');
                var thisVariationId = value.id;
                var thisPrice = value.price / 100;
                // console.log(currentFinish,thisFinish,currentSize,thisSize);
                if ((thisFinish.indexOf(currentFinish) > -1) && (currentSize == thisSize)) {
                    // console.log('this variation id is', thisVariationId);
                    window.calc.setVariationId(thisVariationId);
                    window.calc.setPrices(thisPrice);
                }
            });
        }
        this.maybeSetBothPrice();
    }

    getTextLength() {
        return getTextLengthForSpecificString(this.text ?? '');
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        // console.log('will set url',baseurl[0]);
        window.history.pushState('', '', baseurl[0]);
    }

}

class plaquecalculator {

    saveAndCalc(data, a, e) {
        // console.log(data);
        calc.nl_product = data;
        calc.recalc();
    }

    async getContrastData() {
        calc.contrast_data = [];
        calc.contrast_inventory = [];
        const response = await fetch("/products/plaque-contrast-plate.js");
        const contrastProducts = await response.json();
        // console.log("HERE", contrastProducts);

        $(contrastProducts.variants).each(function (index, value) {
            var id = value.id;
            var description = value.title;
            var size = value.option1.toLowerCase()
                .replaceAll(' ', '')
                .replaceAll('"', '')
                .replaceAll('rectangle', '')
                .replaceAll('square', '')
                .replaceAll('circle', '')
                .replaceAll('diameter', '')
            ;
            var color = value.option2.toLowerCase();
            // they want "4 inch" for the variant name because it's easier to track.
            var key = size + "_" + color;
            calc.contrast_data[key] = id;
            calc.contrast_inventory[key] = value.inventory_quantity;
        });
        //console.log(calc.contrast_inventory);
    }

    getProductData() {

        $.ajax('/products/plaque.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalc,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });
    }


    init() {

        window.has_rendered_once = false;
        window.ignore_redraw = false;

        window.user_has_modified_preview_text = false;

        this.maxLength = 3;
        this.textDefault = '123Abc';
        this.maxFontSize = 120; // was 120

        this.shape = this.getDefault('shape', 'rect-5-16');
        this.setShape(this.shape);

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font !== 'palmsprings') this.setFont(this.font);

        this.finish = this.getDefault('finish', 'brushed');
        if (this.finish !== 'brushed') this.setFinish(this.finish);

        this.alignment = this.getDefault('alignment', 'center');
        if (this.alignment !== 'center') this.setAlignment(this.alignment);

        this.contrast = this.getDefault('contrast', 'none');
        if (this.contrast !== 'none') this.setContrast(this.contrast);

        this.orientation = this.getDefault('orientation', 'horizontal');
        if (this.orientation === 'both') {
            this.orientation = 'horizontal';
        }
        if (this.orientation !== 'horizontal') this.setOrientation(this.orientation);

        this.text = this.getDefault('text', this.textDefault);
        if (this.text !== this.textDefault) {
            //console.log(this.text, this.textDefault);
            window.user_has_modified_preview_text = true;
        }
        this.setText(this.text);

        this.getProductData();

        this.getContrastData();

        // in case it's the default
        this.recalc();

        this.reset_url();
    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin'
        }
        return names[key];
    };

    getNiceShapeName(key) {
        var names = {
            'circle-5': '5" Circle',
            'circle-7': '7" Circle',
            'circle-10': '10" Circle',
            'rect-3-8': '3"x8" Rectangle',
            'rect-4-11': '4"x11" Rectangle',
            'rect-5-16': '5"x16" Rectangle',
            'square-8': '8" Square',
        }
        return names[key];
    };

    getNiceAlignmentName(key) {
        var names = {
            'right': 'Right',
            'center': 'Center',
            'bottom': 'Bottom'
        }
        return names[key];
    };

    getNiceFinishName(key) {
        var names = {
            'brushed': 'Brushed Aluminum',
            'black': 'Matte Black',
            'white': 'White',
            'brass': 'Matte Brass',
            'bronze': 'Dark Bronze'
        }
        return names[key];
    };


    setFont(font) {

        var possibleFonts = ['palmsprings', 'socal', 'austin'];
        if (possibleFonts.indexOf(font) == -1) {
            font = 'palmsprings';
        }

        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);


        var height = $('#previewsection').height();
        $('#previewsection').css('height', height);
        // $('#previewsection').css('overflow', 'hidden');
        $('#previewsection .previewimagewrapper').hide();
        var slideshowSelector = '#previewsection .previewimagewrapper[data-font=\'' + font + '\']';
        $(slideshowSelector).fadeIn(250, function () {
            var flkty = new Flickity('#previewsection');
            flkty.select(0, false, true);
            flkty.resize();
        });

        // guide next
        this.bumpSlideshow('.main-carousel.fonts', font);
        this.setGuidePicker('font', font);

        $('#previewfontwrap').removeClass().addClass(this.font);

        this.recalc();
    }

    setFinish(finish) {
        this.finish = finish;
        this.setCookie('finish', finish, 7);

        // first the picker
        this.setPicker("#finish-picker", 'finish', finish);

        // extra fancy stuff they don't want
        // $('#previewwrapper').removeClass('finish-brushed finish-black finish-white finish-brass finish-bronze').addClass('finish-' + finish);

        // now the guide
        this.bumpSlideshow('.main-carousel.finish', finish);
        this.setGuidePicker('finish', finish);
        window.ignore_redraw = true;
        this.recalc();
    }

    setShape(shape) {

        $('.toolongnotice').hide();
        $('.lengthnotice').hide();


        this.shape = shape;
        this.setCookie('shape', shape, 7);

        // first the picker
        this.setPicker(".shape-picker", 'shape', shape);

        // set the shape above the dimensions
        this.setPreviewShape(shape);

        // set the shape in the preview
        this.setShapeGuide(shape);

        this.setNewMaxLength(shape);

        this.setNewMaxSize(shape);

        this.maskAlignments(shape);

        this.maskOrientation(shape);

        // now the guide
        this.bumpSlideshow('.main-carousel.shape', shape);
        this.setGuidePicker('shape', shape);

        this.recalc();
    }

    setNewMaxSize(shape) {
        var maxSizes = {
            'circle-5': 120,
            'circle-7': 140,
            'circle-10': 160,
            'square-8': 120,
            'rect-3-8': 180,
            'rect-4-11': 180,
            'rect-5-16': 180
        };
        //console.log("Setting to " + maxSizes[shape]);
        this.maxFontSize = maxSizes[shape];
    }

    setNewMaxLength(shape) {
        var lengths = {
            'circle-5': 2,
            'circle-7': 4,
            'circle-10': 7,
            'square-8': 6,
            'rect-3-8': 4,
            'rect-4-11': 6,
            'rect-5-16': 8
        };
        if (this.orientation === 'vertical') {
            lengths = {
                'rect-3-8': 3,
                'rect-4-11': 4,
                'rect-5-16': 6
            };
        }
        this.maxLength = lengths[shape];
        if (undefined !== this.text) {
            this.setText(this.text.substr(0, lengths[shape]));
        }
        $('#summary-text').attr('maxlength', this.maxLength);
        $('.lengthnotice span').html("Max " + this.maxLength + " chars");
    }

    maskSizes(orientation) {
        if (orientation === 'vertical') {
            $('.shape-picker.circles').hide();
            $('.shape-picker.squares').hide();
        } else {
            $('.shape-picker.circles').show();
            $('.shape-picker.squares').show();
        }
    }

    maskOrientation(shape) {
        if ((shape.indexOf('circle') !== -1) || (shape.indexOf('square') !== -1)) {
            // hide all alignments but center
            $('#orientation-picker').hide();
            $('.chosen_orientation').hide();
            $('.orientationrow').hide();
        } else {
            $('#orientation-picker').show();
            $('.chosen_orientation').show();
            $('.orientationrow').show();
        }
    }

    maskAlignments(shape) {

        if ((undefined !== this.orientation) && (this.orientation === 'vertical')) {
            // console.log("masking alignments", this.orientation)
            $('#alignment-picker li').hide();
            $('.summary .alignmentrow').hide();
            return;
        } else {
            $('.summary .alignmentrow').show();
            $('#alignment-picker li').show();
        }
        $('.mobile-alignment-guide-picker option').attr('disabled', 'disabled');
        $('#alignment-guide-picker li').show();

        if (shape.indexOf('circle') !== -1) {
            // hide all alignments but center
            $('#alignment-picker li.right').hide();
            $('#alignment-picker li.bottom').hide();
            $('#alignment-picker li.center').show();
            $('#alignment-guide-picker li[data-alignment="right"]').hide();
            $('#alignment-guide-picker li[data-alignment="bottom"]').hide();
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);
        } else if (shape.indexOf('square') !== -1) {
            // only center and bottom
            $('#alignment-picker li.right').hide();
            $('#alignment-picker li.bottom').show();
            $('#alignment-picker li.center').show();

            $('.mobile-alignment-guide-picker option[value=bottom]').attr('disabled', false);
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);


            $('#alignment-guide-picker li[data-alignment="right"]').hide();


        } else if (shape.indexOf('rec') !== -1) {
            // only right or center
            $('#alignment-picker li.bottom').hide();
            $('#alignment-picker li.right').show();
            $('#alignment-picker li.center').show();
            $('.mobile-alignment-guide-picker option[value=right]').attr('disabled', false);
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);

            $('#alignment-guide-picker li[data-alignment="bottom"]').hide();
        }
    }

    setAlignment(alignment) {
        this.alignment = alignment;
        this.setCookie('alignment', alignment, 7);

        // first the picker
        this.setPicker("#alignment-picker", 'alignment', alignment);

        this.setPreviewAlignment(alignment);

        // now the guide
        this.bumpSlideshow('.main-carousel.alignment', alignment);
        this.setGuidePicker('alignment', alignment);

        this.recalc();
    }


    setContrast(contrast) {
        this.contrast = contrast;
        this.setCookie('contrast', contrast, 7);

        // first the picker
        this.setPicker("#contrast-picker", 'contrast', contrast);

        // now the guide
        this.setGuidePicker('contrast', contrast);
        this.bumpSlideshow('.main-carousel.contrast', contrast);

        this.recalc();
    }


    setOrientation(orientation) {
        this.orientation = orientation;
        this.setCookie('orientation', orientation, 7);

        if (
            (this.shape !== 'rect-3-8')
            &&
            (this.shape !== 'rect-4-11')
            &&
            (this.shape !== 'rect-5-16')
        ) {
            this.setShape('rect-3-8');
        }
        // first the picker
        this.setPicker("#orientation-picker", 'orientation', orientation);

        this.setShape(this.shape);

        this.maskSizes(this.orientation);

        // now the guide
        this.setGuidePicker('orientation', orientation);
        this.bumpSlideshow('.main-carousel.orientation', orientation);

        this.recalc();
    }

    hideContrastWarning() {
        jQuery('.contrast_plate_warning').addClass("hidden");
    }
    showContrastWarning() {
        jQuery('.contrast_plate_warning').removeClass("hidden");
    }

    setPrices(singlePrice) {

        if (this.contrast !== 'none') {
            let ctrst_qty = this.get_contrast_qty(this.shape, this.contrast);
            // console.log("For current item qty is ", ctrst_qty);
            if (ctrst_qty > 0) {
                singlePrice += 8;
                this.hideContrastWarning();
            } else {
                this.showContrastWarning();
            }
        } else {
            this.hideContrastWarning();
        }
        if (this.text != this.textDefault) {
            $('.totalPrice').html(parseFloat(singlePrice).toFixed(2));
        }

    }

    setText(text, master) {

        if (text.length > this.maxLength) {
            text = text.substring(0, this.maxLength);
        }
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault)  this.setCookie('text', text, 7);
        $('.summary .bigtext .preview').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        // if they're actually keying in the preview blank, don't replace it.
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.recalc();
    }

    /**
     * Given an alignment class, apply it to the preview box.
     * @param shape
     */
    setPreviewAlignment(alignment) {
        var possiblealignments = ['right', 'center', 'top', 'bottom'];
        $(possiblealignments).each(function (index, value) {
            $('#previewwrapper .preview').removeClass(value);
        });
        $('#previewwrapper .preview').addClass(alignment);
        if (alignment == 'right' || this.orientation === 'vertical')
            $('.previewwrapper.plaque').addClass('rightalignpad').removeClass('px-3');
        else
            $('.previewwrapper.plaque').removeClass('rightalignpad').addClass('px-3');
    }

    /**
     * Given a shape, make sure we reset the alignment to a valid setting.
     * @param shape
     */
    sanityCheckAlignment(shape) {
        if (shape.indexOf('circle') !== -1) {
            this.setAlignment('center');
        } else if (shape.indexOf('square') !== -1) {
            if (this.alignment == 'right') {
                this.setAlignment('center');
            }
        } else {
            // rectangle
            if (this.alignment == 'bottom') {
                this.setAlignment('center');
            }
        }
    }

    calculateNewHeight(wrappername, shape) {
        var newHeight = $(wrappername).height();
        var width = $(wrappername).outerWidth();
        if (shape == 'rect-3-8') {
            newHeight = 3 * width / 8;
        } else if (shape == 'rect-4-11') {
            newHeight = 4 * width / 11;
        } else if (shape == 'rect-5-16') {
            newHeight = 5 * width / 16;
        } else if (shape.indexOf('circle') !== -1) {
            newHeight = $(wrappername + ' .bigtext').width();
        } else if (shape.indexOf('square') !== -1) {
            newHeight = $(wrappername + ' .bigtext').width();
        }
        if (newHeight <= 0 ) newHeight = 45;
        return newHeight;
    }

    /**
     * Given a shape class, apply it to the preview box.
     * @param shape
     */
    setPreviewShape(shape) {
        var possibleShapes = ['circle-5', 'circle-7', 'circle-10', 'rect-3-8', 'rect-4-11', 'rect-5-16', 'square-8'];
        $(possibleShapes).each(function (index, value) {
            $('.previewwrapper').removeClass(value);
        });
        $('.previewwrapper').addClass(shape);
        $('.previewwrapper').removeClass('horizontal');
        $('.previewwrapper').removeClass('vertical');
        $('.previewwrapper').addClass(this.orientation);

        this.sanityCheckAlignment(shape);
        var alignment = this.alignment;
        var newWidth;
        var newHeight;
        $('.previewwrapper').addClass('p-3').removeClass('rightalignpad');
        if (shape == 'square-8') {
            newWidth = '200';
            newHeight = '200';
        } else if (shape == 'circle-5') {
            newWidth = '175';
            newHeight = '175';
        } else if (shape == 'circle-7') {
            newWidth = '200';
            newHeight = '200';
        } else if (shape == 'circle-10') {
            newWidth = '225';
            newHeight = '225';
        } else {
            // rectangles
            $('.previewwrapper').removeClass('p-3');
            if (this.alignment == 'right') $('.previewwrapper').addClass('rightalignpad');
            newWidth = 'auto';
            newHeight = 'auto';
        }
        $('.previewwrapper').height(newHeight).width(newWidth);
        $('.previewwrapper .bigtext').height(newHeight).width(newWidth);

        if (newWidth === 'auto') {
            if (this.orientation !== 'vertical') {
                newHeight = this.calculateNewHeight('.picker .previewwrapper', shape);
                //console.log('setting new height to ', newHeight)
                $('.picker .previewwrapper .bigtext')
                    .height(newHeight);
                $('.picker .previewwrapper')
                    .css('line-height', newHeight + "px")
                    .css('height', newHeight + "px");
                newHeight = this.calculateNewHeight('.step-summary .previewwrapper', shape);
                $('.step-summary .previewwrapper .bigtext')
                    .height(newHeight);
                $('.step-summary .previewwrapper')
                    .css('line-height', newHeight + "px")
                    .css('height', newHeight + "px");
            } else {
                newHeight = 500;
                newWidth = 90;

                if (shape === 'rect-3-8') {
                    newHeight = 8 * newWidth / 3;
                } else if (shape === 'rect-4-11') {
                    newHeight = 11 * newWidth / 4;
                } else if (shape === 'rect-5-16') {
                    newHeight = 16 * newWidth / 5;
                }
                $('.picker .previewwrapper .bigtext')
                    .height(newHeight)
                    .width(newWidth);
                $('.picker .preview')
                    .css('line-height', 'auto')
                $('.picker .previewwrapper')
                    .css('height', newHeight + "px")
                    .css('width', newWidth + "px");
                $('.step-summary .previewwrapper .bigtext')
                    .height(newHeight + "px")
                    .width(newWidth + "px");
                $('.step-summary .previewwrapper')
                    .css('height', newHeight + "px")
                    .css('width', newWidth + "px");

            }
        }
    }


    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    /**
     * Set the shape above the dimensions
     * @param selector
     * @param attr
     * @param value
     */
    setShapeGuide(shape) {
        var parts = shape.split('-');
        $('.shapeoutline').removeClass('active');
        $('.shapeoutline.' + parts[0]).addClass('active');

    }

    setVariationId(id) {
        this.variation_id = id;
    }

    /**
     * Set the guide picker indicator
     * @param selector
     * @param attr
     * @param value
     */
    setGuidePicker(attr, value) {
        var selector = "#" + attr + "-guide-picker";
        $(selector + ' li ').removeClass('active');
        $(selector + ' li i').removeClass('fas').addClass('far');
        var chosen = $(selector + ' li[data-' + attr + '="' + value + '"]');
        chosen.addClass('active');
        chosen.find('i').removeClass('far').addClass('fas');
        $(selector + ' .desc').addClass('mhnhidden');
        chosen.find('.desc').removeClass('mhnhidden');

        // now adjust the menus. Note that we're checking current value so we don't trigger a change event when not necessary.
        var mobileDropDown = $('select[name="mobile-' + attr + '-guide-picker"]');
        if (mobileDropDown.val() != value) mobileDropDown.val(value);

        // NEW STYLE:
        var description = chosen.find(" .desc").text();
        $(".mobile-" + attr + "-description").text(description);



    }

    /**
     * Refresh slideshow so it works right
     * @param selector
     * @param attr
     */
    bumpSlideshow(selector, attr) {
        var slideshowSelector = selector + '.' + attr;
        if ($(slideshowSelector).length) {
            $(selector).addClass('hidden');
            $(slideshowSelector).removeClass('hidden');
            var flkty = new Flickity(slideshowSelector);
            flkty.resize();
        }
    }


    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    addToCart() {

        if (!window.user_has_modified_preview_text) {
            window.alert("Please enter your own text by clicking on the \"" + this.textDefault + "\" preview text.");
            return false;
        }

        var textToAdd = (this.font == 'socal') ? this.text.toUpperCase() : this.text;
        var item = {
            quantity: 1,
            id: this.variation_id,
            properties: {
                'Typeface': this.getNiceFontName(this.font),
                'House-numbers': textToAdd,
                'Orientation': this.orientation
            }
        };
        // console.log(item);
        if (this.shape.indexOf('square') !== false) {
            item.properties['Alignment'] = this.alignment;
        } else if (this.shape.indexOf('rect') !== false) {
            item.properties['Alignment'] = this.alignment;
        } else {
            item.properties['Alignment'] = '';
        }
        let items_to_add = [];
        if (this.contrast !== 'none') {
            let product_id = this.get_contrast_product(this.shape, this.contrast);
            let ctrst_qty = this.get_contrast_qty(this.shape, this.contrast);
            if ((product_id) && (ctrst_qty > 0)) {
                items_to_add.push({
                    quantity: 1,
                    id: product_id
                });
            }
        }
       items_to_add.push(item);

        jQuery.post('/cart/add.js', {
            items: items_to_add
        }, function (response) {
            refreshCart();
            jQuery.post(
                'https://dev.modernhousenumbers.com/api/log_shopify',
                {
                    type: 'plaque-add-to-cart',
                    item: items_to_add,
                    response: response
                }
            );
        }, 'json');


    }

    get_key_for_shape_and_contrast( shape, contrast ) {
        let mapping = {
            'circle-5': '5',
            'circle-7': '7',
            'circle-10': '10',
            'rect-3-8': '3x8',
            'rect-4-11': '4x11',
            'rect-5-16': '5x16',
            'square-8': '8x8',
        }
        let key = mapping[shape] + "_" + contrast;
        return key;
    }

    get_contrast_qty( shape, contrast ) {
        //console.log("Shape is", shape, 'contrast is ', contrast);
        //console.log(calc.contrast_data);
        if (contrast === 'none') {
            return false;
        }
        let key = this.get_key_for_shape_and_contrast(shape, contrast);
        return calc.contrast_inventory[key];
    }

    get_contrast_product( shape, contrast ) {
        //console.log("Shape is", shape, 'contrast is ', contrast);
        //console.log(calc.contrast_data);
        if (contrast === 'none') {
            return false;
        }
        let key = this.get_key_for_shape_and_contrast(shape, contrast);
        return calc.contrast_data[key];
    }

    getVerticalFontSize() {
        if ((undefined !== this.text) && (undefined !== this.shape)) {
            let numChars = window.calc['text'].length;
            let isWindows = false;
            let vals = {};
            if (window.navigator.userAgent.indexOf('Windows') != -1) {
                isWindows = true;
            }
            if (isWindows) {
                // different for windows! .15 margin
                vals = {
                    'rect-3-8': {
                        1: '96px',
                        2: '86px',
                        3: '65px',
                    },
                    'rect-4-11': {
                        1: '96px',
                        2: '96px',
                        3: '70px',
                        4: '50px',
                    },
                    'rect-5-16': {
                        1: '96px',
                        2: '96px',
                        3: '75px',
                        4: '60px',
                        5: '53px',
                        6: '45.5px',
                    },
                }
            } else {
                vals = {
                    'rect-3-8': {
                        1: '96px',
                        2: '86px',
                        3: '65px',
                    },
                    'rect-4-11': {
                        1: '96px',
                        2: '96px',
                        3: '70px',
                        4: '50px',
                    },
                    'rect-5-16': {
                        1: '96px',
                        2: '96px',
                        3: '75px',
                        4: '60px',
                        5: '50px',
                        6: '45px',
                    },
                }
            }
            return vals[this.shape][numChars];
        }
        return '96px';
    }

    redraw() {
        var previews = ['.picker  .bigtext', '.summary .bigtext'];
        var currentfont = this.font;
        let letter_spacing = '';

        if (this.orientation === 'vertical') {

            let margin = '.1em 0 0';
            if (window.navigator.userAgent.indexOf('Windows') != -1) {
                margin = '0 0 0';
                if (this.font === 'socal') {
                    letter_spacing = "-2px";
                } else {
                    letter_spacing = "-10px";
                }
            } else if (this.font === 'austin') {
                letter_spacing = "-10px";
            }
            $('.previewwrapper').removeClass('rightalignpad');
            $('.preview')
                .css('font-size', this.getVerticalFontSize())
                .css('float', 'none')
                .css('line-height', '90px')
                .css('margin', margin)
                .css('letter-spacing', letter_spacing)
                .css('left', 'auto')
                .css('top', 'auto');
            $('.previewwrapper').removeClass('px-3')
            $('.offsetwrapper').css('margin', 0);
            jQuery('.previewwrapper').css('line-height', '')

            $(previews).each(function (index, selector) {
                $(selector).css('opacity', 1);
                if (!$('.previewwrapper').hasClass(currentfont)) {
                    var possibleFonts = ['palmsprings', 'socal', 'austin'];
                    $(possibleFonts).each(function (index, value) {
                        $('.previewwrapper').removeClass(value);
                    });
                    $('.previewwrapper').addClass(currentfont);
                }
            });

            return;
        }

        // undo any adjustments made in vertical.
        $('.preview').css('letter-spacing', '');

        var currentalignment = this.alignment;
        var maxFontSize = this.maxFontSize;

        if ((undefined == currentalignment) || (undefined == currentfont)) return;

        var halign = 'center';
        var valign = 'center';

        if (currentalignment == 'bottom') {
            valign = 'bottom';
        }
        if (currentalignment == 'right') {
            halign = 'right';
        }
        if (window.ignore_redraw) {
            window.ignore_redraw = false;
            return;
        }

        $(previews).each(function (index, selector) {
            $(selector).css('opacity', 0);
            // $(selector).css('width', '100%');
            var height = $(selector).height(),
                width = $(selector).width();
            //console.log('selector', selector, 'height', height, 'width', width);
            $(selector).css('width', width + 'px').css('height', height + 'px');
            //console.log('++selector', selector, 'height', height, 'width', width);
            var options = {
                fontSizeFactor: .8,
                maximumFontSize: maxFontSize,
                limitingDimension: 'both',
                horizontalAlign: halign,
                verticalAlign: valign,
                textAlign: 'center',
                whiteSpace: 'nowrap'
            };
            //console.log(options);
            if (!$('.previewwrapper').hasClass(currentfont)) {
                var possibleFonts = ['palmsprings', 'socal', 'austin'];
                $(possibleFonts).each(function (index, value) {
                    $('.previewwrapper').removeClass(value);
                });
                $('.previewwrapper').addClass(currentfont);
            }
            if ($(selector).width() == 0) {
                $(selector).width('100%');
                //console.log('tweak');
            }

            // console.log(options);
            window.setTimeout(function () {
                BigText(selector + ' div', options);
                adjustFontOffsetPlaque(selector, currentfont);
                $(selector).css('opacity', 1);
            }, 500);
        });

    }


    recalc() {
        $('.summary .font').html(this.getNiceFontName(this.font));
        $('.summary .finish').html(this.getNiceFinishName(this.finish));
        $('.summary .shape').html(this.getNiceShapeName(this.shape));
        $('.summary .alignment').html(this.alignment);
        $('.summary .orientation').html(this.orientation);
        $('.summary .contrast').html(this.contrast);
        if (undefined != this.text) {
            $('.summary .quantity').html(this.getTextLength());
        } else {
            $('.summary .quantity').html('');
        }
        this.redraw();

        if (undefined != calc.nl_product) {
            var currentFinish = this.finish;
            var currentShape = this.shape;
            var currentSku = currentShape + '-' + currentFinish;
            // console.log(currentSku);
            $(calc.nl_product.variants).each(function (index, value) {
                // console.log('variation', value);
                var thisSku = value.sku;
                var thisVariationId = value.id;
                var thisPrice = value.price / 100;
                if (currentSku == thisSku) {
                    // console.log('got it!',thisVariationId);
                    // console.log('this variation id is', thisVariationId);
                    window.calc.setVariationId(thisVariationId);
                    window.calc.setPrices(thisPrice);
                    // iej
                }
            });
        }
    }

    getTextLength() {
        var temp = this.text.replace(/ /g, '');
        return temp.length;
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        // console.log('will set url',baseurl[0]);
        window.history.pushState('', '', baseurl[0]);
    }

}

class proscalculator {


    saveAndCalcNL(data, a, e) {
        calc.nl_product = data;
        calc.recalc();
    }

    saveAndCalcPlaque(data, a, e) {
        //console.log(data);
        calc.plaque_product = data;
        calc.recalc();
    }

    async getTemplateData() {
        calc.template_data = [];
        const response = await fetch("/products/extra-template.js");
        const templateProducts = await response.json();
        // console.log("HERE", templateProducts);

        $(templateProducts.variants).each(function (index, variant) {
            //console.log(variant);
            var id = variant.id;
            var size = variant.option1.toLowerCase()
                .replaceAll('"', '')
            calc.template_data['size_' + size] = {
                'price': variant.price,
                'id': id
            };
        });
        // console.log(calc.template_data);
        calc.recalc();
    }

    getBothPrice() {
        // console.log(calc.template_data )
        if ((undefined !== calc.template_data) && (this.size !== undefined)) {
            let num_chars = this.getTextLength();
            let size = parseInt(this.size);
            if (undefined !== calc.template_data['size_' + size] ?? undefined) {

                let singlePrice = parseInt(calc.template_data['size_' + size]['price'] ?? 0) / 100;
                // console.log(singlePrice, 'x', num_chars)
                let final = parseFloat(singlePrice * num_chars).toFixed(2);
                // console.log(final);
                return final;
            }
        }
        return 0;
    }

    maybeSetBothPrice() {
        if (this.orientation === 'both') {
            let price = this.getBothPrice();
            $('.both_note').html('(optional - $'+price+' Add On)');
        } else {
            $('.both_note').html('');
        }
    }

    getProductData(product_id) {

        $.ajax('/products/house-numbers-letters.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalcNL,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });
        $.ajax('/products/plaque.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalcPlaque,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });


        this.getTemplateData();
    }


    init() {

        this.type = 'nl'; // or plaque

        this.sets = {
            nl: [],
            plaque: []
        };

        window.has_rendered_once = false;

        this.maxLength = 100;
        this.maxFontSize = 100;
        this.textDefault = '123Abc';

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font != 'palmsprings') this.setFont(this.font);

        this.finish = this.getDefault('finish', 'brushed');
        if (this.finish != 'brushed') this.setFinish(this.finish);

        this.size = this.getDefault('size', '6');
        if (this.size != '6') this.setSize(this.size);

        this.orientation = this.getDefault('orientation', 'horizontal');
        if (this.orientation != 'horizontal') this.setOrientation(this.orientation);

        this.alignment = this.getDefault('alignment', 'center');
        if (this.alignment != 'center') this.setAlignment(this.alignment);

        /*
        this.shape = this.getDefault('shape', 'rect-5-16');
        this.setShape(this.shape);
        */

        this.text = this.getDefault('text', this.textDefault);
        this.setText(this.text);

        this.getProductData();

        this.recalc();

        this.reset_url();
    }

    switchPicker(type) {
        $('.emptysetwarning').addClass('hidden');
        this.type = type;
        window.has_rendered_once = false;
        if (this.type == 'nl') {
            this.setShape('rect-4-11');
            this.maxLength = 100;
        } else {
            this.setFont('palmsprings');
            this.setShape('rect-5-16');
        }
        $('.changewarning').addClass('hidden');
        $('.toolongnotice').hide();
    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin',
            'soho': 'SoHo',
            'backbay': 'Backbay',
            'southbeach': 'South Beach',
            'santabarbara': 'Santa Barbara'
        }
        return names[key];
    };

    getNiceFinishName(key) {
        var names = {
            'brushed': 'Brushed Aluminum',
            'black': 'Matte Black',
            'white': 'White',
            'brass': 'Matte Brass',
            'bronze': 'Dark Bronze'
        }
        return names[key];
    };

    addSet() {
        $('.emptysetwarning').addClass('hidden');
        $('.changewarning').addClass('hidden');
        this.sets[this.type].push(this.text.trim());
        this.redrawSets();
        this.recalc();
    }

    removeSet(index) {
        $('.emptysetwarning').addClass('hidden');
        $('.changewarning').addClass('hidden');
        this.sets[this.type].splice(index, 1);
        this.redrawSets();
        this.recalc();
    }

    redrawSets() {
        $('.sets-nl ').html('');
        var i = 0;
        if (this.type == 'nl') {
            $('.sets-nl').html('');
            $(this.sets['nl']).each(function (index, value) {
                $('.sets-nl').append('<span class="setitem" onclick="removeSetItem(\'' + (i++) + '\')">' + value + '</span>');
            });
        } else {
            $('.sets-plaque').html('');
            var i = 0;
            $(this.sets['plaque']).each(function (index, value) {
                $('.sets-plaque').append('<span class="setitem" onclick="removeSetItem(\'' + (i++) + '\')">' + value + '</span>');
            });
        }

    }

    /**
     * Given an alignment class, apply it to the preview box.
     * @param shape
     */
    setPreviewAlignment(alignment) {
        console.log('setting alignment!');
        var possiblealignments = ['right', 'center', 'top', 'bottom'];
        $(possiblealignments).each(function (index, value) {
            $('#previewwrapper.plaque .preview').removeClass(value);
        });
        $('#previewwrapper.plaque .preview').addClass(alignment);
        if (alignment == 'right')
            $('.previewwrapper.plaque').addClass('rightalignpad').removeClass('px-3');
        else
            $('.previewwrapper.plaque').removeClass('rightalignpad').addClass('px-3');
    }

    /**
     * Given a shape, make sure we reset the alignment to a valid setting.
     * @param shape
     */
    sanityCheckAlignment(shape) {
        if (shape.indexOf('circle') !== -1) {
            this.setAlignment('center');
        } else if (shape.indexOf('square') !== -1) {
            if (this.alignment == 'right') {
                this.setAlignment('center');
            }
        } else {
            // rectangle
            if (this.alignment == 'bottom') {
                this.setAlignment('center');
            }
        }
    }

    calculateNewHeight(wrappername, shape) {
        var newHeight = $(wrappername).height();
        var width = $(wrappername).outerWidth();
        if (shape == 'rect-3-8') {
            newHeight = 3 * width / 8;
        } else if (shape == 'rect-4-11') {
            newHeight = 4 * width / 11;
        } else if (shape == 'rect-5-16') {
            newHeight = 5 * width / 16;
        } else if (shape.indexOf('circle') !== -1) {
            newHeight = $(wrappername + ' .bigtext').width();
        } else if (shape.indexOf('square') !== -1) {
            newHeight = $(wrappername + ' .bigtext').width();
        }
        if (newHeight <= 0 ) newHeight = 45;
        return newHeight;
    }


    /**
     * Set the shape above the dimensions
     * @param selector
     * @param attr
     * @param value
     */
    setShapeGuide(shape) {
        var parts = shape.split('-');
        $('.shapeoutline').removeClass('active');
        $('.shapeoutline.' + parts[0]).addClass('active');

    }


    maskAlignments(shape) {
        $('.mobile-alignment-guide-picker option').attr('disabled', 'disabled');
        if (shape.indexOf('circle') !== -1) {
            // hide all alignments but center
            $('#alignment-picker li.right').hide();
            $('#alignment-picker li.bottom').hide();

            $('#alignment-picker li.center').show();
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);
        } else if (shape.indexOf('square') !== -1) {
            // only center and bottom
            $('#alignment-picker li.right').hide();
            $('#alignment-picker li.bottom').show();
            $('#alignment-picker li.center').show();
            $('.mobile-alignment-guide-picker option[value=bottom]').attr('disabled', false);
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);

        } else if (shape.indexOf('rec') !== -1) {
            // only right or center
            $('#alignment-picker li.bottom').hide();
            $('#alignment-picker li.right').show();
            $('#alignment-picker li.center').show();
            $('.mobile-alignment-guide-picker option[value=right]').attr('disabled', false);
            $('.mobile-alignment-guide-picker option[value=center]').attr('disabled', false);
        }
    }

    setNewMaxSize(shape) {
        var maxSizes = {
            'circle-5': 120,
            'circle-7': 140,
            'circle-10': 160,
            'square-8': 145,
            'rect-3-8': 105,
            'rect-4-11': 120,
            'rect-5-16': 120
        };
        this.maxFontSize = maxSizes[shape];
    }

    setNewMaxLength(shape) {
        var lengths = {
            'circle-5': 2,
            'circle-7': 4,
            'circle-10': 7,
            'square-8': 6,
            'rect-3-8': 4,
            'rect-4-11': 6,
            'rect-5-16': 8
        };
        this.maxLength = lengths[shape];
        if (undefined !== this.text) {
            this.setText(this.text.substr(0, lengths[shape]));
        }

    }


    /**
     * Given a shape class, apply it to the preview box.
     * @param shape
     */
    setPreviewShape(shape) {
        var possibleShapes = ['circle-5', 'circle-7', 'circle-10', 'rect-3-8', 'rect-4-11', 'rect-5-16', 'square-8'];
        $(possibleShapes).each(function (index, value) {
            $('.previewwrapper.plaque').removeClass(value);
        });
        $('.previewwrapper.plaque').addClass(shape);
        this.sanityCheckAlignment(shape);
        var alignment = this.alignment;
        var newDimension;
        $('.previewwrapper.plaque').addClass('px-3').removeClass('rightalignpad');
        if (shape == 'square-8') {
            newDimension = '200';
        } else if (shape == 'circle-5') {
            newDimension = '175';
        } else if (shape == 'circle-7') {
            newDimension = '200';
        } else if (shape == 'circle-10') {
            newDimension = '225';
        } else {
            // rectangles
            $('.previewwrapper.plaque').removeClass('px-3');
            console.log('align', alignment);
            if (alignment == 'right')  $('.previewwrapper.plaque').addClass('rightalignpad');
            newDimension = 'auto';
        }

        $('.previewwrapper.plaque').height(newDimension).width(newDimension);
        $('.previewwrapper.plaque .bigtext').height(newDimension).width(newDimension);

        if (newDimension == 'auto') {
            if ($('.previewwrapper.plaque').width() < 10) {
                $('.previewwrapper.plaque, .previewwrapper.plaque .bigtext').width('294.188');
            }
            var newHeight = this.calculateNewHeight('.previewwrapper.plaque', shape);
            $('.previewwrapper.plaque .bigtext').height(newHeight);
            $('.previewwrapper.plaque').height(newHeight);
            $('.previewwrapper.plaque').css('line-height', newHeight + "px");

        }
    }

    warnIfNeeded() {
        if (this.sets[this.type].length > 0) {
            $('.' + this.type + '.changewarning').removeClass('hidden');
        } else {
            $('.' + this.type + '.changewarning').addClass('hidden');
        }
    }

    setAlignment(alignment) {
        this.warnIfNeeded();
        this.alignment = alignment;
        this.setCookie('alignment', alignment, 7);

        // first the picker
        this.setPicker("#alignment-picker", 'alignment', alignment);

        this.setPreviewAlignment(alignment);


        this.recalc();
    }

    setShape(shape) {

        $('.toolongnotice').hide();
        $('.lengthnotice').hide();

        this.warnIfNeeded();
        this.shape = shape;
        this.setCookie('shape', shape, 7);

        // first the picker
        this.setPicker(".shape-picker", 'shape', shape);


        // set the shape above the dimensions
        this.setPreviewShape(shape);

        // set the shape in the preview
        this.setShapeGuide(shape);

        this.setNewMaxLength(shape);

        this.setNewMaxSize(shape);

        this.maskAlignments(shape);

        this.recalc();
    }


    setFont(font) {
        this.warnIfNeeded();
        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);

        // extra fancy stuff.
        if (font == 'socal') {
            $('.setbox').addClass('uppercase');
        } else {
            $('.setbox').removeClass('uppercase');
        }

        var kind = this.type;


        var height = $('#previewsection-' + kind).height();
        if (height == 0) height = 200;
        $('#previewsection-' + kind).css('height', height);
        // $('#previewsection').css('overflow', 'hidden');
        $('#previewsection-' + kind + ' .previewimagewrapper').hide();
        var slideshowSelector = '#previewsection-' + kind + ' .previewimagewrapper[data-font=\'' + font + '\']';

        $(slideshowSelector).fadeIn(250, function () {
            var flkty = new Flickity('#previewsection-' + kind);
            flkty.select(0, false, true);
            flkty.resize();
        });

        this.recalc();
    }

    setFinish(finish) {
        this.warnIfNeeded();
        this.finish = finish;
        this.setCookie('finish', finish, 7);

        // first the picker
        this.setPicker("#finish-picker", 'finish', finish);


        this.recalc();
    }

    setSize(size) {
        this.warnIfNeeded();
        var possibleSizes = [4, 6, 8, 12, 15];
        if (possibleSizes.indexOf(parseInt(size)) == -1) {
            size = 4;
        }
        this.size = size;
        this.setCookie('size', size, 7);

        // first the picker
        this.setPicker("#size-picker", 'size', size);


        this.recalc();
    }

    setOrientation(orientation) {
        this.warnIfNeeded();
        this.orientation = orientation;
        this.setCookie('orientation', orientation, 7);

        // first the picker
        this.setPicker("#orientation-picker", 'orientation', orientation);

        this.maybeSetBothPrice();

        this.recalc();
    }

    setPrices(singlePrice) {
        if (this.type == 'nl') {
            if (this.orientation === 'both') {
                $('.extraprice').html("Plus $" + this.getBothPrice() + " additional installation template.");
            } else {
                $('.extraprice').html("");
            }
            $('.itemQty').html(this.getTextLength());
            $('.singleUnitPrice').html(parseFloat(singlePrice).toFixed(2));
            $('.totalPrice').html(parseFloat(singlePrice * (this.getTextLength())).toFixed(2));
        } else {
            $('.itemQty').html(this.sets[this.type].length);
            $('.singleUnitPrice').html(parseFloat(singlePrice).toFixed(2));
            $('.totalPrice').html(parseFloat(singlePrice * this.sets[this.type].length).toFixed(2));
        }
    }

    setText(text, master) {
        window.has_rendered_once = false;
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault)  this.setCookie('text', text, 7);
        $('.preview_summary').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.recalc();
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }


    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    addToCart() {

        if (this.sets[this.type].length == 0) {
            $('.emptysetwarning').removeClass('hidden');
            return false;
        }
        $('.emptysetwarning').addClass('hidden');
        $('.changewarning').addClass('hidden');
        if (this.type == 'nl') {
            console.log("+", calc.template_data, this.size);
            var items = [];
            var fontName = this.getNiceFontName(this.font);
            var font = this.font;
            var size = this.size;
            var variation_id = this.variation_id;
            var orientation = this.orientation;
            $(this.sets[this.type]).each(function (index, value) {
                var textToAdd = (font == 'socal') ? value.toUpperCase() : value;

                if (orientation === 'both') {
                    items.push(
                        {
                            quantity: getTextLengthForSpecificString(value),
                            id: calc.template_data['size_' + size].id,
                            properties: {
                                'Typeface': fontName,
                                'House-numbers': textToAdd,
                            }
                        }
                    )
                }
                var item = {
                    quantity: getTextLengthForSpecificString(value),
                    id: variation_id,
                    properties: {
                        'Typeface': fontName,
                        'House-numbers': textToAdd,
                        'Orientation': orientation
                    }
                };
                items.push(item);
            });
            jQuery.post('/cart/add.js', {
                items: items
            }, function (response) {
                window.refreshCart();
                jQuery.post(
                    'https://dev.modernhousenumbers.com/api/log_shopify',
                    {
                        type: 'pro-nl-add-to-cart',
                        item: items,
                        response: response
                    }
                );
            }, 'json');
        } else {
            var textToAdd = (this.font == 'socal') ? this.text.toUpperCase() : this.text;
            var items = [];
            var fontName = this.getNiceFontName(this.font);
            var font = this.font;
            var shape = this.shape;
            var alignment = this.alignment;
            var variation_id = this.variation_id;
            $(this.sets[this.type]).each(function (index, value) {
                var textToAdd = (font == 'socal') ? value.toUpperCase() : value;
                var item = {
                    quantity: 1,
                    id: variation_id,
                    properties: {
                        'Typeface': fontName,
                        'House-numbers': textToAdd
                    }
                };
                if (shape.indexOf('square') !== false) {
                    item.properties['Alignment'] = alignment;
                } else if (shape.indexOf('rect') !== false) {
                    item.properties['Alignment'] = alignment;
                }
                items.push(item);
            });

            jQuery.post('/cart/add.js', {
                items: items
            }, function (response) {
                jQuery.post(
                    'https://dev.modernhousenumbers.com/api/log_shopify',
                    {
                        type: 'pro-plaque-add-to-cart',
                        item: item,
                        response: response
                    }
                );
                refreshCart();
            }, 'json');


        }
        this.sets[this.type] = [];
        this.redrawSets();
        this.recalc();

    }

    redraw() {
        currentfont = this.font;
        if (this.type == 'nl') {

            var previews = ['.picker .bigtext'];

            $(previews).each(function (index, selector) {
                $(selector).css('width', '100%');
                var height = $(selector).height(),
                    width = $(selector).width();


                if ((undefined != currentfont)) {

                    if (!$(selector).closest('.previewwrapper').hasClass(currentfont) || (!window.has_rendered_once)) {
                        window.has_rendered_once = true;
                        $(selector).css('opacity', 0);
                        var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
                        $(possibleFonts).each(function (index, value) {
                            $('.previewwrapper').removeClass(value);
                        });
                        $('.previewwrapper').addClass(currentfont);

                        $(selector).css('width', width + 'px').css('height', height + 'px');
                        window.setTimeout(function () {
                            BigText(selector + ' div', {
                                fontSizeFactor: 0.8,
                                maximumFontSize: 100,
                                limitingDimension: 'both',
                                horizontalAlign: 'center',
                                verticalAlign: 'center',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            });

                            adjustFontOffsetPlaque(selector, currentfont);
                            $(selector).css('opacity', 1);
                        }, 200);
                    }
                } else {
                    console.log('not defined!');
                }

            });
            window.has_rendered_once = true;
        } else {
            var selector = '.previewwrapper.plaque .bigtext';
            var currentfont = this.font;
            var currentalignment = this.alignment;
            var maxFontSize = this.maxFontSize;


            if ((undefined == currentalignment) || (undefined == currentfont)) return;

            var halign = 'center';
            var valign = 'center';

            if (currentalignment == 'bottom') {
                valign = 'bottom';
            }
            if (currentalignment == 'right') {
                halign = 'right';
            }

            $(selector).css('opacity', 0);

            var height = $(selector).height(),
                width = $(selector).width();

            $(selector).css('width', width + 'px').css('height', height + 'px');

            var options = {
                fontSizeFactor: 0.8,
                maximumFontSize: maxFontSize,
                limitingDimension: 'both',
                horizontalAlign: halign,
                verticalAlign: valign,
                textAlign: 'center',
                whiteSpace: 'nowrap'
            };
            // console.log(options);

            if (!$('.previewwrapper').hasClass(currentfont)) {
                    var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
                    $(possibleFonts).each(function (index, value) {
                        $('.previewwrapper').removeClass(value);
                    });
                    $('.previewwrapper').addClass(currentfont);
                }
            window.setTimeout(function () {
                BigText(selector + ' div', options);
                adjustFontOffset(selector, currentfont);

                $(selector).css('opacity', 1);
            }, 500);
        }
    }


    recalc() {
        $('.summary .font').html(this.getNiceFontName(this.font));
        $('.summary .finish').html(this.getNiceFinishName(this.finish));
        $('.summary .size').html(this.size + ' inches');
        $('.summary .orientation').html(this.orientation);
        if (undefined != this.text) {
            $('.summary .quantity').html(this.getTextLength());
        } else {
            $('.summary .quantity').html('');
        }
        if (this.type == 'nl') {
            if (undefined != calc.nl_product) {
                var currentFinish = this.finish;
                var currentSize = this.size;
                $(calc.nl_product.variants).each(function (index, value) {
                    var thisFinish = value.option2;
                    var thisSize = value.option1.replace('"','');
                    var thisVariationId = value.id;
                    var thisPrice = value.price / 100;
                    if ((thisFinish.indexOf(currentFinish) > -1) && (currentSize == thisSize)) {
                        window.calc.setVariationId(thisVariationId);
                        window.calc.setPrices(thisPrice);
                    }
                });

                this.maybeSetBothPrice();
            }
        } else {
            if (undefined != calc.plaque_product) {
                var currentFinish = this.finish;
                var currentShape = this.shape;
                var currentSku = currentShape + '-' + currentFinish;
                $(calc.plaque_product.variants).each(function (index, value) {
                    // console.log('variation', value);
                    var thisSku = value.sku;
                    var thisVariationId = value.id;
                    var thisPrice = value.price / 100;
                    if (currentSku == thisSku) {
                        // console.log('this variation id is', thisVariationId);
                        window.calc.setVariationId(thisVariationId);
                        window.calc.setPrices(thisPrice);
                    }
                });
            }
        }
        this.redraw();
    }



    getTextLength() {
        var totalChars = 0;
        // console.log('sets', this.sets);
        $(this.sets[this.type]).each(function (index, value) {
            totalChars = totalChars + getTextLengthForSpecificString(value)
        });
        return totalChars;
    }


    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        window.history.pushState('', '', baseurl[0]);
    }

}

class qscalculator {


    async getProductData() {
        calc.hashed_product_array = [];
        calc.inventory_array = [];
        calc.price_array = [];
        const response = await fetch("/products/quick-ship.js");
        const quickshipProducts = await response.json();

        const response2 = await fetch("/products/quickship-glyphs.js");
        const quickshipGlyphsProducts = await response2.json();

        $(quickshipProducts.variants).each(function (index, value) {

            //console.log(value);
            var id = value.id;
            var description = value.title;
            var finish = 'black';
            if (description.indexOf('brushed') !== -1) {
                finish = 'brushed';
            }
            var number = value.option3;
            // they want "4 inch" for the variant name because it's easier to track.
            var size = value.option2.replace(' inch', '');
            var key = finish + "_" + number + "_" + size;
            calc.hashed_product_array[key] = id;
            // for some reason the testing server doesn't show stock.
            calc.inventory_array[key] = value.inventory_quantity ?? 10;
            calc.price_array[key] = parseFloat(value.price / 100);

        });
        // Shopify products can only have 100 variants, so the new ones must be split into a new product.
        $(quickshipGlyphsProducts.variants).each(function (index, value) {

            var id = value.id;
            var description = value.title;
            var finish = 'black';
            if (description.indexOf('brushed') !== -1) {
                finish = 'brushed';
            }
            var number = calc.translation[value.option3] ?? value.option3;
            // they want "4 inch" for the variant name because it's easier to track.
            var size = value.option2.replace(' inch', '');
            var key = finish + "_" + number + "_" + size;
            calc.hashed_product_array[key] = id;
            // for some reason the testing server doesn't show stock.
            calc.inventory_array[key] = value.inventory_quantity ?? 10;
            calc.price_array[key] = parseFloat(value.price / 100);
            // also add to initial array of full objects.
            quickshipProducts.variants.push(value);
        });
        // for testing
        // calc.inventory_array['black_NO3_6'] = 0;

        calc.qs_product = quickshipProducts;
        //console.log(calc.hashed_product_array);
        //console.log(calc.inventory_array);
        calc.recalc();
    }

    init() {
        // new default copy.
        this.defaultText = 'Start selecting products.';
        // Get the finish -- either persisted or new
        this.finish = this.getDefault('finish', 'brushed');
        // make sure we're not still set to "brass" from some other page.
        this.finish = this.sanityCheckFinish(this.finish);
        this.setFinish(this.finish);

        // Get the size -- either persisted or new
        this.size = this.getDefault('size', '6');
        // make sure we're not still set to "12" from some other page.
        this.size = this.sanityCheckSize(this.size);
        this.setSize(this.size);

        this.numbers = this.getDefault('numbers', this.defaultText);

        calc.translation = {
            'Arrowhead': 'TRI',
            'Arrow': 'ARROW',
            '1/2 Symbol': 'HALF',
            'No - 1 piece': 'NO1',
            'No - 3 piece': 'NO3',
        }
        calc.nice_names = {
            'TRI': 'Arrowhead',
            'ARROW': 'Arrow',
            'HALF': '1/2 Symbol',
            'NO1': 'No - 1 piece',
            'NO3': 'No - 3 piece'
        }


        // if they haven't previously selected QS, but they have valid numbers from other pages, use them.
        // if they still have the default here from the old one, fix it.
        if (this.numbers == "Start selecting numbers.") {
            this.numbers = this.defaultText;
        }
        if (this.numbers == this.defaultText) {
            var text = this.getDefault('text', '');
            var thenum = text.replace(/\D/g, '');
            if (thenum != '') {
                this.numbers = thenum.split('').join(', ');
            }

        }
        this.setNumbers(this.numbers);

        this.getProductData();
        this.reset_url();
    }

    reset() {
        this.setNumbers(this.defaultText);
    }

    sanityCheckFinish(finish) {
        if (window.qs_black_out_of_stock) {
            return 'brushed';
        } else if ((finish != 'brushed') && (finish != 'black')) {
            return 'brushed';
        } else {
            return finish;
        }
    }

    sanityCheckSize(size) {
        if ((size == '12') || (size == '15')) {
            return '6';
        } else {
            return size;
        }
    }

    getNiceFinishName(key) {
        var names = {
            'brushed': 'Brushed Aluminum',
            'black': 'Matte Black'
        }
        return names[key];
    };

    addNum(num) {
        let nice_num = num;
        if (num.length > 1) {
            nice_num = calc.nice_names[num];
        }
        if (parseInt(calc.inventory_array[calc.finish + "_" + num + "_" + calc.size]) == 0) {
            jQuery('.stock-warning').text("Sorry, QuickShip number " + nice_num + " " + calc.finish + "  is currently out of stock. ");
            return false;
        }
        if (this.numbers == this.defaultText) {
            this.setNumbers(num);
        } else {
            var newNumbers = this.numbers = this.numbers + ', ' + num;
            this.setNumbers(newNumbers);
        }
    }

    /**
     * to prevent errors, the onclick is shared.
     * @param font
     */
    setFont(font) {
        return;
    }


    /**
     * to prevent errors, the onclick is shared.
     * @param size
     */
    setSize(size) {
        var possibleSizes = [4, 6, 8];
        if (possibleSizes.indexOf(parseInt(size)) == -1) {
            size = 6;
        }
        this.size = size;
        this.setCookie('size', size, 7);

        // first the picker
        this.setPicker("#size-picker", 'size', size);

        this.recalc();
    }

    setFinish(finish) {
        this.finish = finish;
        this.setCookie('finish', finish, 7);

        jQuery('.stock-warning').text('');

        // first the picker
        this.setPicker("#finish-picker", 'finish', finish);

        // extra fancy stuff.
        $('#previewsection .previewimagewrapper').hide();
        var slideshowSelector = '#previewsection .previewimagewrapper[data-finish=\'' + finish + '\']';
        $(slideshowSelector).fadeIn(250, function () {
            var flkty = new Flickity('#previewsection');
            flkty.select(0, false, true);
            flkty.resize();
        });

        this.recalc();
    }

    setNumbers(numbers, master) {
        this.numbers = numbers;
        this.setCookie('numbers', numbers, 7);

        let breakout = (numbers + '').replaceAll(' ', '').split(",");
        let displayNumbers = [];
        breakout.forEach(number => {
            // console.log("looking for ", number.trim(), 'in',calc.nice_names)
            displayNumbers.push(calc.nice_names[number.trim()] ?? number)
        })
        if (numbers === calc.defaultText) {
            $('.selectednumbers').html(calc.defaultText);
        } else {
            $('.selectednumbers').html(displayNumbers.join(', '));
        }

        this.recalc();
    }

    getCleanNumbers() {
        if (this.numbers == this.defaultText) {
            return [];
        } else {
            this.numbers = this.numbers + "";
            return this.numbers.split(', ');
        }
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }

    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    copy(o) {
        var output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key in o) {
            v = o[key];
            output[key] = (typeof v === "object") ? copy(v) : v;
        }
        return output;
    }

    /**
     * TODO fix!
     * return empty string if no numbers are out of stock.
     * @returns {string}
     */
    has_sufficient_qty() {
        var workingInventory = this.copy(calc.inventory_array);
        var response = '';
        var numbers = this.getCleanNumbers();
        var finish = this.finish;
        var size = this.size;
        var out_of_stock = [];
        //console.log(workingInventory);
        numbers.forEach(number => {

            let number_code = calc.translation[number] ?? number;
            var stock = workingInventory[finish + '_' + number_code + '_' + size];
            //console.log("Found ", stock, " for ", number_code, finish + '_' + number_code + '_' + size)
            // console.log('stock', stock);
            if (stock > 0) {
                workingInventory[finish + '_' + number_code + '_' + size]--;
            } else {
                out_of_stock.push(number);
            }
        })
        if (out_of_stock.length > 0) {
            var uniques = [];
            for (const value of out_of_stock) {
                if (!uniques.includes(value)) {
                    uniques.push(value);
                }
            }
            if (uniques.length > 1) {
                response += "Sorry, we don't have enough QuickShip items " + uniques.join(', ') + " " + calc.finish + " in " + calc.size + "\" to fulfill this entire order.  Please reduce the quantity. ";
            } else {
                response += "Sorry, we don't have enough of QuickShip items " + uniques[0] + " " + calc.finish + " in " + calc.size + " to fulfill this entire order. Please reduce the quantity. ";
            }
        }
        return response;
    }

    // https://shopify.dev/tutorials/develop-theme-getting-started-using-ajax-api
    addToCart() {
        var stock_warning = this.has_sufficient_qty();
        if (stock_warning != '') {
            window.alert(stock_warning);
        } else {
            // turns out, the naive approach of just sending the same ids with a qty of 1 doesn't work over 2.
            // we have to aggregate them to make it work.
            let itemsById = {};
            var numbers = this.getCleanNumbers();
            numbers.forEach(number => {
                number = calc.translation[number] ?? number;
                var thisId = calc.hashed_product_array[this.finish + '_' + number + '_' + this.size];
                if (thisId != false) {
                    if (itemsById.hasOwnProperty(thisId)) {
                        itemsById[thisId]++;
                    } else {
                        itemsById[thisId] = 1;
                    }
                }
            })
            var itemsToAdd = [];
            Object.keys(itemsById).forEach(key => itemsToAdd.push({
                id: key,
                quantity: itemsById[key]
            }));
            console.log("Total items being added", itemsToAdd);
            jQuery.post('/cart/add.js', {
                items: itemsToAdd
            }, function (response) {
                window.refreshCart();
                window.calc.reset();
            }, 'json');
        }
    }

    recalc() {
        var currentFinish = this.finish;
        var currentSize = this.size;
        if (undefined != calc.qs_product) {
            // First, iterate over numbers and disable/enable.
            $(calc.qs_product.variants).each(function (index, value) {
                var thisFullDescription = value.option1;
                var thisnumber = (calc.translation[value.option3] ?? value.option3);
                var thissize = value.option2.replace(' inch', '');
                let key = currentFinish + "_" + thisnumber + "_" + thissize;
                if (
                    (thisFullDescription.indexOf(currentFinish) !== -1)
                    &&
                    (parseInt(thissize) === parseInt(currentSize))
                ) {

                    if (parseInt(calc.inventory_array[key]) == 0) {
                        console.log("Disabling ", thisnumber, key)
                        calc.disableNumber(thisnumber);
                    } else {
                        calc.enableNumber(thisnumber);
                    }
                }
            });
        }
        let totalPrice = 0;
        let price_sets = {};
        let numbersArray = this.getCleanNumbers();
        if (undefined != calc.price_array) {
            numbersArray.forEach(thisNumber => {
                let key = currentFinish + "_" + thisNumber + "_" + currentSize;
                let thisPrice = calc.price_array[key];
                totalPrice += thisPrice;
                if (Object.hasOwn(price_sets, thisPrice)) {
                    price_sets[thisPrice]++;
                } else {
                    price_sets[thisPrice] = 1;
                }
            });
        }
        $('.totalPrice').html(parseFloat(totalPrice).toFixed(2));

        let nice_price_descriptions = [];
        Object.keys(price_sets).forEach(price => {
            nice_price_descriptions.push(price_sets[price] + " items @ $" + parseFloat(price).toFixed(2) + " each")
        })
        $('.price_descriptions').html(nice_price_descriptions.join(', '));
    }

    redraw() {
        // console.log("would redraw, if not quickship.");
    }

    enableNumber(num) {
        jQuery('.qsnumselect').each(function (index, value) {
            var boxNum = jQuery(this).data('which');
            // console.log("Comparing ", num, boxNum);
            if (num == boxNum) {
                jQuery(this).removeClass('disabled');
            }
        });
    }

    disableNumber(num) {
        jQuery('.qsnumselect').each(function (index, value) {
            var boxNum = jQuery(this).data('which');
            if (num == boxNum) {
                jQuery(this).addClass('disabled');
            }
        });
    }

    getTextLength() {
        var temp = this.getCleanNumbers().replace(/ /g, '');
        return temp.length;
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        // console.log('will set url',baseurl[0]);
        window.history.pushState('', '', baseurl[0]);
    }

}

class qs_upsell_calculator {

    updateStock(data, a, e) {
        window.hashed_product_array = [];
        window.inventory_array = [];
        $(data.variants).each(function (index, value) {
            var id = value.id;
            var description = value.title;
            var finish = 'black';
            if (description.indexOf('brushed') !== -1) {
                finish = 'brushed';
            }
            var number = value.option3;
            var size = value.option2; // something like "8 inch"
            size = size.replace(" inch", '');
            // console.log(value);
            let key = finish + "_" + number + "_" + size;
            window.hashed_product_array[key] = id;
            window.inventory_array[key] = value.inventory_quantity;
        });
        //console.log(window.hashed_product_array, window.inventory_array, '==');

        if (window.upsellcalc.has_sufficient_qty()) {
            jQuery('.qsupsell').removeClass('hidden');
        }
    }

    getProductData() {
        $.ajax('/products/quick-ship.js', {
            cache: false,
            dataType: 'json',
            success: this.updateStock,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });
    }

    init(numbers, finish, size) {
        if (finish === 'brushed aluminum') {
            finish = 'brushed';
        } else {
            finish = 'black';
        }
        numbers = numbers + "";
        numbers = numbers.replace(/ |,/gi, '');
        this.finish = finish;
        this.numbers = numbers;
        this.size = size.replace('"', '');
        this.getProductData();
    }


    copy(o) {
        var output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key in o) {
            v = o[key];
            output[key] = (typeof v === "object") ? copy(v) : v;
        }
        return output;
    }

    /**
     * return empty string if no numbers are out of stock.
     * @returns {string}
     */
    has_sufficient_qty() {
        var workingInventory = this.copy(window.inventory_array);
        //console.log(workingInventory);
        var numbers = this.numbers;
        var finish = this.finish;
        var size = this.size;
        var out_of_stock = [];
        if (numbers.length > 0) {
            for (var i = 0; i < numbers.length; i++) {
                var number = numbers.charAt(i);
                var key = finish + "_" + number + "_" + size;
                var stock = workingInventory[key];
                if (stock > 0) {
                    workingInventory[key]--;
                } else {
                    out_of_stock.push( number );
                }
            }
        }
        // console.log(out_of_stock, 'are out of stock');
        if (out_of_stock.length > 0 ) {
            return false;
        }
        return true;
    }


    // https://shopify.dev/tutorials/develop-theme-getting-started-using-ajax-api
    addToCart() {
        let itemsById = {};
        var numbers = this.numbers;
        if (numbers.length > 0) {
            for (var i = 0; i < numbers.length; i++) {
                var number = numbers.charAt(i);
                var key = this.finish + "_" + number + "_" + this.size;
                var thisId = window.hashed_product_array[key];
                if (thisId != false) {
                    if (itemsById.hasOwnProperty(thisId)) {
                        itemsById[thisId]++;
                    } else {
                        itemsById[thisId] = 1;
                    }
                }
            }
        }
        var itemsToAdd = [];
        Object.keys(itemsById).forEach( key =>  itemsToAdd.push({
            id: key,
            quantity: itemsById[key]
        }));
        var payload = {
            items: itemsToAdd
        };
        // console.log(payload);
        jQuery.post('/cart/add.js', payload, function (response) {
            window.refreshCart();
        }, 'json');
    }

    getTextLength() {
        var temp = this.getCleanNumbers().replace(/ /g, '');
        return temp.length;
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }


}

class readymadecalculator {

    saveAndCalc(data, a, e) {
        calc.variants = data.variants;
        calc.recalc();
    }

    async getContrastData() {
        calc.contrast_data = [];
        calc.contrast_inventory = [];
        const response = await fetch("/products/plaque-contrast-plate.js");
        const contrastProducts = await response.json();
        // console.log("HERE", contrastProducts);

        $(contrastProducts.variants).each(function (index, value) {
            // console.log(value);
            var id = value.id;
            var description = value.title;
            var size = value.option1.toLowerCase()
                .replaceAll(' ', '')
                .replaceAll('"', '')
                .replaceAll('rectangle', '')
                .replaceAll('square', '_square')
                .replaceAll('circle', '_circle')
                .replaceAll('diameter', '')
            ;
            var color = value.option2.toLowerCase();
            // they want "4 inch" for the variant name because it's easier to track.
            var key = size + "_" + color;
            calc.contrast_data[key] = id;
            calc.contrast_inventory[key] = value.inventory_quantity ?? 1;
        });
        console.log(calc.contrast_inventory);
    }

    getProductData() {

        $.ajax('/products/'+this.product_slug+'.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalc,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                // console.log('complete');
                //console.log(status);
            }
        });
    }

    async init( product_slug ) {

        await this.getContrastData();
        this.product_slug = product_slug;
        // new default copy.
        this.defaultText = 'Choose a sign and finish';
        this.prefix = (product_slug === 'welcome-signs') ? 'ws1' : 'rr1';
        // Get the finish -- either persisted or new
        this.finish = this.getDefault('finish', 'brushed');
        if (this.finish === 'brass') {
            this.finish = 'brushed';
        }
        this.contrast = this.getDefault('contrast', 'none');
        if (this.contrast !== 'none') this.setContrast(this.contrast);



        this.getProductData();


    }

    getNiceFinishName(key) {
        var names = {
            'brushed': 'Brushed Aluminum',
            'black': 'Matte Black'
        }
        return names[key];
    };

    get_product_for_prefix_and_finish( prefix, finish ) {
        return this.variants.find( variant => {
            let parts = variant.sku.split('-');
            let thisprefix = parts[0] ?? '';
            let thisfinish = parts[1] ?? '';
            return prefix === thisprefix && thisfinish === finish;
        });
    }

    select_item_by_prefix( prefix ) {
        if (this.variants === undefined) {
            return;
        }
        this.prefix = prefix;
        let currentProduct = this.get_product_for_prefix_and_finish(this.prefix, this.finish);
        //console.log("current product", currentProduct, 'contrast', this.contrast)
        if (currentProduct) {
            let title = currentProduct.title;
            let price = currentProduct.price / 100;
            this.product_id = currentProduct.id;
            let parts = title.split(" / ");
            $('.chosen_product_name').html("<div     class='font-bold'>" + (parts[0] ?? '') + "</div><div class='text-sm'>in " + (parts[1] ?? '')+"</div>");

            if (this.contrast !== 'none') {
                let ctrst_qty = this.get_contrast_qty(currentProduct.sku, this.contrast);
                //console.log("For current item qty is ", ctrst_qty);
                if (ctrst_qty > 0) {
                    price += 8;
                    this.hideContrastWarning();
                } else {
                    this.showContrastWarning();
                }
            } else {
                this.hideContrastWarning();
            }


            $('.totalPrice').html(parseFloat(price).toFixed(2));
            this.setSizeLabel(currentProduct.title);
        }

        $('.rmselect').removeClass('border-orange').addClass('border-grayLight')
        let item = $('.rmselect[data-prefix="'+prefix+'"]');
        item.removeClass('border-grayLight').addClass('border-orange')


    }

    setSizeLabel( product_title ) {
        let theSize = "Varies";
        if (product_title.includes('square')) {
            theSize = '6"x6" Square';
        } else if (product_title.includes('circle')) {
            if (product_title.includes('6')) {
                theSize = '6" circle';
            } else {
                theSize = '9" circle';
            }
        } else if (product_title.includes('figure')) {
            theSize = '4" tall figure';
        } else if (product_title.includes('11')) {
            theSize = '4"x11" rectangle';
        }
        $('.product_size').text(theSize);
    }

    setFinish(finish) {
        this.finish = finish;
        this.setCookie('finish', finish, 7);
        // first the picker
        this.setPicker("#finish-picker", 'finish', finish);
        this.recalc();
    }


    hideContrastWarning() {
        jQuery('.contrast_plate_warning').addClass("hidden");
    }

    showContrastWarning() {
        jQuery('.contrast_plate_warning').removeClass("hidden");
    }


    get_key_for_sku_and_contrast( sku, contrast ) {
        let parts = sku.split('-');
        let shape = parts[0];
        //console.log('shape is', shape)
        let mapping = {
            'ws1': '6_square',
            'ws2': '6_circle',
            'ws3': '4x11',
            'rr1': '6_square',
            'rr2': '6_square',
            'rr3': '6_square',
            'rr4': '6_square',
            'rr5': '6_square',
            'rr6': '6_square',
            'rr10': '9_circle',
            'rr11': '9_circle',
            'rr12': '9_circle',
        }
        //console.log("Shape is --> ", shape)
        //console.log(['rr7','rr8','rr9'].indexOf(sku), 'indexoif')
        if (['rr7','rr8','rr9'].indexOf(shape) !== -1) {
            //console.log("NO PLATE AVAILABLE.");
            return false;
        }
        return mapping[shape] + "_" + contrast;
    }


    get_contrast_qty( sku, contrast ) {
        //console.log("SKU is", sku, 'contrast is ', contrast);
        //console.log(calc.contrast_data);
        if (contrast === 'none') {
            return false;
        }
        let key = this.get_key_for_sku_and_contrast(sku, contrast);

        if (!key) {
            return 0;
        }
        //console.log('looking for key',key,' in ', calc.contrast_inventory)
        return calc.contrast_inventory[key];
    }


    setContrast(contrast) {
        this.contrast = contrast;
        this.setCookie('contrast', contrast, 7);

        // first the picker
        this.setPicker("#contrast-picker", 'contrast', contrast);

        this.recalc();
    }


    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }

    redraw() {
        return;
    }

    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed !== '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    copy(o) {
        var output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key in o) {
            v = o[key];
            output[key] = (typeof v === "object") ? copy(v) : v;
        }
        return output;
    }


    get_contrast_product(currentProduct, contrast) {
        // console.log("given", currentProduct, ' and ', contrast);
        // console.log(calc.contrast_data);
        // console.log(calc.contrast_inventory);
        let key = this.get_key_for_sku_and_contrast(currentProduct.sku, contrast);
        return calc.contrast_data[key];
    }

    // https://shopify.dev/tutorials/develop-theme-getting-started-using-ajax-api
    addToCart() {

        var itemsToAdd = [];
        itemsToAdd.push({
            id: this.product_id,
            quantity: 1
        });

        if (this.contrast !== 'none') {
            let currentProduct = this.get_product_for_prefix_and_finish(this.prefix, this.finish);
            //console.log(currentProduct);
            let product_id = this.get_contrast_product(currentProduct, this.contrast);
            let ctrst_qty = this.get_contrast_qty(currentProduct.sku, this.contrast);
            if ((product_id) && (ctrst_qty > 0)) {
                itemsToAdd.push({
                    quantity: 1,
                    id: product_id
                });
            }
        }

        // console.log("Total items being added", itemsToAdd);
        jQuery.post('/cart/add.js', {
            items: itemsToAdd
        }, function (response) {
            window.refreshCart();
        }, 'json');
    }

    recalc() {
        this.select_item_by_prefix( this.prefix );
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }


}

class stencilcalculator {

    saveAndCalc(data, a, e) {
        //console.log(data);
        calc.product = data;
        calc.recalc();
    }

    getProductData() {

        $.ajax('/products/curb-stencil.js', {
            cache: false,
            dataType: 'json',
            success: this.saveAndCalc,
            error: function (xhqr, status, error) {
                console.log('error');
                console.log(status);
            },
            complete: function (data, status) {
                //console.log('complete');
                //console.log(status);
            }
        });
    }


    init() {

        this.maxLength = 50;
        this.textDefault = '123Abc';

        window.has_rendered_once = false;

        window.user_has_modified_preview_text = false;

        this.font = this.getDefault('font', 'palmsprings');
        if (this.font != 'palmsprings') this.setFont(this.font);

        this.text = this.getDefault('text', this.textDefault);
        this.setText(this.text);

        if (this.text != this.textDefault) {
            window.user_has_modified_preview_text = true;
        }

        this.qty = this.getDefault('qty', '1');
        if (this.qty != '1') this.setQty(this.qty);

        this.recalc();

        this.getProductData();

        this.reset_url();
    }

    getNiceFontName(key) {
        var names = {
            'palmsprings': 'Palm Springs',
            'socal': 'SoCal',
            'austin': 'Austin',
            'soho': 'SoHo',
            'backbay': 'Backbay',
            'southbeach': 'South Beach',
            'santabarbara': 'Santa Barbara'
        }
        return names[key];
    };


    setFont(font) {
        this.font = font;
        this.setCookie('font', font, 7);

        // first the picker
        this.setPicker("#font-picker", 'font', font);

        // guide next
        this.bumpSlideshow('.main-carousel.fonts', font);
        this.setGuidePicker('font', font);

        this.recalc();
    }

    setPrices(singlePrice) {
        if (this.text != this.textDefault) {

            $('.itemQty').html(this.qty);
            var totalPerSet = parseFloat(singlePrice * (this.getTextLength()));
            $('.singleUnitPrice').html(parseFloat(totalPerSet).toFixed(2));
            $('.totalPrice').html((totalPerSet * this.qty).toFixed(2));
        }

        /*$('.singleUnitPrice').html(parseFloat(singlePrice).toFixed(2));
        $('.totalPrice').html(parseFloat(singlePrice * (this.text.length) * this.qty).toFixed(2));*/
    }

    setText(text, master) {
        window.has_rendered_once = false;
        this.text = text;
        // text = text.replace ( /[^\d]/g, '' );
        if (text != this.textDefault) this.setCookie('text', text, 7);
        $('.preview_summary').html(text);
        $('.summary .text').html(text);
        $('#summary-text').val(text);
        if (!master) {
            $('.preview').text(text);
        } else {
            $('.summary.preview').text(text);
        }
        this.recalc();
    }


    setQty(qty) {
        this.qty = qty;
        this.setCookie('qty', qty, 7);

        // first the picker
        this.setPicker("#qty-picker", 'qty', qty);

        // now the guide
        this.bumpSlideshow('.main-carousel.qty', 'qty' + qty);
        this.setGuidePicker('qty', qty);

        this.recalc();
    }

    /**
     * Set the picker picked indicator
     * @param selector
     * @param attr
     * @param value
     */
    setPicker(selector, attr, value) {
        var picker = $(selector + ' li[data-' + attr + '="' + value + '"]');
        var label = picker.data('label');
        $(selector + ' li').removeClass('active');
        picker.addClass('active');
        $('.chosen_' + attr).html(label);
    }

    setVariationId(id) {
        this.variation_id = id;
    }

    /**
     * Set the guide picker indicator
     * @param selector
     * @param attr
     * @param value
     */
    setGuidePicker(attr, value) {
        var selector = "#" + attr + "-guide-picker";
        $(selector + ' li ').removeClass('active');
        $(selector + ' li i').removeClass('fas').addClass('far');
        var chosen = $(selector + ' li[data-' + attr + '="' + value + '"]');
        chosen.addClass('active');
        chosen.find('i').removeClass('far').addClass('fas');
        $(selector + ' .desc').addClass('mhnhidden');
        chosen.find('.desc').removeClass('mhnhidden');

        // now adjust the menus. Note that we're checking current value so we don't trigger a change event when not necessary.
        var mobileDropDown = $('select[name="mobile-' + attr + '-guide-picker"]');
        if (mobileDropDown.val() != value) mobileDropDown.val(value);

        // NEW STYLE:
        var description = chosen.find(" .desc").text();
        $(".mobile-" + attr + "-description").text(description);

    }

    /**
     * Refresh slideshow so it works right
     * @param selector
     * @param attr
     */
    bumpSlideshow(selector, attr) {
        var slideshowSelector = selector + '.' + attr;
        if ($(slideshowSelector).length) {
            $(selector).addClass('hidden');
            $(slideshowSelector).removeClass('hidden');
            var flkty = new Flickity(slideshowSelector);
            flkty.resize();
        }
    }


    getDefault(name, fallback) {
        var passed = this.getParam(name);
        if ((passed != 'undefined') && (passed != '') && (passed != null)) {
            this.setCookie(name, passed, 7);
            //console.log("Setting " + name + " to " + passed + " from url.");
            return passed;
        }
        var saved = this.getCookie(name);
        if ((saved != null) && (saved != '')) {
            //console.log("Setting " + name + " to " + saved + " from cookie.");
            return saved;
        }
        // todo -- use set methods if NOT default
        return fallback;
    }

    addToCart() {

        if (!window.user_has_modified_preview_text) {
            window.alert("Please enter your own text by clicking on the \"" + this.textDefault + "\" preview text.");
            return false;
        }

        var textToAdd = (this.font == 'socal') ? this.text.toUpperCase() : this.text;
        var item = {
            quantity: this.qty * this.getTextLength(),
            id: this.variation_id,
            properties: {
                'Typeface': this.getNiceFontName(this.font),
                'House-numbers': textToAdd,
                'Mailbox-color': this.color
            }
        };
        jQuery.post('/cart/add.js', {
            items: [
                item
            ]
        }, function (response) {
            refreshCart();
            jQuery.post(
                'https://dev.modernhousenumbers.com/api/log_shopify',
                {
                    type: 'stencil-add-to-cart',
                    item: item,
                    response: response
                }
            );
        }, 'json');
    }


    redraw() {
        var previews = ['.picker  .bigtext', '.summary .bigtext'];
        var currentfont = this.font;
        $(previews).each(function (index, selector) {
            $(selector).css('width', '100%');
            var height = $(selector).height(),
                width = $(selector).width();
            $(selector).css('width', width + 'px').css('height', height + 'px');


            // extra fancy stuff.
            if (undefined != currentfont) {

                if (!$(selector).closest('.previewwrapper').hasClass(currentfont) || (window.has_rendered_once == false)) {
                    $(selector).css('opacity', 0);
                    var possibleFonts = ['palmsprings', 'socal', 'austin', 'soho', 'backbay', 'southbeach', 'santabarbara'];
                    $(possibleFonts).each(function (index, value) {
                        $('.previewwrapper').removeClass(value);
                    });
                    $('.previewwrapper').addClass(currentfont);

                    window.setTimeout(function () {
                        BigText(selector + ' div', {
                            fontSizeFactor: 0.8,
                            maximumFontSize: 100,
                            limitingDimension: 'both',
                            horizontalAlign: 'center',
                            verticalAlign: 'center',
                            textAlign: 'center',
                            whiteSpace: 'nowrap'
                        });
                        adjustFontOffset(selector, currentfont);
                        $(selector).css('opacity', 1);
                    }, 200);
                }
            }
        });

        window.has_rendered_once = true;
    }


    recalc() {
        $('.summary .font').html(this.getNiceFontName(this.font));
        $('.summary .qty').html(this.qty + " stencils");
        if (undefined != this.text) {
            $('.summary .quantity').html(this.getTextLength());
        } else {
            $('.summary .quantity').html('');
        }
        this.redraw();
        if (undefined != calc.product) {
            $(calc.product.variants).each(function (index, value) {
                // console.log('variation', value);
                var thisVariationId = value.id;
                var thisPrice = value.price / 100;
                window.calc.setVariationId(thisVariationId);
                window.calc.setPrices(thisPrice);
            });
        }
    }


    getTextLength() {
        return getTextLengthForSpecificString(this.text);
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = 'mhn_' + cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'mhn_' + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    getParam(name) {
        var url = new URL(document.location);
        var param = url.searchParams.get(name);
        return param;
    }

    reset_url() {
        var baseurl = window.location.href.split('?');
        // console.log('will set url',baseurl[0]);
        window.history.pushState('', '', baseurl[0]);
    }

}


var MHNGlobals = {
    'fonts' : {
        'palmsprings' : "Palm Springs"
    }
};

jQuery(document).ready(function ($) {

    if ((undefined !== typeof (currentpage)) && (currentpage == 'home')) {
        window.calc = new homecalculator();
        calc.init();

        // prepopulate the link to the other product pages.
        $('.quickstart').click(function (e) {
            var previewText = $('#preview').text();
            var font = $('#font-picker li span.active').closest('li').data('font');
            var baseurl = $(this).attr('href').split('?');
            var newurl = baseurl + '?' + 'text=' + previewText + '&' + 'font=' + font;
            $(this).attr('href', newurl);
        });

        $('.quickstartitemwrapper').mouseenter(function (e) {
            $('.quickstart').addClass('desaturate');
            $(this).find('.quickstart').removeClass('desaturate');
        });
        $('.quickstartitemwrapper').mouseleave(function (e) {
            $('.quickstart').removeClass('desaturate');
        });


        var focused = false;
        var focusHomePreview = debounce(function() {
            if (!focused) {
                var scrollTop = $(window).scrollTop(),
                    elementOffset = $('.home.pickerwrapper').offset().top,
                    distance = (elementOffset - scrollTop);
                if (distance < 175) {
                    $('#previewFocus').focus();
                    focused = true;
                }
            }
        }, 250);

        window.addEventListener('scroll', focusHomePreview);

        $('.home .preview').click(function () {
            if ($('#preview').text() == '123Abc') {
                $('#preview').text('');
            }
        });

        $('.home .preview').on('keypress', function (e) {
            if (e.which == 13) e.preventDefault(); // don't allow line breaks.
            var text = $(this).text();
            if (text == calc.textDefault) $('.preview').text('');
            if (text.length >= calc.maxLength) {
                $('.toolongnotice .content').text(calc.maxLength + " character limit.").show().fadeOut(2500);
                e.preventDefault();
            }
            return true;
        });

        $('.home .preview').on('keyup', function (e) {
            var text = $(this).text();
            calc.setText(text, true);
        });

        $('.home .preview').on('blur', function (e) {
            var text = $(this).text();
            if (text.length == 0) calc.setText(calc.textDefault, false);
        });

        // console.log(options);
        calc.redraw();

        var fixPreview = debounce(function() {
            window.calc.redraw();
        }, 500);

        window.addEventListener('resize', fixPreview);

    }
});


jQuery(document).ready(function ($) {


    // mobile navigation
    $('#show').click(function () {
        $('#header_menu').css('left', 0);
        $('#header_menu').css('opacity', 1);
        $('body').css('position', 'fixed');
    });

    // mobile navigation
    $('#hide').click(function () {
        resetMenus();
    });

    $('#header_menu a').click( function() {
       resetMenus();
    });

    window.hideMobileMenu = function() {
        $('#header_menu').css('left', '-120%');
        $('#header_menu').css('opacity', 0);
        $('body').css('position', 'relative');
    }

    /* RESOURCES DROP */
    $('#resources > a').click(function(e) {
        e.preventDefault();
        hideMainDrop();
        var trigger = $(this);
        var $icon = trigger.find('.fas');
        if ($icon.hasClass('fa-chevron-down')) {
            showResourcesDrop(trigger);
            $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
            trigger.addClass('text-orange');
        } else {
            resetMenus();
        }

    });

    function showResourcesDrop(trigger) {
        //var triggerleft = trigger.offset().left, headerleft = $('#header').offset().left;
        //$('#resourcesdrop .inner').css('margin-left', (triggerleft - headerleft - 40) + "px");
        $('#resourcesdrop').removeClass('opacity-0 visibility-hidden overflow-hidden h-0');
    }

    // when mouse out of the menu altogether.
    $('#resourcesdrop').mouseleave(function () {
        resetMenus();
    });

    function hideResourcesDrop() {
        var $resourcesmenuitem = $('#resources > a');
        var $icon = $resourcesmenuitem.find('.fas');
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down')
        $('#resourcesdrop').addClass('opacity-0 visibility-hidden overflow-hidden h-0');
    }

    /* ABOUT DROP */

    $('#about > a').click(function(e) {
        e.preventDefault();
        hideMainDrop();
        hideResourcesDrop();
        var trigger = $(this);
        var $icon = trigger.find('.fas');
        if ($icon.hasClass('fa-chevron-down')) {
            showAboutDrop(trigger);
            $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
            trigger.addClass('text-orange');
        } else {
            resetMenus();
        }

    });

    function showAboutDrop(trigger) {
        //var triggerleft = trigger.offset().left, headerleft = $('#header').offset().left;
        $('#aboutdrop').removeClass('opacity-0 visibility-hidden overflow-hidden h-0');
    }

    // when mouse out of the menu altogether.
    $('#aboutdrop').mouseleave(function () {
        resetMenus();
    });

    function hideAboutDrop() {
        var $aboutmenuitem = $('#about > a');
        var $icon = $aboutmenuitem.find('.fas');
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down')
        $('#aboutdrop').addClass('opacity-0 visibility-hidden overflow-hidden h-0');
    }


    /* SHOP DROP */


    // shop special mega dropdown for md+
    $('.shopmenuitem').click(function () {
        hideResourcesDrop();
        hideAboutDrop();
        var $shopmenuitem = $(".shopmenuitem");
        var $icon = $shopmenuitem.find('.fas');
        if ($icon.hasClass('fa-chevron-down')) {
            $('#drop').removeClass('opacity-0 visibility-hidden overflow-hidden h-0');
            $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up')
        } else {
            console.log('doing next thing');
            resetMenus();
        }
    });

    // when mouse out of the menu altogether.
    $('#drop').mouseleave(function () {
        hideMainDrop();
    });

    function hideMainDrop() {
        var $shopmenuitem = $(".shopmenuitem");
        var $icon = $shopmenuitem.find('.fas');
        $('#drop').addClass('opacity-0 visibility-hidden overflow-hidden');
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $('.dropmenulink').removeClass('desaturate');
    }

    $('.dropmenulink').on('mouseenter', function () {
        $('.dropmenulink').addClass('desaturate');
        $(this).removeClass('desaturate');
    });

    $('#drop').show();
    $('#resourcesdrop').show();
    $('#aboutdrop').show();


    function resetMenus() {
        hideResourcesDrop();
        hideAboutDrop();
        hideMainDrop();
        hideMobileMenu();
        $('#about > a, #resources > a').removeClass('text-orange');
    }

    var resetMenusOnResize = debounce(function() {
        resetMenus();
    }, 250);

    window.addEventListener('resize', resetMenusOnResize);

});


jQuery(document).ready(function ($) {


    if (undefined !== typeof currentpage) {
        if (currentpage === 'plaques') {
            window.calc = new plaquecalculator();
            calc.init();
        } else if (currentpage === 'nl') {
            window.calc = new nlcalculator();
            calc.init();
        } else if (currentpage === 'stencil') {
            window.calc = new stencilcalculator();
            calc.init();
        } else if (currentpage === 'quickship') {
            window.calc = new qscalculator();
            calc.init();
        } else if (currentpage === 'decal') {
            window.calc = new decalcalculator();
            calc.init();
        } else if (currentpage === 'pros') {
            window.calc = new proscalculator();
            calc.init();
        } else if (currentpage === 'welcome-signs') {
            window.calc = new readymadecalculator();
            calc.init('welcome-signs');
        } else if (currentpage === 'restroom-signs') {
            window.calc = new readymadecalculator();
            calc.init('restroom-signs');
        }
    }

    // RM specific
    $('.rmselect').click(function (e) {
        let prefix = $(this).data('prefix');
        calc.select_item_by_prefix(prefix);
    });

    // QS specific
    $('.qsnumselect').click(function (e) {
        var num = $(this).data('which');
        calc.addNum(num);
        var number = $(this);
        number.css('background-color', '#F36A10').css('color', '#FFFFFF');
        window.setTimeout( function() {
            number.css('background-color', '#F0F0F0').css('color', '#707070');
        }, 500, number);

    });

    $('.clearbut').click(function (e) {
        calc.reset();
    });

    /**
     * When using mobile pickers, get the next or previous option based on the available options, wrapping if needed.
     * @param currentValue
     * @param selector (options selector)
     * @param direction (next or previous)
     * @param dataslug (i.e. font, etc.)
     * @returns {*}
     */
    var getNextOption = function(currentValue, selector, direction, dataslug) {
        var choices = [];
        var newIndex;
        $(selector).each(function (index, value) {
            if (undefined != $(value).data(dataslug)) choices.push(String($(value).data(dataslug)));
        });
        var currentIndex = choices.indexOf(currentValue);
        var totalNumber = choices.length;
        if (direction == 'next') {
            newIndex = currentIndex + 1;
            if (newIndex > (totalNumber - 1)) newIndex = 0;
        } else {
            newIndex = currentIndex - 1;
            if (newIndex < 0) newIndex = totalNumber - 1;
        }
        return choices[newIndex];
    }


    // preview block
    $('#font-picker li').click(function () {
        var type = $(this).data('type');
        var font;
        // this is for the next/previous arrows.
        if (undefined != type) {
            font = getNextOption(calc.font, '#font-picker li', type, 'font');
        } else {
            font = $(this).data('font');
        }
        calc.setFont(font);
    });

    $('#color-picker li').click(function (e) {
        var type = $(this).data('type');
        var color;
        // this is for the next/previous arrows.
        if (undefined != type) {
            color = getNextOption(calc.color, '#color-picker li', type, 'color');
        } else {
            color = $(this).data('color');
        }
        calc.setColor(color);
    });


    $('#size-picker li').click(function (e) {
        var type = $(this).data('type');
        var size;
        // this is for the next/previous arrows.

        if (undefined != type) {
            size = getNextOption(calc.size, '#size-picker li', type, 'size');
        } else {
            size = $(this).data('size');
        }
        calc.setSize(size);
    });

    $('#qty-picker li').click(function (e) {
        var type = $(this).data('type');
        var qty;
        // this is for the next/previous arrows.
        if (undefined != type) {
            qty = getNextOption(calc.qty, '#qty-picker li', type, 'qty');
        } else {
            qty = $(this).data('qty');
        }
        calc.setQty(qty);
    });

    $('#orientation-picker li').click(function (e) {
        var type = $(this).data('type');
        var orientation;
        // this is for the next/previous arrows.
        if (undefined != type) {
            orientation = getNextOption(calc.orientation, '#orientation-picker li', type, 'orientation');
        } else {
            orientation = $(this).data('orientation');
        }
        calc.setOrientation(orientation);
    });

    $('#finish-picker li').click(function (e) {
        var type = $(this).data('type');
        var finish;
        // this is for the next/previous arrows.
        if (undefined != type) {
            finish = getNextOption(calc.finish, '#finish-picker li', type, 'finish');
        } else {
            finish = $(this).data('finish');
        }
        calc.setFinish(finish);
    });

    // For mobile menus and summary dropdowns
    $('.mobile-guide-picker').change(function () {
        var type = $(this).data('type');
        var value = $(this).val();
        if (type == 'font') {
            window.has_rendered_once = false;
            calc.setFont(value);
        } else if (type == 'qty') {
            calc.setQty(value);
        } else if (type == 'size') {
            calc.setSize(value);
        } else if (type == 'color') {
            calc.setColor(value);
        } else if (type == 'finish') {
            calc.setFinish(value);
        } else if (type == 'shape') {
            calc.setShape(value);
        } else if (type == 'alignment') {
            calc.setAlignment(value);
        } else if (type == 'orientation') {
            calc.setOrientation(value);
        } else if (type == 'contrast') {
            calc.setContrast(value);
        }
    });




    // NL Guide -- font picker section
    $('#font-guide-picker li').click(function () {
        var font = $(this).data('font');
        calc.setFont(font);
    });


    $('#orientation-guide-picker li').click(function (e) {
        var orientation = $(this).data('orientation');
        calc.setOrientation(orientation);
    });


    // Note class not id because multiples
    $('.shape-picker li').click(function (e) {
        var shape = $(this).data('shape');
        calc.setShape(shape);
    });

    // on mobile devices, shape changing off screen was scrolling this section.
    $('.step-shape .shape-picker li').click(function (e) {
        $('html, body').stop().animate({
            'scrollTop':  $('.step-shape').offset().top
        }, 5, 'linear');
    });

    $('#alignment-picker li').click(function (e) {
        var alignment = $(this).data('alignment');
        calc.setAlignment(alignment);
    });


    $('#contrast-picker li').click(function (e) {

        var contrast = $(this).data('contrast');
        // console.log("contrast is ", contrast);
        calc.setContrast(contrast);
    });

    // NL Guide -- size picker section
    $('#size-guide-picker li').click(function () {
        var size = $(this).data('size');
        calc.setSize(size);
    });
    // NL Guide -- finish picker section
    $('#finish-guide-picker li').click(function () {
        var finish = $(this).data('finish');
        calc.setFinish(finish);
    });


    // Plaque Guide -- finish picker section
    $('#contrast-guide-picker li').click(function () {
        var contrast = $(this).data('contrast');
        calc.setContrast(contrast);
    });

    // NL Guide -- shape picker section
    $('#shape-guide-picker li').click(function () {
        var shape = $(this).data('shape');
        calc.setShape(shape);
    });

    // NL Guide -- alignment picker section
    $('#alignment-guide-picker li').click(function () {
        var alignment = $(this).data('alignment');
        calc.setAlignment(alignment);
    });

    // NL Guide -- color picker section
    $('#color-guide-picker li').click(function () {
        var color = $(this).data('color');
        calc.setColor(color);
    });

    // NL Guide -- color picker section
    $('#qty-guide-picker li').click(function () {
        var qty = $(this).data('qty');
        calc.setQty(qty);
    });

    $('.add-to-cart').click(function (e) {
        calc.addToCart();
    });

    function focusOnPreviewText() {
        const previewblock = document.getElementById('previewFocus');
        if (null != previewblock) {
            previewblock.focus({
                preventScroll: true
            });
        }
    }

    if (undefined !== typeof currentpage) {
        if ((currentpage !== 'home') && (currentpage !== 'pros')) {
            focusOnPreviewText();
        }
    }

    $('.bigtext').on('click', function (e) {
        e.preventDefault();
        var editableArea = $(this).find('.preview');
        editableArea.focus();
        setTimeout(function(){ editableArea.selectionStart = editableArea.selectionEnd = 10000; }, 10);

    });

    $('.picker .preview').on('click', function (e) {
        window.user_has_modified_preview_text = true;
        if (calc.text == calc.textDefault) {
            $('.preview').text('');
        }
    });

    $('.preview').on('keydown', function (e) {
        //console.log(e.keyCode);
        if (e.which == 13) {
            e.preventDefault();
            if ((undefined !== typeof currentpage) && (currentpage == 'pros')) {
                calc.addSet();
            }
        }
        // don't allow line breaks.
        var text = $(this).text();

        if ((e.which == 8) || (e.which == 46)) {
            //console.log('delete key pressed');
            $('.toolongnotice').hide();
            $('.lengthnotice').hide();
            $('.preview').css('opacity', 1);
        } else if (text.length >= calc.maxLength) {
            $('.toolongnotice .content').text(calc.maxLength + " character limit.");
            $('.toolongnotice').show();
            $('.lengthnotice span').text(calc.maxLength + " character limit.");
            $('.lengthnotice').show();
            e.preventDefault();
        } else {
            //console.log('opacity in');
            $('.toolongnotice').hide();
        }
        return true;
    });

    $('.toolongnotice').click( function(e) {
       e.preventDefault();
       $(this).hide();
    });

    $('.preview').on('keyup', function (e) {
        var text = $(this).text();
        window.has_rendered_once = false;
        calc.setText(text, true);
        //console.log('opacity in');
        $('.preview').css('opacity', '1');
    });

    $('.preview').on('blur', function (e) {
        var text = $(this).text();
        if (text.length == 0) calc.setText(calc.textDefault, false);
    });

    /* this is only for the summary section for plaques */
    $('#summary-text').on('keydown', function (e) {
        if (e.which == 13) e.preventDefault(); // don't allow line breaks.
        var text = $(this).val();
        if ((e.which == 8) || (e.which == 46)) {
            $('.lengthnotice').hide();
        } else if (text.length >= calc.maxLength) {
            $('.lengthnotice span').text(calc.maxLength + " character limit.");
            $('.lengthnotice').show();
            e.preventDefault();
        } else {
            //console.log('opacity in');
            $('.lengthnotice').hide();
        }
        return true;
    });


// ADVANCERS
    $('.advance-to-summary').click(function (e) {
        e.preventDefault();
        $('.step .header').removeClass('bg-graySelected');
        if ( $('.step-summary').hasClass('active')) {
            $('.step-summary .payload').addClass('hidden');
            $('.step-summary').removeClass('active')
        } else {
            $(".summary.previewwrapper").css('height', '220px');
            $('.summary .bigtext').css('opacity', 0).css('height', '160px'); // to ensure no crazy-render on open
            $('.step .payload').addClass('hidden');
            var $targetEle = $('.step-summary');
            $('.step-summary .payload').removeClass('hidden');
            $('.step-summary').addClass('active');
            $('html, body').stop().animate({
                'scrollTop': $targetEle.offset().top
            }, 800, 'swing', function () {
                window.has_rendered_once = false;
                if (typeof calc.setShape === "function") {
                    calc.setShape(calc.shape);
                }
                window.calc.redraw();

            });
        }
    });

// home page
    $('.advance-to-picker').click(function (e) {
        e.preventDefault();
        var $targetEle = $('#home-picker');
        $('html, body').stop().animate({
            'scrollTop': $targetEle.offset().top
        }, 800, 'swing');
    });

    $('.advance-to-text').click(function (e) {
        e.preventDefault();
        $('.step .header').removeClass('bg-graySelected').addClass('bg-grayLight');
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 800, 'swing');
    });

    $('.advance-to-font').click(function (e) {
        e.preventDefault();
        goToSection('.step-font', '.fonts', calc.font);
    });

    $('.advance-to-size').click(function (e) {
        e.preventDefault();
        goToSection('.step-size', '.size', 'size' + calc.size);
    });

    $('.advance-to-alignment').click(function (e) {
        e.preventDefault();
        goToSection('.step-alignment', '.alignment', calc.alignment);
    });


    $('.advance-to-color').click(function (e) {
        e.preventDefault();
        goToSection('.step-color', '.color', calc.color);
    });


    $('.advance-to-shape').click(function (e) {
        e.preventDefault();
        goToSection('.step-shape', '.shape', calc.shape);
    });

    $('.advance-to-qty').click(function (e) {
        e.preventDefault();
        goToSection('.step-qty', '.qty', 'qty' + calc.qty);
    });

    $('.advance-to-finish').click(function (e) {
        e.preventDefault();
        goToSection('.step-finish', '.finish', calc.finish);
    });


    $('.advance-to-contrast').click(function (e) {
        e.preventDefault();
        goToSection('.step-contrast', '.contrast', calc.contrast);
    });

    $('.advance-to-how-it-works').click(function (e) {
        e.preventDefault();
        goToSection('.step-how-it-works', '.how-it-works', 'first');
    });


    $('.advance-to-orientation').click(function (e) {
        e.preventDefault();
        goToSection('.step-orientation', '.orientation', calc.orientation);
    });

    $('.proswitcher li ').click(function (e) {
        calc.switchPicker($(this).data('type'));
    });


    $('.add-to-sets').click(function (e) {
        e.preventDefault();

        calc.addSet();

    });

    window.removeSetItem = function (index) {
        calc.removeSet(index);
    }

    // https://shopify.dev/docs/themes/product-merchandising/gift-cards
    // Comments.
    $('.gift-add-to-cart').click(function (e) {
        e.preventDefault();
        var variation_id = $('input[name=variant_id]:checked').val();
        var has_recipient = $('#has_recipient').is(":checked");
        var recipient_name = $('#recipient_name').val();
        var recipient_email = $('#recipient_email').val();
        var send_on = $('#send_on').val();
        var message = $('#message').val();
        if (has_recipient) {
            var item = {
                quantity: 1,
                id: variation_id,
                properties: {
                    'Recipient email': recipient_email,
                    'Recipient name': recipient_name,
                    'Message': message,
                    'Send on': send_on,
                    '__shopify_send_gift_card_to_recipient': true
                }
            };
        } else {
            var item = {
                quantity: 1,
                id: variation_id
            };
        }
        //console.log("Preparing to post", item);
        jQuery.post('/cart/add.js', {
            items: [
                item
            ]
        }, function (response) {
            //console.log("Hiding error");
            $('.error_message').addClass('hidden');
            refreshCart();
        }, 'json').fail(function(response) {
            //console.log("Showing error");
            $('.error_message').removeClass('hidden');
        })
    });

    function goToSection(stepClass, innerclass, value) {

        $('.step-summary').removeClass('active');
        $('.step-summary .payload').addClass('hidden');
        if ($(stepClass + ' .header').hasClass('bg-graySelected')) {
            $('.step .header').removeClass('bg-graySelected');
            $('.step .payload').addClass('hidden');
        } else {
            $('.step .header').removeClass('bg-graySelected').addClass('bg-grayLight');
            $(stepClass + ' .header').addClass('bg-graySelected');
            show_guide_section(stepClass, innerclass, value);
        }
    }

    function show_guide_section(wrapperClass, innerclass, selectedvalue) {
        $('.step .payload').addClass('hidden');
        $(wrapperClass + ' .payload').removeClass('hidden');
        var $targetEle = $(wrapperClass);
        if ($(('.main-carousel' + innerclass)).length) {
            var flkty = new Flickity('.main-carousel' + innerclass);
            flkty.resize();
        }
        $('html, body').stop().animate({
            'scrollTop': $targetEle.offset().top
        }, 800, 'swing', function () {
            if ($(('.main-carousel' + innerclass)).length) {
                var flkty = new Flickity('.main-carousel' + innerclass + '.' + selectedvalue);
                flkty.resize();
            }
        });
    }


    var fixPreview = debounce(function() {
        if ((window.calc) && (undefined !== typeof window.calc)) {
            window.calc.redraw();
        }
    }, 500);

    window.addEventListener('resize', fixPreview);

    if (undefined !== typeof window.calc) {
        fixPreview();
    }

    let hash = window.location.hash;
    if (hash !== '') {
      let target = hash.replace('#', '');
      switch (target) {
        case "font":
          goToSection('.step-font', '.fonts', calc.font);
          break;
        case "size":
          goToSection('.step-size', '.size', 'size' + calc.size);
          break;
        case "alignment":
          goToSection('.step-alignment', '.alignment', calc.alignment);
          break;
        case "color":
          goToSection('.step-color', '.color', calc.color);
          break;
        case "shape":
          goToSection('.step-shape', '.shape', calc.shape);
          break;
        case "qty":
          goToSection('.step-qty', '.qty', 'qty' + calc.qty);
          break;
        case "finish":
          goToSection('.step-finish', '.finish', calc.finish);
          break;
        case "contrast":
          goToSection('.step-contrast', '.contrast', calc.contrast);
          break;
        case "orientation":
          goToSection('.step-orientation', '.orientation', calc.orientation);
          break;
        case "how-it-works":
          goToSection('.step-how-it-works', '.how-it-works', 'first');
          break;
      }
    }

});

jQuery(document).ready(function ($) {

    $('table.summary a.edit').click(function (e) {
        e.preventDefault();
        reset();
        var wrapper_row = $(this).closest('tr');
        wrapper_row.find('.displayvalue').addClass('hidden');
        wrapper_row.find('.inputfield').removeClass('hidden');
        wrapper_row.find('.save').removeClass('hidden');
        wrapper_row.find('.edit').addClass('hidden');
       $('.add-to-cart').attr('disabled', 'disabled');
       $('.saveNotice').show();
    });

    function reset() {
        $('.saveNotice').hide();
        $('.displayvalue').removeClass('hidden');
        $('.save').addClass('hidden');
        $('.inputfield').addClass('hidden');;
        $('.edit').removeClass('hidden');
        $('.add-to-cart').removeAttr('disabled');
    }

    $('table.summary a.save').click(function (e) {
        e.preventDefault();
        reset();
        var wrapper_row = $(this).closest('tr');
        var value = wrapper_row.find('.inputfield select').val();
        var type = $(this).data('type');
        if (type == 'font') {
            window.has_rendered_once = false;
            calc.setFont(value);
        } else if (type == 'qty') {
            calc.setQty(value);
        } else if (type == 'orientation') {
            calc.setOrientation(value);
        } else if (type == 'shape') {
            calc.setShape(value);
        } else if (type == 'alignment') {
            calc.setAlignment(value);
        } else if (type == 'size') {
            calc.setSize(value);
        } else if (type == 'finish') {
            calc.setFinish(value);
        } else if (type == 'color') {
            calc.setColor(value);
        } else if (type == 'text') {
            window.has_rendered_once = false;
            value = $('#summary-text').val();
            calc.setText(value);
        }

    });

});

document.fonts.ready.then(function () {
    // console.log("hi, the fonts just loaded.")
});

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};



var getTextLengthForSpecificString = function( value ) {
    // console.log('got', value);
    var temp = value.split('').filter(function (currentValue, index, arr) {
        var code = arr[index].charCodeAt(0);
        return ((code != 32) && (code != 160));
    });
    // console.log('returning', temp.length);
    return temp.length;
}


function adjustFontOffset(selector, currentfont) {
    var platformDetail = window.navigator.userAgent;
    var isWindows = false;
    if (platformDetail.indexOf('Windows') != -1) {
        isWindows = true;
    }
    //if (isWindows) console.log('Look like Windows OS.');
    var fontsize = parseInt($(selector + ' div').css('font-size').replace('px', ''));
    var factor = 0;
    if (currentfont == 'palmsprings') {
        factor = .18;
        if (isWindows) factor = .08;
    } else if (currentfont == 'soho') {
        factor = .12;
        if (isWindows) factor = 0;
    } else if (currentfont == 'austin') {
        factor = .06;
    } else if (currentfont == 'backbay') {
        factor = .12;
        if (isWindows) factor = .04;
    } else if (currentfont == 'socal') {
        factor = .03;
    }
    var adjust = fontsize * factor;
    //console.log('font:' + currentfont, ' factor ', factor, 'fontsize', fontsize, 'adjust', adjust);
    if (undefined !== currentfont) {
        jQuery(selector).closest('.offsetwrapper').css('margin-top', adjust + 'px');
        jQuery(selector).closest('.offsetwrapper').css('margin-bottom', '-' + adjust + 'px');
    }
}

function adjustFontOffsetPlaque(selector, currentfont) {
    var shape = window.calc.shape;
    var alignment = window.calc.alignment;
    var numchars = window.calc.getTextLength();
    var platformDetail = window.navigator.userAgent;
    var isWindows = false;
    if (platformDetail.indexOf('Windows') != -1) {
        isWindows = true;
    }
    //if (isWindows) console.log('Look like Windows OS.');
    var fontsize = parseInt($(selector + ' div').css('font-size').replace('px', ''));
    var factor = 0;


    if ((shape == 'square-8') && (alignment == 'bottom')) {
        if (currentfont == 'palmsprings') {
            if (numchars == 6) {
                factor = (isWindows) ? .2 : .27;
            } else if (numchars == 5) {
                factor = (isWindows) ? .25 : .25;
            } else if (numchars == 4) {
                factor = (isWindows) ? .25 : .26;
            } else {
                factor = (isWindows) ? .08 : .15;
            }
        } else if (currentfont == 'socal') {
            if (numchars == 6) {
                factor = (isWindows) ? -.18 : -.14;
            } else if (numchars == 5) {
                factor = (isWindows) ? .05 : -.10;
            }
        } else if (currentfont == 'austin') {
            if (numchars == 6) {
                factor = (isWindows) ? .02 : .08;
            } else if (numchars == 5) {
                factor = (isWindows) ? .05 : .05;
            } else if (numchars == 4) {
                factor = (isWindows) ? .03 : .0;
            }
        }
    } else {
        if (currentfont == 'palmsprings') {
            factor = (isWindows) ? .11 : .19;
            // factor = (isWindows) ? .10 : .18;
        } else if (currentfont == 'soho') {
            factor = (isWindows) ? 0 : .12;
        } else if (currentfont == 'austin') {
            factor = .04;
        } else if (currentfont == 'backbay') {
            factor = (isWindows) ? .04 : .12;
        } else if (currentfont == 'socal') {
            factor = .03;
        }
    }
    var adjust = fontsize * factor;
    // console.log('selector:', selector, 'font:' + currentfont, 'factor:', factor, 'fontsize:', fontsize, 'adjust:', adjust, "shape:", shape, "numchars:", numchars);
    if (undefined !== currentfont) {
        // console.log("Actually doing it to ", selector);
        jQuery(selector).closest('.offsetwrapper').css('margin-bottom', '-' + adjust + 'px');
        jQuery(selector).closest('.offsetwrapper').css('margin-top', adjust + 'px');
    }
}


jQuery(document).ready(function ($) {


  $(".open_write_modal").click( function(e) {
    let url = $(this).attr('href');
    e.preventDefault();
    if ($(window).width() > 768) {
      handle = window.open(url, '_blank', 'popup,width=475,menubar=no,status=no,titlebar=no,toolbar=no')
      if (!handle) {
        //window.open(url, '_blank')
      }
    } else {
      window.open(url, '_blank')
    }

  })
  
    ScrollOut({
        threshold: .6
    });

    /* Optional Javascript to close the accordion radio button version by clicking it again */
    var myRadios = document.getElementsByName('accordiontabs');
    var setCheck;
    var x = 0;
    for (x = 0; x < myRadios.length; x++) {
        myRadios[x].onclick = function () {
            if (setCheck != this) {
                setCheck = this;
            } else {
                this.checked = false;
                setCheck = null;
            }
        };
    }

    $('.accordions.installation label, .accordions.faqs label, .accordions.infosection label').click(function (e) {
        var tabtarget = $(this).closest('.tab');
        window.setTimeout(function () {
            $('html, body').stop().animate({
                'scrollTop': (tabtarget.offset().top - 10) + 'px'
            }, 800, 'swing');
        }, 100);

    });

    // open tabs WITHIN the page
    $('.tab-content .shopifycontent a.internal').click(function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        $('#' + target).closest('.tab').find('label').click();
    });

    if (window.location.hash) {
        // Fragment exists
        var target = window.location.hash;
        if ((undefined != target) && (target.length)) {
            if ($(target).length) {
                scroll(0, 0);
                $(target).next('.tab').find('input').prop('checked', 'checked');
                $('html, body').stop().animate({
                    'scrollTop': ($(target).offset().top + 30) + 'px'
                }, 800, 'swing');
            }
        }
    }


    $('.smoothscroll').click(function (e) {
        var target = $(this).attr('href');
        if (target.charAt(0) == '#') {
            e.preventDefault();
            $('html, body').stop().animate({
                'scrollTop': ($(target).offset().top + 30) + "px"
            }, 800, 'swing');
        }
    });

    $('.tabs li').click(function (e) {
        e.preventDefault();
        $('.tabs li').removeClass('active');
        $(this).addClass('active');
        var thisSection = $(this).find('a').attr('href');
        $('.tabsection').addClass('hidden');
        $(thisSection).removeClass('hidden');
        // now, there might be a flickety gallery in there.
        if ($(thisSection + ' #previewsection').length) {
            var flkty = new Flickity(thisSection + ' #previewsection');
            flkty.resize();
        }
    });

    $('a.opentab').click(function (e) {
        var id = $(this).attr('href');
        $(id).next('.tab').find('input').prop('checked', 'checked');
        $('html, body').stop().animate({
            'scrollTop': $(id).offset().top + "px"
        }, 800, 'swing');
    });

    $('.slideshowlink').click(function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var title = $(this).attr('title');

        $.colorbox({
            href: url + '&embedded=true',
            iframe: true,
            width: '90%',
            maxWidth: 960,
            height: 600
        });

        // window.open(url, title, 'width=1100,height=700');
    });

    $('.pickergallery').css('overflow-y', 'visible').css('overflow-x', 'visible');

});

/** Flickity breaks accessiblity by adding aria hidden **/
class FlickPatch {  //  Flick Carousel ARIA-HIDDEN observer
    constructor(_d, _sQ) {
        this._d = _d; this._sQ = _sQ;
        this.aF = []; this.aObs = [];
    }
    init() {  //
        this.aF = Array.from( this._d.querySelectorAll( this._sQ ))
        if( this.aF.length ){
            this.aObs = []
            this.aF.forEach( ( eF )=>{
                const oObs = new MutationObserver( flickPatch.removeAttr );
                oObs.observe( eF, { attributes: true, childList: true, subtree: true } );
                this.aObs.push( oObs )
            })
        }
        return this;
    }
    removeAttr( aObs ){  //
        if( aObs.length ){
            aObs.forEach( ( elO )=>{
                if( elO?.target ){
                    [ ... elO.target.querySelectorAll( "[aria-hidden='true']" )].forEach( ( eH )=>{
                        eH.removeAttribute("aria-hidden")
                    })
                }
            })
        }
    }
}
//. Usage
let flickPatch = {}
document.addEventListener("DOMContentLoaded", ( ev )=>{
    setTimeout( ()=>{
        flickPatch = new FlickPatch( document, ".flickity-slider" )
        flickPatch.init()
    }, 8e3 )
})
